<template>
  <div class="ship_with_us" style="display: none">
        <img src="../assets/box-by-door.jpg" alt="Truck">
        <div class="ship_with_us_layout">
            <h1>If your business is driving <br> we have a route for you.</h1>
            <p>Putting women behind the wheel.</p>
             <a @click="()=> DriveWithUsTogglePopup('DriveWithUsButtonTrigger')" style="text-decoration: none;"><button>Drive with us</button></a> 
        </div>
    </div>
    <div class="header-container">
        <h1>Our Solutions</h1>
    </div>
    
    <div class="card-container">
        <div class="card-container-inner">
            <div class="card-one" id="card-one">
                <div class="text-container-front">
                    <div class="shape-container">
                        <div class="shape-one">
                        <h2>Supported Service Levels</h2>
                        </div>
                    </div>
                    <div class="text-container">
                        <div class="text-container-inner">
                        <div class="text-container-shipping-options">

                            <div class="text-container-svg">
                                <svg version="1.1" id="Layer_2_00000017498551833638599530000000546862870078238139_"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 244 164"
                                        style="enable-background:new 0 0 244 164;" xml:space="preserve">
                                    <g id="_Ñëîé_1">
                                        <g>
                                            <g>
                                                <path class="st0" d="M4,110v16c0,5.5,4.5,10,10,10h30"/>
                                                <path class="st0" d="M92,136h50c5.5,0,10-4.5,10-10V14c0-5.5-4.5-10-10-10H23"/>
                                                <path class="st0" d="M27,4H14C8.5,4,4,8.5,4,14v100"/>
                                                <circle class="st0" cx="68" cy="136" r="24"/>
                                                <circle class="st0" cx="196" cy="136" r="24"/>
                                                <line class="st0" x1="128" y1="136" x2="172" y2="136"/>
                                                <path class="st0" d="M220,136h10c5.5,0,10-4.5,10-10V87.9c0-2.5-0.9-4.9-2.6-6.8L199,39.2c-1.9-2.1-4.6-3.2-7.4-3.2H152"/>
                                                <path class="st0" d="M240,84h-50c-5.5,0-10-4.5-10-10V48"/>
                                            </g>
                                        </g>
                                    </g>
                                    <image style="overflow:visible;" width="507" height="492" xlink:href="../assets/lrexDino-transparent.png"  transform="matrix(9.068223e-02 0 0 9.068223e-02 10.352 11.3701)">
                                    </image>
                                </svg>
                            </div>

                            <div class="text-container-text">
                                <p>Next Day</p>
                            </div>

                        </div>
                        <div class="text-container-shipping-options">

                            <div class="text-container-svg">
                                    <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264.36 164">
                                    <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                        <g>
                                        <g>
                                            <path class="cls-1" d="M24.36,106v20c0,5.52,4.48,10,10,10h30"/>
                                            <path class="cls-1" d="M112.36,136h50c5.52,0,10-4.48,10-10V14c0-5.52-4.48-10-10-10H65.36"/>
                                            <circle class="cls-1" cx="88.36" cy="136" r="24"/>
                                            <circle class="cls-1" cx="216.36" cy="136" r="24"/>
                                            <line class="cls-1" x1="166.36" y1="136" x2="192.36" y2="136"/>
                                            <path class="cls-1" d="M240.36,136h10c5.52,0,10-4.48,10-10v-38.11c0-2.5-.94-4.91-2.63-6.76l-38.4-41.89c-1.89-2.07-4.57-3.24-7.37-3.24h-39.6"/>
                                            <path class="cls-1" d="M260.36,84h-50c-5.52,0-10-4.48-10-10v-26"/>
                                        </g>
                                        <line class="cls-1" x1="94.78" y1="58" x2="12.72" y2="58"/>
                                        <line class="cls-1" x1="82.06" y1="86" y2="86"/>
                                        <line class="cls-1" x1="105.48" y1="30" x2="23.42" y2="30"/>
                                        </g>
                                    </g>
                                </svg>
                            </div>

                            <div class="text-container-text">
                                <p>Same Day</p>
                            </div>

                        </div>


                        <div class="text-container-shipping-options">

                            <div class="text-container-svg">
                                <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 291.61 269.01">
                                    <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                        <g>
                                        <g>
                                            <g>
                                            <line class="cls-2-alt" x1="219.91" y1="189.83" x2="219.91" y2="260.62"/>
                                            <polyline class="cls-2-alt" points="286.61 156.93 286.61 233.35 219.91 264.01 153.21 233.35 153.21 156.93"/>
                                            <polyline class="cls-2-alt" points="286.61 158.95 286.61 157.11 219.91 190.55 153.21 157.11 153.21 158.95"/>
                                            <polyline class="cls-2-alt" points="286.61 156.65 286.61 154.8 219.91 119.97 153.21 154.8 153.21 156.65"/>
                                            </g>
                                            <line class="cls-2-alt" x1="186.56" y1="138.31" x2="253.26" y2="171.92"/>
                                        </g>
                                        <g>
                                            <line class="cls-2" x1="49.53" y1="153.57" x2="58.71" y2="153.57"/>
                                            <line class="cls-2" x1="82.65" y1="153.57" x2="91.83" y2="153.57"/>
                                            <line class="cls-2" x1="49.53" y1="123.56" x2="58.71" y2="123.56"/>
                                            <line class="cls-2" x1="82.65" y1="123.56" x2="91.83" y2="123.56"/>
                                            <line class="cls-2" x1="115.77" y1="123.56" x2="124.95" y2="123.56"/>
                                            <line class="cls-2" x1="115.77" y1="153.57" x2="124.95" y2="153.57"/>
                                            <line class="cls-2" x1="82.65" y1="93.55" x2="91.83" y2="93.55"/>
                                            <line class="cls-2" x1="115.77" y1="93.55" x2="124.95" y2="93.55"/>
                                            <line class="cls-2" x1="148.89" y1="93.55" x2="158.07" y2="93.55"/>
                                            <line class="cls-2" x1="148.89" y1="123.56" x2="158.07" y2="123.56"/>
                                            <line class="cls-2" x1="182" y1="93.55" x2="191.18" y2="93.55"/>
                                        </g>
                                        <g>
                                            <path class="cls-2" d="M41.66,14.81H20.53c-8.58,0-15.53,6.96-15.53,15.54v25.88H241.44V30.34c0-8.58-6.96-15.54-15.53-15.54h-15.37"/>
                                            <line class="cls-2" x1="62.37" y1="5" x2="62.37" y2="24.61"/>
                                            <line class="cls-2" x1="189.24" y1="5" x2="189.24" y2="26.93"/>
                                            <line class="cls-2" x1="167.23" y1="14.81" x2="81.64" y2="14.81"/>
                                            <path class="cls-2" d="M5,56.22v120.96c0,8.58,6.96,15.53,15.53,15.53h110.44"/>
                                            <line class="cls-2" x1="241.44" y1="35.48" x2="241.44" y2="104.91"/>
                                        </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>

                            <div class="text-container-text">
                                <p>Saturday Delivery</p>
                            </div>

                        </div>


                        <div class="text-container-shipping-options">

                            <div class="text-container-svg">
                                <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 182">
                                    <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                        <g>
                                        <g>
                                            <path class="cls-1" d="M24,116v28c0,5.52,4.48,10,10,10h30"/>
                                            <path class="cls-1" d="M116,22h46c5.52,0,10,4.48,10,10v112c0,5.52-4.48,10-10,10h-50"/>
                                            <circle class="cls-1" cx="88" cy="154" r="24"/>
                                            <circle class="cls-1" cx="216" cy="154" r="24"/>
                                            <line class="cls-1" x1="160" y1="154" x2="192" y2="154"/>
                                            <path class="cls-1" d="M240,154h10c5.52,0,10-4.48,10-10v-38.11c0-2.5-.94-4.91-2.63-6.76l-38.4-41.89c-1.89-2.07-4.57-3.24-7.37-3.24h-39.6"/>
                                            <path class="cls-1" d="M260,102h-50c-5.52,0-10-4.48-10-10v-26"/>
                                        </g>
                                        <g>
                                            <circle class="cls-1-alt" cx="56" cy="56" r="52"/>
                                            <line class="cls-1-alt" x1="56" y1="24" x2="56" y2="59.71"/>
                                            <line class="cls-1-alt" x1="52.29" y1="56" x2="78.29" y2="56"/>
                                        </g>
                                        </g>
                                    </g>
                                </svg>
                            </div>

                            <div class="text-container-text">
                                <p>Priority Delivery</p>
                            </div>

                        </div>
                        <div class="text-container-shipping-options">

                            <div class="text-container-svg">
                                <svg version="1.1" id="Layer_2_00000097481093836458423110000015290372084020771757_"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 244 164"
                                        style="enable-background:new 0 0 244 164;" xml:space="preserve">
                                    <g id="_Ñëîé_1">
                                        <g>
                                            <g>
                                                <path class="st0" d="M4,109.9v16c0,5.5,4.5,10,10,10h30"/>
                                                <path class="st0" d="M92,135.9h50c5.5,0,10-4.5,10-10v-112c0-5.5-4.5-10-10-10H23"/>
                                                <path class="st0" d="M27,3.9H14c-5.5,0-10,4.5-10,10v100"/>
                                                <circle class="st0" cx="68" cy="135.9" r="24"/>
                                                <circle class="st0" cx="196" cy="135.9" r="24"/>
                                                <line class="st0" x1="128" y1="135.9" x2="172" y2="135.9"/>
                                                <path class="st0" d="M220,135.9h10c5.5,0,10-4.5,10-10V87.8c0-2.5-0.9-4.9-2.6-6.8L199,39.2c-1.9-2.1-4.6-3.2-7.4-3.2H152"/>
                                                <path class="st0" d="M240,83.9h-50c-5.5,0-10-4.5-10-10v-26"/>
                                            </g>
                                            <path class="st0" d="M87.7,46"/>
                                            <g>
                                                <g>
                                                    <g>
                                                        <polygon class="snowflake-alt" points="111.4,58.5 95.6,58.5 101.7,52 97.5,47.6 87.2,58.5 73.1,58.5 80.2,45.6 94.2,41.6 92.7,35.5 84.3,37.9 
                                                            92.3,23.3 87.1,20.1 79.2,34.7 77,25.9 71.3,27.5 75,42.4 68,55.4 61,42.4 64.7,27.5 59,25.9 56.8,34.7 48.9,20.1 43.7,23.3 
                                                            51.7,37.9 43.3,35.5 41.8,41.6 55.8,45.6 62.9,58.5 48.8,58.5 38.5,47.6 34.3,52 40.4,58.5 24.6,58.5 24.6,64.8 40.4,64.8 
                                                            34.3,71.3 38.5,75.8 48.8,64.8 62.9,64.8 55.8,77.8 41.8,81.8 43.3,87.9 51.7,85.5 43.7,100.1 48.9,103.2 56.8,88.6 59,97.5 
                                                            64.7,95.9 61,80.9 68,68 75,80.9 71.3,95.9 77,97.5 79.2,88.6 87.1,103.2 92.3,100.1 84.3,85.5 92.7,87.9 94.2,81.8 80.2,77.8 
                                                            73.1,64.8 87.2,64.8 97.5,75.8 101.7,71.3 95.6,64.8 111.4,64.8 					"/>
                                                    </g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                                <g>
                                                </g>
                                            </g>
                                        </g>
                                    </g>
                                    <path class="st0" d="M46.6,39.1"/>
                                    <path class="st0" d="M46.6,81.9"/>
                                    <path class="st0" d="M107.1,61.7"/>
                                    <path class="st0" d="M87.6,67.3"/>
                                </svg>
                            </div>

                            <div class="text-container-text">
                                <p>Cold-chain cabable</p>
                            </div>

                        </div>
                        <div class="text-container-shipping-options">

                            <div class="text-container-svg">
                                <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 251.67 328.54">
                                    <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                        <g>
                                        <g>
                                            <polyline class="cls-2-alt" points="213.95 310.25 213.95 280.72 192.99 240.34 66.07 240.34 45.11 284.23 45.11 310.25"/>
                                            <line class="cls-2-alt" x1="48.63" y1="284.23" x2="213.95" y2="284.23"/>
                                            <polyline class="cls-2-alt" points="150.64 284.23 150.64 323.54 129.53 314.13 108.43 323.54 108.43 284.23"/>
                                            <line class="cls-2-alt" x1="115.46" y1="240.34" x2="108.43" y2="284.23"/>
                                            <line class="cls-2-alt" x1="150.64" y1="284.23" x2="143.6" y2="240.34"/>
                                        </g>
                                        <path class="cls-2" d="M5,263.23l4.07-31.12c1.49-11.39,9.48-20.87,20.45-24.26l41.72-12.89c4.68-1.45,9.78-.46,13.58,2.62h0c23.9,19.38,58.11,19.38,82.01,0h0c3.81-3.09,8.9-4.07,13.58-2.62l41.72,12.89c10.97,3.39,18.97,12.87,20.45,24.26l4.07,31.12"/>
                                        <path class="cls-2" d="M179.67,133.69v1.49c0,17.17-9.99,32.77-25.58,39.95l-16.31,7.52c-7.79,3.59-16.76,3.59-24.54,0l-16.31-7.52c-15.59-7.18-25.58-22.78-25.58-39.95v-1.49"/>
                                        <path class="cls-2" d="M66.66,77.38l2.08-34.12c.68-11.22,7.8-21.02,18.25-25.15l28.02-11.08c6.83-2.7,14.44-2.7,21.28,0l28.02,11.08c10.45,4.13,17.56,13.94,18.25,25.15l2.08,34.12"/>
                                        <path class="cls-2" d="M182.17,75.94l-.69-.59c-31.61-27.16-78.16-27.68-110.37-1.23l-1.41,1.16c-5.33,4.37-6.62,12-3.03,17.89l8.7,14.27h0c30.19-23.72,72.69-23.72,102.89,0h0s3.95-8.06,7.32-14.94c2.77-5.66,1.38-12.46-3.4-16.56Z"/>
                                        <path class="cls-2" d="M57.76,116.69l-.15,.9c-1.37,8.44,5.15,16.11,13.7,16.11h.03"/>
                                        <path class="cls-2" d="M193.24,116.69l.15,.9c1.37,8.44-5.15,16.11-13.7,16.11h0"/>
                                        </g>
                                    </g>
                                    </svg>
                            </div>

                            <div class="text-container-text">
                                <p>Signature Required</p>
                            </div>

                        </div>
                        </div>
                    </div>
                    <div class="button-container-card">
                        <button class="main-button-blue-white" @click="CardOneAnimation()">Click here for more information</button>
                    </div>
                </div>

                <div class="text-container-back">
                    <div class="shape-container">
                        <div class="shape-one">
                            <h2>Supported Service Levels</h2>
                        </div>
                    </div>
                    <div class="text-container">
                        <div class="text-container-inner">
                            <p class="shipping-options-more-info" style="margin-top: 5px; margin-bottom: 5px;"> 
                                Our local, regional express delivery platform is built for and by clients who require:
                            </p>
                            <ul style="margin-top: 5px; margin-bottom: 5px;">
                                <li>Time Sensitive and Critical Delivery </li>
                                <li>Easy Online Tracking and Delivery notifications</li>
                                <li>Refrigerated Storage and Specialty care </li>
                            </ul>
                        </div>
                    </div>
                    <div class="button-container-card">
                        <button class="main-button-blue-white" @click="CardOneAnimation()">See less information</button>
                    </div>
                </div>
            </div>

            <div class="card-two">
                <div class="text-container-front">
                    <div class="header-container-lrex">
                    <div class="header-container-lrex-inner">
                        <h2>Compliance-Ready Workflows</h2>
                    </div>
                </div>

                <div class="text-container-lrex">
                    <div style="margin-top: 2%; margin-left: 1%;" class="text-container-lrex-inner">
                    <p>Secure, time-stamped, and signature-ready.<br>
                        Audit friendly. <br>
                        Built for regulated industries.
                    </p>
                    </div>
                </div>
                    <div class="button-container-card">
                        <button class="main-button-blue-white" @click="CardTwoAnimation()">Click here for more information</button>
                    </div>
                </div>

                <div class="text-container-back">
                    <div class="header-container-lrex">
                        <div class="header-container-lrex-inner-back">
                            <h2>LRex</h2>
                        </div>
                    </div>

                    <div class="text-container-lrex-back">
                        <div class="text-container-lrex-inner-back">
                        <!-- <p>
                            Putting the <span style="font-weight: bold">x</span> in express.
                        </p> -->
                        </div>
                        <div class="text-container-lrex-inner-two">
                            <ul>
                                <li>Encrypted data transmission</li>
                                <li>Restricted driver visibility</li>
                                <li>Time-Stamped Chain of Custody</li>
                                <li>Real-time GPS location at scan</li>
                                <li>Signature collection options</li>
                                <li>Photo confirmation</li>
                            </ul>
                            <!-- <p>A delivery solution for evolving businesses who have outgrown 
                                in-house shipping. LRex is the delivery partner who routes for 
                                your business.  
                            </p> -->
                        </div>
                    </div>
                    <div class="button-container-card">
                        <button class="main-button-blue-white" @click="CardTwoAnimation()">See less information</button>
                    </div>
                </div>
            </div>

            <!-- <div class="card-two">
                <div class="text-container-front">
                    <div class="header-container-lrex">
                    <div class="header-container-lrex-inner">
                        <h2>Priority Today</h2>
                    </div>
                </div>

                <div class="text-container-lrex">
                    <div class="text-container-lrex-inner">
                    <p>Scheduled Delivery Window <br>
                        Shopper Centric <br>
                        Same Day Service 
                    </p>
                    </div>
                </div>
                    <div class="button-container-card">
                        <button class="main-button-blue-white" @click="CardTwoAnimation()">Click here for more information</button>
                    </div>
                </div>

                <div class="text-container-back">
                    <div class="header-container-lrex">
                        <div class="header-container-lrex-inner-back">
                            <h2>Priority Today</h2>
                        </div>
                    </div>

                    <div class="text-container-lrex-back">
                        <div class="text-container-lrex-inner-back">
                        <p>
                            Putting the <span style="font-weight: bold">x</span> in express.
                        </p>
                        </div>
                        <div class="text-container-lrex-inner-two">
                            <p>A delivery solution for evolving businesses who have outgrown 
                                in-house shipping. LRex is the delivery partner who routes for 
                                your business.  
                            </p>
                        </div>
                    </div>
                    <div class="button-container-card">
                        <button class="main-button-blue-white" @click="CardTwoAnimation()">See less information</button>
                    </div>
                </div>
            </div> -->

            <!-- <div class="card-three">
                <div class="text-container-front">
                    <div class="shape-container">
                        <div class="shape-three">
                        <h2>ZipShip</h2>
                        </div>
                    </div>

                    <div class="text-container">
                        <div class="text-container-inner">
                        <div class="text-container-image">

                            <div class="text-container-svg">
                                <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 165.91">
                                    <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                        <g>
                                        <g>
                                            <path class="cls-1" d="M112,136.75h50c5.52,0,10-4.48,10-10V14.75c0-5.52-4.48-10-10-10h-42l-85.91-.75c-5.56-.05-10.09,4.44-10.09,10V55.91"/>
                                            <circle class="cls-1" cx="216" cy="136.75" r="24"/>
                                            <line class="cls-1" x1="146" y1="136.75" x2="192" y2="136.75"/>
                                            <path class="cls-1" d="M240,136.75h10c5.52,0,10-4.48,10-10v-38.11c0-2.5-.94-4.91-2.63-6.76l-38.4-41.89c-1.89-2.07-4.57-3.24-7.37-3.24h-39.6"/>
                                            <path class="cls-1" d="M260,84.75h-50c-5.52,0-10-4.48-10-10v-26"/>
                                        </g>
                                        <circle class="cls-1" cx="52" cy="113.91" r="48"/>
                                        <ellipse class="cls-1" cx="52" cy="113.91" rx="16" ry="48"/>
                                        <path class="cls-1" d="M11.36,91.91c8.5,4.52,23.52,7.5,40.64,7.5s32.14-2.98,40.64-7.5"/>
                                        <path class="cls-1" d="M92.64,135.91c-8.5-4.52-23.52-7.5-40.64-7.5s-32.14,2.98-40.64,7.5"/>
                                        </g>
                                    </g>
                                    </svg>
                            </div>

                            <div class="text-container-text">
                                <p style="font-weight: bold;">
                                No Drop Box. No Pickup. No Problem.
                                </p>
                            </div>
                        </div>
                        <div class="text-container-zipship">
                            <img src="../assets/FinalImages/OurSolutions/numberOne.png" alt="">
                            <p>
                            Create a shipping label.
                            </p>
                        </div>
                        <div class="text-container-zipship">
                            <img src="../assets/FinalImages/OurSolutions/numberTwo.png" alt="">
                            <p>
                            Email us the label with your documents.
                            </p>
                        </div>
                        <div class="text-container-zipship">
                            <img src="../assets/FinalImages/OurSolutions/numberThree.png" alt="">
                            <p>
                            Leave the rest to us.
                            </p>
                        </div>
                        </div>
                    </div>
                    <div class="button-container-card">
                        <button class="main-button-blue-white"><router-link class="main-button-blue-white" to="/ZipShip">Click here to submit information</router-link></button>
                    </div>
                </div>
            </div> -->
            <div class="card-three">
                <div class="text-container-front">
                    <div class="shape-container">
                        <div class="shape-three">
                        <h2>Tracking</h2>
                        </div>
                    </div>

                    <div class="text-container">
                        <div class="text-container-inner">
                        <div class="text-container-image">

                            <!-- <div class="text-container-svg">
                                <svg id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 264 165.91">
                                    <g id="_Ñëîé_1" data-name="Ñëîé 1">
                                        <g>
                                        <g>
                                            <path class="cls-1" d="M112,136.75h50c5.52,0,10-4.48,10-10V14.75c0-5.52-4.48-10-10-10h-42l-85.91-.75c-5.56-.05-10.09,4.44-10.09,10V55.91"/>
                                            <circle class="cls-1" cx="216" cy="136.75" r="24"/>
                                            <line class="cls-1" x1="146" y1="136.75" x2="192" y2="136.75"/>
                                            <path class="cls-1" d="M240,136.75h10c5.52,0,10-4.48,10-10v-38.11c0-2.5-.94-4.91-2.63-6.76l-38.4-41.89c-1.89-2.07-4.57-3.24-7.37-3.24h-39.6"/>
                                            <path class="cls-1" d="M260,84.75h-50c-5.52,0-10-4.48-10-10v-26"/>
                                        </g>
                                        <circle class="cls-1" cx="52" cy="113.91" r="48"/>
                                        <ellipse class="cls-1" cx="52" cy="113.91" rx="16" ry="48"/>
                                        <path class="cls-1" d="M11.36,91.91c8.5,4.52,23.52,7.5,40.64,7.5s32.14-2.98,40.64-7.5"/>
                                        <path class="cls-1" d="M92.64,135.91c-8.5-4.52-23.52-7.5-40.64-7.5s-32.14,2.98-40.64,7.5"/>
                                        </g>
                                    </g>
                                    </svg>
                            </div> -->

                            <div class="text-container-text">
                                <p style="font-weight: bold; text-align: center; margin-top: 20px;">
                                Time-Stamped Chain of Custody
                                </p>
                            </div>
                        </div>
                        <div class="text-container-zipship">
                            <!-- <img src="../assets/FinalImages/OurSolutions/numberOne.png" alt=""> -->
                            <p>
                            Every handoff, scan, and event securely tracked with date, time, and location stamps.
                            </p>
                        </div>
                        <!-- <div class="text-container-zipship">
                            <img src="../assets/FinalImages/OurSolutions/numberTwo.png" alt="">
                            <p>
                            Email us the label with your documents.
                            </p>
                        </div>
                        <div class="text-container-zipship">
                            <img src="../assets/FinalImages/OurSolutions/numberThree.png" alt="">
                            <p>
                            Leave the rest to us.
                            </p>
                        </div> -->
                        </div>
                    </div>
                    <div class="progress-outer-container button-container-card">
                        <div class="progress-container">
                        <div class="progress" id="progress"></div>
                            <div class="circle active"><p class="where"></p></div>
                            <div class="circle active"><p class="how"></p></div>
                            <div class="circle active"><p class="details"></p></div>
                            <div class="circle"><p class="confirm"></p></div>
                        </div>
                    </div>
                    
                    <!-- <div class="button-container-card">
                        <button class="main-button-blue-white"><router-link class="main-button-blue-white" to="/ZipShip">Click here to submit information</router-link></button>
                    </div> -->
                </div>
            </div>

            <div class="card-four">
                <div class="text-container-front">
                    <div class="shape-container">
                        <div class="shape-one">
                        <h2>Technology</h2>
                        </div>
                    </div>

                    <div class="text-container">
                        <div class="text-container-inner-tech">
                            <div class="svg-container">
                                <svg class="svg-main" version="1.1" id="Layer_2_00000167358154578852465310000008108272067321791904_" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 259.8 228.7" style="enable-background:new 0 0 259.8 228.7;" xml:space="preserve">
                                    <g id="Layer_2-2">
                                        <g>
                                            <linearGradient id="SVGID_1_" gradientUnits="userSpaceOnUse" x1="128.8861" y1="132.5718" x2="240.621" y2="116.9565" gradientTransform="matrix(1 0 0 -1 0 227.8898)">
                                            <stop  offset="2.339961e-02" style="stop-color:#FFFFFF;stop-opacity:0"/>
                                            <stop  offset="4.047504e-02" style="stop-color:#E1FBED;stop-opacity:1.923770e-02"/>
                                            <stop  offset="6.884298e-02" style="stop-color:#B5F6D3;stop-opacity:5.119786e-02"/>
                                            <stop  offset="0.1002" style="stop-color:#8DF1BB;stop-opacity:8.657145e-02"/>
                                            <stop  offset="0.134" style="stop-color:#6BEDA7;stop-opacity:0.1246"/>
                                            <stop  offset="0.1708" style="stop-color:#4EEA96;stop-opacity:0.166"/>
                                            <stop  offset="0.2116" style="stop-color:#37E788;stop-opacity:0.212"/>
                                            <stop  offset="0.2581" style="stop-color:#25E57D;stop-opacity:0.2644"/>
                                            <stop  offset="0.3139" style="stop-color:#18E376;stop-opacity:0.3272"/>
                                            <stop  offset="0.3881" style="stop-color:#11E271;stop-opacity:0.4109"/>
                                            <stop  offset="0.556" style="stop-color:#0FE270;stop-opacity:0.6"/>
                                        </linearGradient>
                                        <path class="st0-tech" d="M205.6,121.5c-22.7,23.6-46.6,79.9-71.5,44.9c-12.3-15.9-22.9-46.9-27-68.9c-4.2-23.2-1.7-37.3,10-47.2
                                            C140.6,31.6,186,4.4,209.9,42c12.2,17.8,17,37.5,15.6,49.1C224.2,103.8,216.6,108.4,205.6,121.5L205.6,121.5z"/>
                                        </g>
                                        <g>
                                        
                                            <linearGradient id="SVGID_00000149378171658145657260000014893634367668020883_" gradientUnits="userSpaceOnUse" x1="190.7869" y1="63.4997" x2="214.1943" y2="95.7448" gradientTransform="matrix(1 0 0 -1 0 227.8898)">
                                            <stop  offset="0" style="stop-color:#FFFFFF;stop-opacity:0"/>
                                            <stop  offset="0.6993" style="stop-color:#32CCFE"/>
                                        </linearGradient>
                                        <path class="st1-tech" style="fill:url(#SVGID_00000149378171658145657260000014893634367668020883_);" d="M212.4,132.1c2.6,1.1,2.6,3.2,2,6
                                            s-1.9,6.4-2.6,10.5c-0.9,4.1-1.4,7.4-2.8,10.5c-1.4,3-3.5,5.7-6.9,7.6c-3.3,1.8-7.4,2.1-10.4-0.7c-3-2.7-4.9-8.6-3.2-15.6
                                            c1.6-7.1,6.6-12.9,11.6-15.9C205,131.4,209.9,131.1,212.4,132.1L212.4,132.1z"/>
                                        </g>
                                        
                                        <linearGradient id="SVGID_00000121982770445702316340000016228823954594341810_" gradientUnits="userSpaceOnUse" x1="21.2818" y1="97.4699" x2="201.9027" y2="190.1537" gradientTransform="matrix(1 0 0 -1 0 227.8898)">
                                        <stop  offset="0" style="stop-color:#33F18A"/>
                                        <stop  offset="7.742755e-02" style="stop-color:#33F18A"/>
                                        <stop  offset="0.5478" style="stop-color:#33F18A"/>
                                        </linearGradient>
                                        <path class="st2-tech" style="fill:url(#SVGID_00000121982770445702316340000016228823954594341810_);" d="M106.6,13.4c31.8,0.9,60.5,12.5,79.8,26.3
                                        c19.5,14.1,29.6,30.5,28.2,46.9c-1.4,16.6-13.8,31.2-30.7,45.2c-17.1,13.8-38.9,26.9-62.5,34.5c-46,16.2-91.8-4.8-106.6-56.1
                                        C-0.1,59.4,41.5,10,106.6,13.4z"/>
                                        <g>
                                        
                                            <linearGradient id="SVGID_00000045618199944962831850000002255751087836228228_" gradientUnits="userSpaceOnUse" x1="12.9635" y1="150.8489" x2="200.6904" y2="150.8489" gradientTransform="matrix(1 0 0 -1 0 227.8898)">
                                            <stop  offset="0.3087" style="stop-color:#63F4A5"/>
                                            <stop  offset="0.6193" style="stop-color:#90E3FE;stop-opacity:0.5507"/>
                                            <stop  offset="1" style="stop-color:#FFFFFF;stop-opacity:0"/>
                                        </linearGradient>
                                        <path class="st3-tech" style="fill:url(#SVGID_00000045618199944962831850000002255751087836228228_);" d="M15,41.7c5.6-21,27.4-36.7,52.7-40
                                            c25.3-3.9,54.2,4.8,72.6,17.5c38.6,26.2,26.5,46.2,6.6,79.4c-20.8,32.1-41.7,66.6-67.7,50.8c-12.8-7.8-30.3-25.4-45.1-45
                                            C19.8,84.7,8.1,63,15,41.7L15,41.7z"/>
                                        </g>
                                        <g>
                                        <g>
                                            <radialGradient id="SVGID_00000137114542197034017570000004139487707518343559_" cx="2045.751" cy="2976.2568" r="59.64" gradientTransform="matrix(2.18 0 0 0.43 -4326.4697 -1075.59)" gradientUnits="userSpaceOnUse">
                                            <stop  offset="0.12" style="stop-color:#C4DEDC"/>
                                            <stop  offset="0.33" style="stop-color:#CCE2E0"/>
                                            <stop  offset="0.66" style="stop-color:#E2EEED"/>
                                            <stop  offset="1" style="stop-color:#FFFFFF"/>
                                            </radialGradient>
                                            <path class="st4-tech" style="fill:url(#SVGID_00000137114542197034017570000004139487707518343559_);" d="M259.8,203.1
                                            c0,14.1-58.2,25.6-129.9,25.6S0,217.3,0,203.1s58.2-25.6,129.9-25.6S259.8,189,259.8,203.1z"/>
                                        </g>
                                        </g>
                                    </g>
                                    <g>
                                        <linearGradient id="SVGID_00000143611303658626877630000017599565499850839982_" gradientUnits="userSpaceOnUse" x1="25.5879" y1="122.2115" x2="48.0246" y2="153.1195" gradientTransform="matrix(-0.9939 -0.1106 -0.1106 0.9939 86.089 -39.8675)">
                                        <stop  offset="0" style="stop-color:#FFFFFF;stop-opacity:0"/>
                                        <stop  offset="0.6993" style="stop-color:#32CCFE"/>
                                        </linearGradient>
                                        <path class="st5-tech" style="fill:url(#SVGID_00000143611303658626877630000017599565499850839982_);" d="M23.8,107.9c-2.2-1.3-2-3.4-1.1-6.1
                                        c0.8-2.7,2.4-6.1,3.5-10c1.2-3.9,2.1-7.1,3.6-10c1.6-2.8,3.7-5.2,7-6.8c3.1-1.4,6.8-1.3,9.2,1.7c2.4,2.9,3.4,8.9,1.1,15.6
                                        c-2.2,6.8-7.3,12-12.1,14.4C30.3,109.3,25.9,109.1,23.8,107.9L23.8,107.9z"/>
                                    </g>
                                </svg>
                            </div>


                            <div class="text-container-image-tech">
                                <div class="text-container-tech-header">
                                    <!-- <p>We sculpt solutions to address your needs.</p> -->
                                    <p>We sculpt flexible technology to fit your custom workflows, partners, and compliance requirements</p>
                                </div>
                                

                                <div class="tech-image-text">
                                    <div class="text-container-svg">
                                        <svg class="technology-svg" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 330.08 331.86">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <g>
                                                <g>
                                                    <path class="puzzle" d="M238.9,331.85H5c-2.76,0-5-2.24-5-5V92.95c0-2.76,2.24-5,5-5H121.98c2.76,0,5,2.24,5,5s-2.24,5-5,5H10v223.9H233.9v-111.94c0-2.76,2.24-5,5-5s5,2.24,5,5v116.94c0,2.76-2.24,5-5,5Z"/>
                                                    <path class="puzzle" d="M121.98,250.78c-2.76,0-5-2.24-5-5v-71.76c0-2.76,2.24-5,5-5s5,2.24,5,5v71.76c0,2.76-2.24,5-5,5Z"/>
                                                    <path class="puzzle" d="M121.98,331.86c-2.76,0-5-2.24-5-5v-32.15c0-2.76,2.24-5,5-5s5,2.24,5,5v32.15c0,2.76-2.24,5-5,5Z"/>
                                                    <path class="puzzle" d="M121.98,130.1c-2.76,0-5-2.24-5-5v-32.16c0-2.76,2.24-5,5-5s5,2.24,5,5v32.16c0,2.76-2.24,5-5,5Z"/>
                                                    <path class="puzzle" d="M37.17,214.9H5.02c-2.76,0-5-2.24-5-5s2.24-5,5-5H37.17c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"/>
                                                    <path class="puzzle" d="M157.86,214.9H86.1c-2.76,0-5-2.24-5-5s2.24-5,5-5h71.76c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"/>
                                                    <path class="puzzle" d="M238.94,214.9h-32.15c-2.76,0-5-2.24-5-5s2.24-5,5-5h32.15c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"/>
                                                    <path class="puzzle" d="M136.01,182.82c-5.7,0-11.32-1.47-16.52-4.46-2.39-1.38-3.22-4.43-1.85-6.83,1.37-2.4,4.42-3.22,6.83-1.85,9.04,5.19,19.63,3.93,29.14-3.51,6.31-8.88,7.52-18.72,3.29-27.1-5.81-11.5-21.03-16.2-32.43-9.65-2.38,1.38-5.45,.55-6.83-1.85-1.38-2.39-.55-5.45,1.85-6.83,5.09-2.93,10.83-4.47,16.63-4.47,12.63,0,24.01,7.01,29.71,18.29,5.99,11.85,4.29,26.08-4.55,38.07-.25,.34-.55,.65-.89,.93-7.61,6.12-16.08,9.25-24.38,9.25Z"/>
                                                    <path class="puzzle" d="M107.94,303.51c-8.3,0-16.77-3.12-24.38-9.25-.34-.27-.63-.59-.89-.93-8.84-11.98-10.54-26.22-4.55-38.07,5.7-11.28,17.08-18.29,29.71-18.29,5.79,0,11.54,1.54,16.63,4.47,2.4,1.38,3.22,4.43,1.85,6.83-1.38,2.39-4.44,3.21-6.83,1.85-11.4-6.57-26.62-1.86-32.43,9.65-4.23,8.38-3.03,18.22,3.29,27.11,9.51,7.4,20.1,8.67,29.14,3.5,2.41-1.38,5.46-.55,6.83,1.85,1.38,2.39,.55,5.45-1.85,6.83-5.21,2.99-10.83,4.46-16.52,4.46Z"/>
                                                    <path class="puzzle" d="M182.22,257.29c-4.96,0-9.83-1.08-14.39-3.3-11.41-5.53-18.77-17.29-18.77-29.95,0-5.88,1.55-11.64,4.49-16.66,1.4-2.37,4.46-3.16,6.84-1.79,2.38,1.4,3.18,4.46,1.79,6.85-2.04,3.48-3.12,7.49-3.12,11.6,0,8.99,5.03,17.02,13.13,20.96,8.65,4.18,18.74,2.66,27.76-4.19,6.52-9.65,7.45-19.95,2.52-28.37-1.39-2.39-.59-5.45,1.79-6.85,2.37-1.38,5.44-.59,6.84,1.79,6.98,11.94,5.72,26.82-3.38,39.78-.28,.4-.62,.75-1,1.05-7.6,6-16.16,9.08-24.5,9.08Zm21.41-13.01h0Z"/>
                                                    <path class="puzzle" d="M86.09,214.9c-.85,0-1.72-.21-2.51-.68-2.39-1.4-3.19-4.45-1.8-6.84,2.04-3.5,3.12-7.52,3.12-11.62,0-8.86-5.16-17.08-13.14-20.95-8.65-4.22-18.73-2.66-27.75,4.19-6.52,9.65-7.45,19.95-2.52,28.37,1.39,2.39,.59,5.45-1.79,6.85-2.37,1.37-5.44,.58-6.84-1.79-6.98-11.94-5.72-26.82,3.38-39.78,.28-.4,.62-.75,1-1.05,12.11-9.56,26.65-11.72,38.89-5.79,11.41,5.53,18.77,17.29,18.77,29.95,0,5.88-1.55,11.64-4.49,16.66-.93,1.59-2.6,2.48-4.32,2.48Z"/>
                                                </g>
                                                <g>
                                                    <path d="M325.05,131.56c-2.76,0-5-2.24-5-5V10h-116.54c-2.76,0-5-2.24-5-5s2.24-5,5-5h121.54c2.76,0,5,2.24,5,5V126.56c0,2.76-2.24,5-5,5Z"/>
                                                    <path d="M203.51,132.4c-2.76,0-5-2.24-5-5v-38.13c0-2.76,2.24-5,5-5s5,2.24,5,5v38.13c0,2.76-2.24,5-5,5Z"/>
                                                    <path d="M203.51,43.42c-2.76,0-5-2.24-5-5V5c0-2.76,2.24-5,5-5s5,2.24,5,5V38.42c0,2.76-2.24,5-5,5Z"/>
                                                    <path d="M203.51,132.4c-2.71,0-4.94-2.17-5-4.88-.06-2.76,2.13-5.05,4.89-5.12l37.29-.84c3.24,.13,5.05,2.14,5.11,4.88,.06,2.76-2.13,5.05-4.89,5.12l-37.29,.84h-.11Z"/>
                                                    <path d="M325.08,131.56h-33.42c-2.76,0-5-2.24-5-5s2.24-5,5-5h33.42c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"/>
                                                    <path d="M218.1,98.22c-5.89,0-11.7-1.53-17.08-4.62-2.4-1.38-3.22-4.43-1.85-6.83,1.38-2.4,4.42-3.23,6.83-1.85,9.48,5.45,20.57,4.1,30.53-3.66,6.62-9.31,7.89-19.62,3.45-28.4-4.18-8.27-12.52-13.41-21.78-13.41-4.24,0-8.46,1.13-12.2,3.29-2.39,1.37-5.45,.55-6.83-1.85-1.38-2.39-.56-5.45,1.84-6.83,5.25-3.02,11.2-4.62,17.19-4.62,13.05,0,24.81,7.24,30.7,18.9,6.19,12.25,4.43,26.96-4.71,39.37-.25,.34-.55,.65-.89,.93-7.87,6.34-16.63,9.57-25.21,9.57Z"/>
                                                    <path d="M266.12,175.62c-5.12,0-10.16-1.12-14.87-3.41-11.78-5.71-19.4-17.86-19.4-30.95,0-6.08,1.61-12.04,4.64-17.23,1.4-2.38,4.46-3.17,6.84-1.79,2.38,1.4,3.18,4.46,1.79,6.85-2.14,3.65-3.27,7.86-3.27,12.17,0,9.42,5.27,17.83,13.76,21.95,9.06,4.39,19.63,2.79,29.09-4.39,6.84-10.11,7.81-20.91,2.64-29.73-1.39-2.38-.59-5.45,1.79-6.85,2.37-1.39,5.44-.6,6.84,1.79,7.22,12.34,5.91,27.71-3.51,41.13-.28,.4-.62,.75-1,1.05-7.87,6.2-16.72,9.39-25.35,9.39Zm22.26-13.32h0Z"/>
                                                </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>

                                    <div class="text-container-text">
                                        <p style="font-weight: bold;">
                                        3rd Party Integrations
                                        </p>
                                    </div>
                                </div>

                                <div class="tech-image-text">
                                    <div class="text-container-svg">
                                        <svg class="technology-svg" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 249.48 320.02">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <g>
                                                <g>
                                                    <path d="M214.08,320.01H5c-2.76,0-5-2.24-5-5V105.93c0-2.76,2.24-5,5-5H109.57c2.76,0,5,2.24,5,5s-2.24,5-5,5H10v199.08H209.08v-99.53c0-2.76,2.24-5,5-5s5,2.24,5,5v104.53c0,2.76-2.24,5-5,5Z"/>
                                                    <path d="M109.57,247.55c-2.76,0-5-2.24-5-5v-64.14c0-2.76,2.24-5,5-5s5,2.24,5,5v64.14c0,2.76-2.24,5-5,5Z"/>
                                                    <path d="M109.57,320.02c-2.76,0-5-2.24-5-5v-28.74c0-2.76,2.24-5,5-5s5,2.24,5,5v28.74c0,2.76-2.24,5-5,5Z"/>
                                                    <path d="M109.57,139.67c-2.76,0-5-2.24-5-5v-28.74c0-2.76,2.24-5,5-5s5,2.24,5,5v28.74c0,2.76-2.24,5-5,5Z"/>
                                                    <path d="M33.75,215.48H5.02c-2.76,0-5-2.24-5-5s2.24-5,5-5h28.74c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"/>
                                                    <path d="M141.64,215.48H77.49c-2.76,0-5-2.24-5-5s2.24-5,5-5h64.15c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"/>
                                                    <path d="M214.11,215.48h-28.74c-2.76,0-5-2.24-5-5s2.24-5,5-5h28.74c2.76,0,5,2.24,5,5s-2.24,5-5,5Z"/>
                                                    <path d="M122.11,186.81c-5.19,0-10.3-1.35-15.04-4.06-2.39-1.38-3.22-4.42-1.85-6.83,1.37-2.4,4.42-3.23,6.83-1.85,7.87,4.51,17.09,3.4,25.39-3.04,5.49-7.76,6.53-16.34,2.86-23.62-5.06-10.02-18.32-14.11-28.25-8.41-2.39,1.37-5.45,.56-6.83-1.85-1.38-2.4-.55-5.45,1.85-6.83,4.63-2.66,9.86-4.06,15.12-4.06,11.49,0,21.85,6.38,27.03,16.63,5.44,10.78,3.91,23.71-4.11,34.59-.25,.34-.55,.65-.89,.93-6.89,5.56-14.58,8.39-22.11,8.39Z"/>
                                                    <path d="M97.02,294.68c-7.53,0-15.21-2.83-22.12-8.38-.34-.27-.63-.59-.89-.93-8.02-10.88-9.56-23.81-4.11-34.59,5.19-10.25,15.54-16.63,27.03-16.63,5.26,0,10.49,1.41,15.12,4.06,2.4,1.37,3.23,4.42,1.86,6.83-1.38,2.39-4.44,3.2-6.83,1.85-9.97-5.69-23.19-1.61-28.26,8.41-3.68,7.29-2.63,15.86,2.86,23.61,8.31,6.45,17.54,7.57,25.4,3.04,2.39-1.37,5.45-.56,6.83,1.85,1.38,2.39,.55,5.45-1.85,6.83-4.74,2.72-9.85,4.06-15.04,4.06Z"/>
                                                    <path d="M163.41,253.36c-4.51,0-8.95-.99-13.1-3-10.37-5.03-17.08-15.72-17.08-27.25,0-5.34,1.41-10.59,4.09-15.16,1.4-2.39,4.45-3.18,6.84-1.8,2.38,1.4,3.18,4.45,1.79,6.84-1.81,3.09-2.72,6.49-2.72,10.12,0,7.83,4.38,14.82,11.44,18.24,7.54,3.66,16.32,2.32,24.2-3.63,5.66-8.43,6.46-17.4,2.18-24.73-1.39-2.38-.59-5.44,1.79-6.84,2.39-1.39,5.44-.6,6.84,1.8,6.35,10.85,5.21,24.36-3.05,36.11-.28,.4-.62,.75-1,1.05-6.89,5.44-14.66,8.23-22.24,8.23Zm19.14-12.16h0Z"/>
                                                    <path d="M33.76,215.48c-1.72,0-3.39-.89-4.32-2.48-6.35-10.86-5.21-24.37,3.05-36.12,.28-.4,.62-.75,1-1.05,10.99-8.68,24.18-10.63,35.33-5.23,10.38,5.04,17.08,15.73,17.08,27.26,0,5.34-1.41,10.59-4.09,15.16-1.4,2.38-4.46,3.16-6.84,1.8-2.38-1.4-3.18-4.45-1.79-6.84,1.78-3.05,2.72-6.54,2.72-10.12,0-7.83-4.38-14.83-11.45-18.25-7.51-3.64-16.3-2.31-24.19,3.63-5.67,8.43-6.47,17.41-2.19,24.74,1.39,2.38,.59,5.44-1.79,6.84-.8,.46-1.66,.68-2.52,.68Z"/>
                                                </g>
                                                <g>
                                                    <path d="M211.52,167.33h-38.55c-2.76,0-5-2.24-5-5v-42.09c-18.96-12.69-32.96-39.19-32.96-63.01,0-31.56,25.67-57.24,57.24-57.24s57.24,25.67,57.24,57.24c0,23.82-14,50.32-32.96,63.01v42.09c0,2.76-2.24,5-5,5Zm-33.55-10h28.55v-39.84c0-1.77,.93-3.4,2.45-4.3,17.1-10.15,30.51-34.73,30.51-55.96,0-26.04-21.19-47.24-47.24-47.24s-47.24,21.19-47.24,47.24c0,21.23,13.4,45.81,30.51,55.96,1.52,.9,2.45,2.53,2.45,4.3v39.84Z" style="fill: #1d1d1b;"/>
                                                    <path d="M211.52,143.7h-38.55c-2.76,0-5-2.24-5-5s2.24-5,5-5h38.55c2.76,0,5,2.24,5,5s-2.24,5-5,5Z" style="fill: #1d1d1b;"/>
                                                    <path d="M201.88,185.37h-19.28c-2.76,0-5-2.24-5-5s2.24-5,5-5h19.28c2.76,0,5,2.24,5,5s-2.24,5-5,5Z" style="fill: #1d1d1b;"/>
                                                    <path d="M192.24,122.56c-2.76,0-5-2.24-5-5v-34.62l-12.84-12.84c-1.95-1.95-1.95-5.12,0-7.07,1.95-1.95,5.12-1.95,7.07,0l14.3,14.31c.94,.94,1.46,2.21,1.46,3.54v36.69c0,2.76-2.24,5-5,5Z" style="fill: #1d1d1b;"/>
                                                    <path d="M192.24,85.87c-1.28,0-2.56-.49-3.54-1.46-1.95-1.95-1.95-5.12,0-7.07l13.68-13.68c1.95-1.95,5.12-1.95,7.07,0s1.95,5.12,0,7.07l-13.68,13.68c-.98,.98-2.26,1.46-3.54,1.46Z" style="fill: #1d1d1b;"/>
                                                </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>

                                    <div class="text-container-text">
                                        <p style="font-weight: bold;">
                                        Custom Applications
                                        </p>
                                    </div>
                                </div>

                                <div class="tech-image-text">
                                    <div class="text-container-svg">
                                        <svg class="technology-svg-signature" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 500 311.65">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <g id="NewGroupe0">
                                                <g>
                                                    <path d="M463.29,15.27c1.5,.38,2.86,.88,4.05,1.49,1.79,.91,3.2,2.04,4.32,3.39,1.11,1.36,1.96,2.98,2.51,5.09,.98,3.88,4.92,6.23,8.81,5.25,3.88-.98,6.23-4.92,5.25-8.81h0c-.91-3.61-2.47-6.9-4.56-9.71-1.56-2.11-3.41-3.93-5.45-5.46-3.06-2.3-6.53-3.92-10.18-4.97C464.38,.48,460.53,0,456.6,0H32.61c-4.48,0-8.79,.91-12.7,2.57-5.86,2.48-10.83,6.61-14.34,11.81C2.06,19.57,0,25.88,0,32.61v246.42c0,4.48,.91,8.79,2.57,12.7,2.48,5.86,6.61,10.83,11.81,14.34,5.2,3.52,11.51,5.58,18.24,5.57H456.6c4.48,0,8.79-.91,12.7-2.57,5.86-2.48,10.83-6.61,14.34-11.81,3.52-5.2,5.58-11.51,5.57-18.24V143.39c0-4-3.25-7.25-7.25-7.25s-7.25,3.25-7.25,7.25v135.64c0,2.52-.51,4.89-1.42,7.05-1.37,3.24-3.68,6.02-6.57,7.98-2.9,1.95-6.35,3.09-10.12,3.09H32.61c-2.52,0-4.89-.51-7.05-1.42-3.24-1.37-6.02-3.68-7.98-6.57-1.95-2.9-3.09-6.35-3.09-10.13V32.61c0-2.52,.51-4.89,1.42-7.05,1.37-3.24,3.68-6.02,6.57-7.98,2.9-1.95,6.35-3.09,10.13-3.09H456.6c2.43,0,4.69,.27,6.69,.77h0Z"/>
                                                    <path d="M401.24,59.06c2.33,1.04,4.4,2.83,5.88,5.16,1.48,2.33,2.37,5.15,2.37,8.26,0,1.91,.77,3.78,2.12,5.12,1.35,1.35,3.22,2.12,5.13,2.12s3.78-.77,5.12-2.12c1.35-1.35,2.12-3.22,2.12-5.12v-1.93c0-.63-.09-1.23-.24-1.81-.79-6.39-3.58-12.19-7.75-16.61-2.49-2.64-5.47-4.8-8.83-6.3-3.35-1.5-7.08-2.34-10.95-2.34H71.26c-3.87,0-7.6,.84-10.95,2.34-5.04,2.26-9.23,5.98-12.18,10.59-2.95,4.61-4.64,10.16-4.64,16.05V239.17c0,7.87,3.01,15.08,7.99,20.35,2.49,2.64,5.48,4.79,8.83,6.3,3.35,1.5,7.08,2.34,10.95,2.34H396.22c3.87,0,7.6-.84,10.95-2.34,5.03-2.26,9.23-5.98,12.17-10.6,2.94-4.61,4.64-10.16,4.64-16.05v-62.44c0-4-3.25-7.25-7.25-7.25s-7.25,3.25-7.25,7.25h0v62.44c0,4.15-1.58,7.8-4.03,10.4-1.22,1.3-2.66,2.32-4.21,3.02-1.56,.7-3.23,1.07-5.02,1.07H71.26c-1.79,0-3.47-.38-5.03-1.07-2.33-1.04-4.4-2.84-5.88-5.16-1.48-2.33-2.37-5.15-2.37-8.26V72.48c0-4.14,1.58-7.8,4.03-10.4,1.23-1.3,2.66-2.32,4.22-3.02,1.56-.7,3.23-1.07,5.03-1.07H396.22c1.79,0,3.47,.38,5.02,1.07h0Z"/>
                                                    <path d="M322.87,223.68l-10.41,3.61,4.37-13.39,84.03-87.07c.44,.55,.9,1.08,1.41,1.58l8.05,7.88c.43,.42,.88,.81,1.35,1.18l-88.8,86.2h0ZM472.04,53.9c.78-.8,1.66-1.38,2.62-1.77,.95-.39,1.97-.59,3-.59s1.99,.19,2.92,.56c.93,.37,1.79,.92,2.57,1.68,.8,.78,1.37,1.66,1.76,2.61,.39,.95,.59,1.97,.59,2.99,0,.92-.16,1.84-.48,2.71-.31,.83-.76,1.62-1.36,2.34l-60.06,61.48c-.23,.24-.47,.39-.74,.5-.26,.11-.56,.17-.85,.17s-.57-.06-.83-.16c-.26-.11-.49-.25-.73-.48l-8.05-7.88c-.24-.23-.39-.47-.5-.74-.11-.26-.17-.56-.17-.85s.05-.57,.16-.83c.11-.26,.25-.49,.48-.72l59.68-61.02h0Zm21.24-10.49c-2.16-2.11-4.67-3.72-7.33-4.78-2.66-1.06-5.48-1.59-8.29-1.59s-5.79,.56-8.52,1.68c-2.73,1.12-5.28,2.81-7.46,5.04l-59.68,61.02s0,0,0,0c-.01,.01-.02,.02-.04,.03h0l-96.73,100.22c-.77,.79-1.33,1.74-1.68,2.78l-9.41,28.86c-.85,2.62-.15,5.49,1.81,7.42s4.85,2.58,7.45,1.67l25.72-8.93c1-.35,1.91-.91,2.67-1.65l101.6-98.63h0c.21-.2,.39-.37,.5-.48,.01-.01,.02-.03,.03-.04,0,0,0,0,.01-.01h0s46.53-47.63,46.53-47.63c-.09,.39-.18,.77-.29,1.16-1.46,5.32-3.96,10.99-8.4,16.88-6.34,8.4-14.06,15.88-22.13,21.5-3.28,2.29-4.09,6.8-1.81,10.09,2.29,3.28,6.8,4.09,10.09,1.81h0c9.44-6.58,18.17-15.06,25.42-24.66,5.58-7.39,8.93-14.87,10.81-21.79,1.89-6.92,2.35-13.28,2.35-18.52,0-1.21-.03-2.36-.06-3.44,.89-1.39,1.61-2.85,2.17-4.36,.91-2.49,1.36-5.09,1.36-7.69,0-2.89-.56-5.78-1.68-8.51-1.12-2.72-2.81-5.28-5.03-7.45h0Z"/>
                                                    <polygon points="137.55 240.29 137.55 240.29 137.54 240.28 137.55 240.29 137.55 240.29"/>
                                                    <path d="M240.87,223.85c3.38-2.52,7.37-5.08,11.28-7.69,1.89-1.26,3.75-2.54,5.54-3.87,1.7,1.44,3.52,2.75,5.44,3.93,0,0,0,0,.01,.01,.21,.31,.51,.82,.8,1.4,.21,.41,.41,.86,.6,1.31-9.13,4.7-18.58,8.73-28.28,12.11-.5-.6-1.01-1.33-1.41-2,.11-.12,.21-.23,.33-.35,1.46-1.52,3.43-3.17,5.68-4.84h0Zm27.61-6.98h0s0,0,0,0h0Zm-33.73-26.11h0s0,0,0,0h0Zm-6.04-1.16h0s0,0,0,0h0Zm-8.76,36.17c-.21,.87-.28,1.64-.28,2.33,0,1.4,.25,2.49,.53,3.48,.26,.87,.57,1.66,.91,2.42,.61,1.33,1.32,2.58,2.12,3.78,.6,.9,1.25,1.77,1.94,2.6,1.05,1.25,2.17,2.4,3.57,3.46,.71,.53,1.49,1.04,2.49,1.5,.5,.23,1.07,.44,1.72,.6,.65,.16,1.4,.28,2.25,.28,.83,0,1.76-.12,2.68-.42h.03c12.94-4.3,25.47-9.71,37.46-16.2h0c.99-.53,1.87-1.29,2.5-2.09,.48-.6,.84-1.21,1.11-1.79,.4-.87,.6-1.65,.72-2.35,.12-.7,.16-1.32,.16-1.89,0-1-.11-1.86-.26-2.69-.26-1.43-.66-2.75-1.13-4.05-.71-1.94-1.58-3.79-2.58-5.48-.51-.85-1.04-1.66-1.7-2.47-.33-.41-.7-.82-1.15-1.26-.46-.43-1-.9-1.82-1.38-.72-.42-1.42-.87-2.1-1.35,1.54-1.21,3.11-2.39,4.7-3.53,3.26-2.33,4.01-6.85,1.68-10.11-2.33-3.26-6.86-4.01-10.11-1.68-2.07,1.48-4.09,3.01-6.08,4.59-.33-.42-.67-.84-1.01-1.27-1.94-2.46-4-5.09-5.57-7.29-.78-1.09-1.44-2.08-1.87-2.79-.21-.35-.36-.64-.44-.79l-.04-.08v-.02s-.01,0-.01,0c-.79-2.55-2.91-4.47-5.55-4.97-2.73-.52-5.49,.55-7.16,2.77-2.28,3.03-4.55,6.07-6.83,9.1-.48-.21-.98-.37-1.5-.47-2.21-.44-4.51,.19-6.2,1.68-1.69,1.49-3.57,2.62-5.6,3.39-2.03,.77-4.19,1.17-6.47,1.17-.7,0-1.41-.04-2.12-.12-1.63-.18-3.26,.2-4.65,1.07-2.88,1.82-5.42,4.03-7.86,6.38-3.64,3.52-7.02,7.37-10.24,10.74-1.6,1.69-3.16,3.25-4.62,4.57-1.46,1.32-2.84,2.4-4.02,3.15-4.9,3.09-9.8,6.17-14.69,9.26-2.46,1.55-4.66,3.22-6.7,4.59-1.02,.68-1.98,1.29-2.86,1.77-.86,.47-1.63,.82-2.28,1.04-.02-.04-.05-.08-.07-.14h0c-.06-.17-.07-.21-.07-.37,0-.12,.02-.3,.08-.58,.1-.42,.33-1.03,.71-1.77,.38-.74,.9-1.59,1.49-2.5,2.4-3.71,5-7.32,7.76-10.83,1.99-2.53,2.08-6.05,.21-8.67-1.86-2.62-5.21-3.7-8.26-2.66-.77,.26-1.53,.51-2.28,.74-1.51,.46-2.97,.92-4.28,1.24-1.31,.32-2.47,.49-3.25,.48-.56,0-.9-.07-1.08-.13-.18-.07-.21-.09-.36-.21-.22-.21-.41-.43-.59-.72-.27-.43-.52-1.04-.71-1.88-.19-.83-.3-1.86-.3-3.03,0-1.93,.3-4.2,.78-6.42,.48-2.22,1.13-4.38,1.76-6.19,2.71-7.92,7.49-15.22,13.73-20.53,4.17-3.56,8.89-6.23,13.91-8.03,5.02-1.79,10.34-2.7,15.71-2.7s10.52,.87,15.57,2.6c0,0,0,0,0,0,1.43,.49,2.84,1.05,4.23,1.68,3.64,1.65,7.94,.04,9.6-3.6,1.65-3.64,.04-7.94-3.6-9.6h0c-1.81-.82-3.65-1.55-5.52-2.19,0,0,0,0,0,0-6.58-2.26-13.44-3.39-20.28-3.39s-13.96,1.18-20.58,3.54c-6.62,2.36-12.89,5.92-18.44,10.65-8.4,7.17-14.52,16.62-18.04,26.85-.76,2.21-1.57,4.88-2.21,7.82-.64,2.94-1.11,6.15-1.11,9.5,0,2.7,.31,5.51,1.23,8.33,.46,1.41,1.09,2.82,1.92,4.17,.83,1.35,1.86,2.64,3.1,3.78,1.68,1.56,3.66,2.67,5.62,3.32,.72,.24,1.44,.41,2.14,.54-.51,.88-1.01,1.84-1.48,2.9-.46,1.04-.87,2.18-1.18,3.42-.31,1.25-.51,2.61-.51,4.06,0,1.88,.35,3.91,1.15,5.84,1.09,2.67,2.9,5,5.23,6.64,2.33,1.64,5.2,2.58,8.14,2.57,1.59,0,3.18-.27,4.71-.78h0c1.7-.58,3.24-1.31,4.67-2.09,2.14-1.18,4.03-2.47,5.76-3.68,1.72-1.2,3.27-2.32,4.56-3.13,4.9-3.09,9.8-6.17,14.69-9.26,2.88-1.82,5.42-4.03,7.86-6.38,3.64-3.52,7.03-7.37,10.24-10.74,1.6-1.68,3.16-3.25,4.62-4.57,.78-.71,1.54-1.34,2.25-1.89,.27,0,.55,.02,.82,.02,4.01,0,7.93-.72,11.6-2.11,1.76-.67,3.46-1.49,5.08-2.45,1.11,.36,2.22,.53,3.26,.53,1.95,0,3.68-.5,5.21-1.27,1.53-.79,2.91-1.88,4.05-3.38h0c.9-1.2,1.8-2.4,2.7-3.59,1.73,2.28,3.55,4.58,5.15,6.6-.48,.34-.96,.69-1.47,1.04-1.99,1.38-4.18,2.82-6.44,4.32-3.39,2.25-6.94,4.63-10.25,7.27-1.65,1.32-3.25,2.7-4.74,4.2-1.49,1.5-2.87,3.1-4.08,4.89h0c-.62,.93-1,1.89-1.21,2.75h0Z"/>
                                                </g>
                                                </g>
                                            </g>
                                        </svg>
                                    </div>

                                    <div class="text-container-text">
                                        <p style="font-weight: bold;">
                                        Remote Signature
                                        </p>
                                    </div>
                                </div>

                                <div class="tech-image-text">
                                    <div class="text-container-svg">
                                        <svg class="technology-svg" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 82.5 61.54">
                                            <g id="Layer_1-2" data-name="Layer 1">
                                                <path d="M59.19,60.29H23.31c-.87,0-1.61-.65-1.71-1.52l-.56-4.73c-.12-1.02,.68-1.92,1.71-1.92H59.74c1.03,0,1.83,.9,1.71,1.92l-.56,4.73c-.1,.87-.84,1.52-1.71,1.52Z" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <line x1="56.08" y1="56.43" x2="57.02" y2="56.43" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <path d="M59.19,52.12H23.31c-.87,0-1.61-.65-1.71-1.52l-.56-4.73c-.12-1.02,.68-1.92,1.71-1.92H59.74c1.03,0,1.83,.9,1.71,1.92l-.56,4.73c-.1,.87-.84,1.52-1.71,1.52Z" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <line x1="56.08" y1="48.25" x2="57.02" y2="48.25" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <path d="M59.19,43.95H23.31c-.87,0-1.61-.65-1.71-1.52l-.56-4.73c-.12-1.02,.68-1.92,1.71-1.92H59.74c1.03,0,1.83,.9,1.71,1.92l-.56,4.73c-.1,.87-.84,1.52-1.71,1.52Z" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <path d="M61.13,36.48l-5.52-8.09c-.44-.55-1.17-.89-1.95-.89H28.84c-.78,0-1.51,.33-1.95,.89l-5.52,8.09" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <line x1="56.08" y1="40.08" x2="57.02" y2="40.08" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <line x1="25.4" y1="56.43" x2="26.34" y2="56.43" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <line x1="30.57" y1="56.43" x2="31.5" y2="56.43" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <line x1="25.4" y1="48.25" x2="26.34" y2="48.25" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <line x1="30.57" y1="48.25" x2="31.5" y2="48.25" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <line x1="25.4" y1="40.08" x2="26.34" y2="40.08" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <line x1="30.57" y1="40.08" x2="31.5" y2="40.08" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <path d="M68.01,43.93c2.55,0,.72,0,1.5,0,6.48,0,11.73-5.25,11.73-11.73s-5.25-11.73-11.73-11.73c-1.9,0-3.67,.49-5.26,1.3-.45-11.39-9.76-20.5-21.26-20.5-10.37,0-18.99,7.4-20.92,17.2-2.07-1.26-4.48-2.02-7.08-2.02-7.59,0-13.75,6.16-13.75,13.75s6.16,13.75,13.75,13.75" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <path d="M42,8.87c-6.06,0-11.3,4.31-12.46,10.25" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                                <path d="M14,24.05c-2.83,0-5.13,2.3-5.13,5.13" style="fill: none; stroke: #1e1e1e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.5px;"/>
                                            </g>
                                        </svg>
                                    </div>

                                    <div class="text-container-text">
                                        <p style="font-weight: bold;">
                                        Record Retention
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="button-container-card">
                        <button class="main-button-blue-white" @click="CardFourAnimation()">Learn about our support team</button>
                    </div>
                </div>

                <div class="text-container-back">
                    <div class="shape-container">
                        <div class="shape-one">
                            <h2>Premium Services</h2>
                        </div>
                    </div>
                    <div class="text-container">
                        <div class="text-container-inner">
                            <p>Throughout the journey, our leading-edge customer care crew is here for you.</p>

                            <ul v-if="toggleSupportTeam" class="support-team-list-container" style="margin-top: 5px; margin-bottom: 5px;">
                                <li style="--animation-order: 1;">Account Manager</li>
                                <li style="--animation-order: 2;">Phone Support</li>
                                <li style="--animation-order: 3;">Email Support</li>
                                <li style="--animation-order: 4;">Automated Notifications</li>
                                <li style="--animation-order: 5;">Custom reporting</li>
                            </ul>
                        </div>
                    </div>
                    <div class="button-container-card">
                        <button class="main-button-blue-white" @click="CardFourAnimation()">See less information</button>
                    </div>
                </div>
            </div>

            <div class="card-five">
                <div class="text-container-front">
                    <div class="shape-container">
                        <div class="shape-two">
                        <h2>Networks</h2>
                        </div>
                    </div>

                    <div class="text-container">
                        <div class="text-container-inner">

                        <!-- <p class="shipping-options-more-info">
                            We scale our Next Day pricing to fit your business model.
                        </p> -->
                        <div class="svg-wrapper">
                            <svg width="150" height="150" viewBox="0 0 150 150" xmlns="http://www.w3.org/2000/svg">
                            <!-- Center circle -->
                            <circle cx="75" cy="75" r="22" fill="#33f18a" stroke="black" stroke-width="3"/>

                            <!-- Top (slightly shorter) -->
                            <line x1="75" y1="53" x2="75" y2="18" stroke="black" stroke-width="3"/>
                            <circle cx="75" cy="12" r="10" fill="white" stroke="black" stroke-width="3"/>

                            <!-- Top-right (longer) -->
                            <line x1="90" y1="60" x2="125" y2="28" stroke="black" stroke-width="3"/>
                            <circle cx="130" cy="23" r="10" fill="white" stroke="black" stroke-width="3"/>

                            <!-- Right (shorter) -->
                            <line x1="97" y1="75" x2="138" y2="75" stroke="black" stroke-width="3"/>
                            <circle cx="143" cy="75" r="10" fill="white" stroke="black" stroke-width="3"/>

                            <!-- Bottom-left (longer) -->
                            <line x1="60" y1="90" x2="20" y2="120" stroke="black" stroke-width="3"/>
                            <circle cx="15" cy="125" r="10" fill="white" stroke="black" stroke-width="3"/>

                            <!-- Left (shorter) -->
                            <line x1="53" y1="75" x2="10" y2="75" stroke="black" stroke-width="3"/>
                            <circle cx="5" cy="75" r="10" fill="white" stroke="black" stroke-width="3"/>

                            <!-- Top-left (medium length) -->
                            <line x1="60" y1="60" x2="28" y2="38" stroke="black" stroke-width="3"/>
                            <circle cx="23" cy="33" r="10" fill="white" stroke="black" stroke-width="3"/>
                            </svg>
                        </div>
                        

                        <div class="pricing-container">
                            <div class="pricing-inner">
                                <h2>Multi-Partner Delivery Network</h2>
                                <p style="font-size: .9em; margin-top: 25px">Connect to regional carriers, contractors, and national services—all orchestrated within one platform.</p>
                            </div>
                        </div>

                        <!-- <div class="pricing-container">
                            <div v-if="sliderValue-1 < 1500" class="pricing-inner">
                                <h2>Emerging</h2>
                                <p style="font-size: .8em;">Light volume. Best for growing businesses with now and again use.</p>
                            </div>
                            <div v-if="(sliderValue-1 >= 1500)  && (sliderValue < 3000)" class="pricing-inner">
                                <h2>Established</h2>
                                <p style="font-size: .8em;">Steady Volume. Best for serious businesses looking to expand their delivery footprint.</p>
                            </div>
                            <div v-if="(sliderValue-1 >= 3000)" class="pricing-inner">
                                <h2>Empire</h2>
                                <p style="font-size: .8em;">Abundant Volume. Best for enterprise businesses with powerful reach & multiple locations.</p>
                            </div>
                        </div>

                        <div class="slidecontainer">
                            <p style="margin-bottom: 10px;" v-if="sliderValue == 1">Shipments: <span class="shipment-value">1</span></p>
                            <p style="margin-bottom: 10px;" v-else-if="sliderValue-1 == 250">Shipments: <span class="shipment-value">200</span></p>
                            <p style="margin-bottom: 10px;" v-else-if="sliderValue-1 == 3000">Shipments: <span class="shipment-value">3000+</span></p>
                            <p style="margin-bottom: 10px;" v-else>Shipments: <span class="shipment-value">{{sliderValue-1}}</span></p>
                        </div>

        

                        <div class="slidecontainer">
                            <input type="range" v-model="sliderValue" min="1" max="3001" step="250" class="slider" id="myRange">
                        </div>


                        <div class="pricing-container">
                            <div v-if="sliderValue-1 < 1500" class="pricing-inner">
                                <p v-if="sliderValue == 1" class="price-text">$10.00<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 250" class="price-text">$10.00<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 500" class="price-text">$9.75<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 750" class="price-text">$9.50<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 1000" class="price-text">$9.25<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 1250" class="price-text">$9.00<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                
                            </div>
                            <div v-if="(sliderValue-1 >= 1500)  && (sliderValue < 3000)" class="pricing-inner">
                                <p v-if="sliderValue-1 == 1500" class="price-text">$8.75<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 1750" class="price-text">$8.50<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 2000" class="price-text">$8.25<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 2250" class="price-text">$8.00<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 2500" class="price-text">$7.75<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 2750" class="price-text">$7.50<span style="font-size: .5em; color: #00000083;">/per</span></p>
                            </div>
                            <div v-if="(sliderValue-1 >= 3000)" class="pricing-inner">
                                <p class="price-text">Custom<span style="font-size: .5em; color: #00000083;">/per</span></p>
                            </div>
                        </div> -->

                        </div>
                    </div>
                    <!-- <div class="button-container-card">
                        <button class="main-button-blue-white" @click="CardFiveAnimation()">Click here for more information</button>
                    </div> -->
                </div>

                <div class="text-container-back">
                    <div class="shape-container">
                        <div class="shape-two">
                            <h2>Pricing Options</h2>
                        </div>
                    </div>
                    <div class="text-container">
                        <div class="text-container-inner">

                        <p class="shipping-options-more-info">
                           Let our experts review your delivery program to see how we can best serve you and your customers' needs. 
                        </p>

                        <div v-if="!inquirySent" class="pricing-contact-form">
                            <input v-model="PricingInput.name" type="text" placeholder="Contact Name">
                            <input v-model="PricingInput.companyName" type="text" placeholder="Company Name">
                            <input v-model="PricingInput.email" type="text" placeholder="Email">
                            <input v-model="PricingInput.phone" type="text" placeholder="Phone">
                            <textarea v-model="PricingInput.message" rows="3" type="text" placeholder="Message"></textarea>
                            <button @click="SendPricingEmail()" class="main-button-orange-white">Send</button>
                        </div>


                        <div v-if="toggleAlertBox" class="alert-box-container">
                            <div class="alert-box">
                             <p>{{alertMessage}}</p>
                            </div>  
                        </div>

                        <div v-if="submittingInfo" class="alert-box-container">
                            <div class="alert-box">
                                <p>Submitting Information</p>
                                <div class="dot-container">
                                    <div class="dot1"></div>
                                    <div class="dot2"></div>
                                    <div class="dot3"></div>
                                </div>
                            </div>
                        </div>

                        <div v-if="inquirySent" class="inquiry-sent">
                            <h2>Inquiry Sent</h2>
                            <div class="check-container">
                                <div class="check"></div>
                            </div>
                        </div>

                        </div>
                    </div>
                    <div class="button-container-card">
                        <button class="main-button-blue-white" @click="CardFiveAnimation()">See less information</button>
                    </div>
                </div>
            </div>

            <!-- <div class="card-five">
                <div class="text-container-front">
                    <div class="shape-container">
                        <div class="shape-two">
                        <h2>Pricing Options</h2>
                        </div>
                    </div>

                    <div class="text-container">
                        <div class="text-container-inner">

                        <p class="shipping-options-more-info">
                            We scale our Next Day pricing to fit your business model.
                        </p>

                        <div class="pricing-container">
                            <div v-if="sliderValue-1 < 1500" class="pricing-inner">
                                <h2>Emerging</h2>
                                <p style="font-size: .8em;">Light volume. Best for growing businesses with now and again use.</p>
                            </div>
                            <div v-if="(sliderValue-1 >= 1500)  && (sliderValue < 3000)" class="pricing-inner">
                                <h2>Established</h2>
                                <p style="font-size: .8em;">Steady Volume. Best for serious businesses looking to expand their delivery footprint.</p>
                            </div>
                            <div v-if="(sliderValue-1 >= 3000)" class="pricing-inner">
                                <h2>Empire</h2>
                                <p style="font-size: .8em;">Abundant Volume. Best for enterprise businesses with powerful reach & multiple locations.</p>
                            </div>
                        </div>

                        <div class="slidecontainer">
                            <p style="margin-bottom: 10px;" v-if="sliderValue == 1">Shipments: <span class="shipment-value">1</span></p>
                            <p style="margin-bottom: 10px;" v-else-if="sliderValue-1 == 250">Shipments: <span class="shipment-value">200</span></p>
                            <p style="margin-bottom: 10px;" v-else-if="sliderValue-1 == 3000">Shipments: <span class="shipment-value">3000+</span></p>
                            <p style="margin-bottom: 10px;" v-else>Shipments: <span class="shipment-value">{{sliderValue-1}}</span></p>
                        </div>

        

                        <div class="slidecontainer">
                            <input type="range" v-model="sliderValue" min="1" max="3001" step="250" class="slider" id="myRange">
                        </div>


                        <div class="pricing-container">
                            <div v-if="sliderValue-1 < 1500" class="pricing-inner">
                                <p v-if="sliderValue == 1" class="price-text">$10.00<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 250" class="price-text">$10.00<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 500" class="price-text">$9.75<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 750" class="price-text">$9.50<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 1000" class="price-text">$9.25<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 1250" class="price-text">$9.00<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                
                            </div>
                            <div v-if="(sliderValue-1 >= 1500)  && (sliderValue < 3000)" class="pricing-inner">
                                <p v-if="sliderValue-1 == 1500" class="price-text">$8.75<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 1750" class="price-text">$8.50<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 2000" class="price-text">$8.25<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 2250" class="price-text">$8.00<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 2500" class="price-text">$7.75<span style="font-size: .5em; color: #00000083;">/per</span></p>
                                <p v-if="sliderValue-1 == 2750" class="price-text">$7.50<span style="font-size: .5em; color: #00000083;">/per</span></p>
                            </div>
                            <div v-if="(sliderValue-1 >= 3000)" class="pricing-inner">
                                <p class="price-text">Custom<span style="font-size: .5em; color: #00000083;">/per</span></p>
                            </div>
                        </div>

                        </div>
                    </div>
                    <div class="button-container-card">
                        <button class="main-button-blue-white" @click="CardFiveAnimation()">Click here for more information</button>
                    </div>
                </div>

                <div class="text-container-back">
                    <div class="shape-container">
                        <div class="shape-two">
                            <h2>Pricing Options</h2>
                        </div>
                    </div>
                    <div class="text-container">
                        <div class="text-container-inner">

                        <p class="shipping-options-more-info">
                           Let our experts review your delivery program to see how we can best serve you and your customers' needs. 
                        </p>

                        <div v-if="!inquirySent" class="pricing-contact-form">
                            <input v-model="PricingInput.name" type="text" placeholder="Contact Name">
                            <input v-model="PricingInput.companyName" type="text" placeholder="Company Name">
                            <input v-model="PricingInput.email" type="text" placeholder="Email">
                            <input v-model="PricingInput.phone" type="text" placeholder="Phone">
                            <textarea v-model="PricingInput.message" rows="3" type="text" placeholder="Message"></textarea>
                            <button @click="SendPricingEmail()" class="main-button-orange-white">Send</button>
                        </div>


                        <div v-if="toggleAlertBox" class="alert-box-container">
                            <div class="alert-box">
                             <p>{{alertMessage}}</p>
                            </div>  
                        </div>

                        <div v-if="submittingInfo" class="alert-box-container">
                            <div class="alert-box">
                                <p>Submitting Information</p>
                                <div class="dot-container">
                                    <div class="dot1"></div>
                                    <div class="dot2"></div>
                                    <div class="dot3"></div>
                                </div>
                            </div>
                        </div>

                        <div v-if="inquirySent" class="inquiry-sent">
                            <h2>Inquiry Sent</h2>
                            <div class="check-container">
                                <div class="check"></div>
                            </div>
                        </div>

                        </div>
                    </div>
                    <div class="button-container-card">
                        <button class="main-button-blue-white" @click="CardFiveAnimation()">See less information</button>
                    </div>
                </div>
            </div> -->
        </div>
    </div>

        <div style="display: none;" class="shipping-options">
            <h1>Shipping Options</h1>
            <div class="next-day-container">
                <div>Next Day</div>
                <p>Guaranteed next business day delivery for small packages and 
                    documents. Ship via web or integration with your system, pickup 
                    from your location or drop off in one of our many drop box locations 
                    across the state. Tracking, alerts, and photo delivery available in our 
                    primary service area.</p>
            </div>

            <div class="shipping-options-inner">
                <div>Shipping Options</div>
                <p><strong>Cold Store</strong>  – For packages that can’t stay overnight without it. <br>
                <strong>Signature Required</strong>  – To be sure your package is delivered to a human. <br>
                <strong>Priority Delivery</strong>  – Guaranteed delivery before 1pm. <br> 
                <strong>Court Priority</strong>  – Automatically added for deliveries to courthouses. Our 
                legal customers have relied on us for over 90 years to deliver their most important documents 
                and packages.</p>
            </div>

            <div class="same-day-container">
                <div>Same Day</div>
                <p>A premium courier service for your most important packages. 
                    Your package is our only package, we come and pickup when you 
                    tell us and deliver as quickly as we can get there. 
                    Available in our primary service area.</p>
            </div>

            <div class="priority-today-container">
                <div>Priority Today</div>
                <p>Volume Deliveries, pickup from your location and deliver in your local region all the features of 
                    Next Day but delivered Today. Available in limited areas, contact your account manager or our 
                    sales team to find out more.</p>
            </div>

            <div class="zip-ship-container">
                <div>ZipShip</div>
                <p>No Printer, No Paper, No Problem. Create a shipping label and email us the label and 
                your documents and leave the rest to us. We print, pack and deliver Next Day.</p>
            </div>
    </div>

    <!-- <div class="imageSliderContainer">
      <h1>We Support</h1>
      <div class="imageSlider">
        <div class="logo_arrow_left" @click="Imageprev"></div>
            <image-carousel 
            @Imagenext = 'Imagenext'
            @Imageprev = 'Imageprev'
            >
                <image-carousel-slide v-for="(image,index) in images" :key="image" :index="index" :visibleSlideImg ="visibleSlideImg" :direction="direction">
                <img loading="lazy" style="background-color: #fee354; border-radius: 999px;" :src="images[index-1]"/>
                <img loading="lazy" style="background-color: #ffcccc; border-radius: 999px;" :src="image"/>
                <img loading="lazy" style="background-color: #ff5534; border-radius: 999px;" :src="images[index+1]"/>
                </image-carousel-slide>
            </image-carousel>
            <div class="logo_arrow_right" @click="Imagenext"></div>
        </div>
    </div> -->


    <div class="imageSliderContainer">
      <h1>Industries We Serve</h1>
      <p>Trusted by compliance-driven businesses where speed, security, and precision matter most</p>
      <div class="imageSlider">
        <div class="logo_arrow_left" @click="Imageprev"></div>
            <image-carousel 
            @Imagenext = 'Imagenext'
            @Imageprev = 'Imageprev'
            >
                <image-carousel-slide v-for="(svgItem,index) in svgArray" :key="svgItem" :index="index" :visibleSlideImg ="visibleSlideImg" :direction="direction">
                    

                    <div class="svg-container" v-if="(index == 1) || (index == 3)">

                        <div class="svg1">
                            <svg class="svg-main-medical" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 859.09 742.62">
                                <g id="Layer_1-2" data-name="Layer 1">
                                    <path d="M844.27,471.2C919.83,234.38,694.84,14.93,434.12,76.7c-78.59,18.62-151.13,62.36-194.68,150.5C138.69,431.12,8.68,411.8,.21,558.22c-8.47,146.43,245.86,276.41,419.57,71.11,126.97-150.06,266.29,160.06,397.79-84.67,13.09-24.35,19.25-50.1,26.7-73.46Z" style="fill: #44c8f5;"/>
                                    <path d="M481.45,193.56c-30.68,24.48-37.75,52.16-38.41,70.7-7.71-22.48-16.2-43.51-24.64-62.5,59.33-43.58,28.45-88.36,28.45-88.36-29.29,24.26-36.36,51.11-37.05,69.63-.04-.08-.08-.17-.12-.25-12.03-25.32-24.29-47.92-35.21-66.7,53.68-55.5,13.54-94.8,13.54-94.8-26.34,32.12-26.08,62.22-22.19,80.25-11.88-19.58-21.31-33.43-25.72-39.72C317.22,1.47,265.56,0,265.56,0c14.32,58.57,49.03,65.41,65.87,65.07,3.46,4.88,13.68,19.58,26.98,41.54-46.99-23.88-83.19-.13-83.19-.13,46.16,40.65,78.93,25,92.06,15.09,10.68,18.42,22.63,40.5,34.36,65.21,1.22,2.56,2.44,5.19,3.67,7.85-42.89-36.53-85.44-19.12-85.44-19.12,40.62,52.69,78.44,37.74,90.68,30.69,8.84,19.95,17.72,42.17,25.67,65.92-41.49-34.84-82.87-18.78-82.87-18.78,37.3,50.27,73.22,40.62,87.64,33.62,15.94,51.57,26.84,109.36,23.49,166.55-.15,2.47,1.74,4.59,4.22,4.74,.49,.03,.97-.02,1.43-.15,1.81-.49,3.2-2.09,3.31-4.07,3.45-58.9-7.86-118.3-24.3-171.11,63.09-42.93,32.3-89.37,32.3-89.37Z" style="fill: #b5d3ef;"/>
                                    <path d="M406.26,332.94c-24.76,30.46-25.77,59.01-22.45,77.26-12.33-20.32-25.1-39.06-37.4-55.81,48.68-55.23,8.96-92.39,8.96-92.39-23.44,29.94-24.63,57.68-21.36,75.93-.06-.07-.11-.15-.17-.22-17.15-22.18-33.95-41.64-48.62-57.66,40.61-65.67-6.98-95.51-6.98-95.51-18.89,37-12.22,66.35-4.57,83.14-15.78-16.6-27.95-28.12-33.59-33.33-35.21-54.06-86-44.49-86-44.49,26.48,54.17,61.85,53.45,78.23,49.53,4.43,4.03,17.54,16.22,35.22,34.84-51-13.31-81.3,17.61-81.3,17.61,53.77,29.87,82.45,7.6,93.16-4.88,14.37,15.72,30.74,34.75,47.47,56.39,1.74,2.25,3.49,4.55,5.26,6.89-49.69-26.55-87.55-.47-87.55-.47,50.92,42.82,84.68,20.15,95.14,10.65,12.89,17.6,26.3,37.42,39.13,58.93-47.96-25.19-84.97-.68-84.97-.68,47.16,41.16,80.2,24.08,92.8,14.16,26.57,46.98,49.53,101.13,58.45,157.71,.38,2.45,2.68,4.12,5.13,3.73,.49-.08,.95-.23,1.36-.45,1.67-.86,2.68-2.72,2.37-4.68-9.18-58.28-32.9-113.91-60.22-161.99,52.48-55.39,12.51-94.2,12.51-94.2Z" style="fill: #b5d3ef;"/>
                                    <g>
                                    <g>
                                        <ellipse cx="607.41" cy="716.5" rx="59.81" ry="25.92" transform="translate(-42 37.83) rotate(-3.45)" style="fill: #d4e7f7;"/>
                                        <g>
                                        <path d="M637.98,696.29c.51,1.86-.03,15.92-.92,17.96-1.62,6.46-7.66,12.69-18.01,17.41-22.7,10.35-57.44,9.5-77.6-1.9-9.4-5.31-14.56-10.81-14.84-17.8-.39-3.78-.77-14.33-.77-14.33,.68-2.32,3.69,.02,5.51-2.18,2.99-4.31,8.09-8.33,15.29-11.61,22.7-10.35,57.44-9.5,77.6,1.9,8.49,4.8,13.02,4.55,13.74,10.55Z" style="fill: #036686;"/>
                                        <ellipse cx="581.93" cy="695.92" rx="56.11" ry="28.7" transform="translate(-14.33 12.23) rotate(-1.19)" style="fill: #017296;"/>
                                        </g>
                                        <path d="M578.39,738.83s22.46-8.11,27.24-17.25c0,0,32.44-7.35,32.55-26.41,0,0,.77,1.48-.63,16.61,0,0-.32,9.83-13.67,17.39,0,0-16.79,10.68-45.48,9.66Z" style="fill: #014c64;"/>
                                    </g>
                                    <polyline points="565.37 690.38 566.36 701.92 612.75 689.2" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.49px;"/>
                                    </g>
                                    <g>
                                    <path d="M254.93,450.34s-6.67,13.25-21.39,16.1c-11.07,2.14-15.57,10.1-20.31,22.08-7.58,19.17-26.6,9.83-29.51,38.31-1.79,17.46,31.1,41.72,59.51,27.44,28.41-14.28,62.23,24.47,59-58.15-.4-10.29-10.87-9.43-9.9-18.86,1.06-10.34-12.38-27.11-12.38-27.11l-25.02,.19Z" style="fill: #24396b; fill-rule: evenodd;"/>
                                    <path d="M272.6,494.64c-7.08-7.02,.85-12.32,.85-12.32l14.79-3.1c5.7,3.13,13.08,15.86,20.06,26.32,2.52,2.14,5.71,3.16,8.92,2.84l24.17-7.92,.56,4.52-22.84,16.8c-9.71,4.38-20.88-5.03-22.88-6.43,0,0-15.21-12.36-23.63-20.71Z" style="fill: #de593f;"/>
                                    <path d="M347.98,503.62h0c-.22,1.66-1.45,2.88-2.74,2.73l-4.65-1.8c-1.3-.15-.37-.17-.15-1.83h0c.22-1.66-.99-2.01,1.56-2.28l3.65,.52c.47,.07,.94,.2,1.37,.42,.79,.42,1.14,.93,.97,2.23Z" style="fill: #de593f;"/>
                                    <path d="M335.06,501.98s-1.02,5.22,.37,11.07l-11.54,7.68c-4.63,3.08-10.32,4.31-15.73,3.04-7.51-1.76-13.95-7.02-16.96-14.65-.06-.15-.12-.31-.18-.47-5.97-15.64-5.94-38.75-5.94-38.75,0,0,4.42,1.02,7.67,6.4,2.41,3.99,12.51,18.74,17.56,26.08,1.81,2.63,4.81,4.15,8,4.05l16.75-4.47Z" style="fill: #fff;"/>
                                    <path d="M224.63,719.68c13.76-6.09,37.31-7.55,52.6-3.25,2.61,.73,4.8,1.59,6.58,2.53,9.71-2.73,22.87-3.07,31.93-.52,10.74,3.02,11.62,8.93,1.95,13.21-9.29,4.11-24.92,5.21-35.66,2.61-.64,.33-1.31,.66-2.03,.98-13.76,6.09-37.31,7.55-52.6,3.25-15.29-4.29-16.53-12.71-2.77-18.8Z" style="fill: #d4e7f7;"/>
                                    <path d="M252.15,717.77l-.1,8.22c-.06,.86-.85,5.44-1.21,6.23-1.03,2.3-2.74,3.26-4.4,3.43-2.2,.22-6.66-3.59-5.12-8.55,1.34-4.32,4.03-11.23,4.03-11.23,3.12,1.35,4.56,1.97,6.8,1.9Z" style="fill: #24396b;"/>
                                    <path d="M300.4,723.66l-11.31-13.16c-1.74-.89-5-1.18-7.65-.65-1.19,.24-1.81,1.05-1.89,2.26l-.29,2.25c-.37,3.77-.83,5.01,1.48,6.19l13.67,7.01c2.81,2.16,10.74,.87,5.99-3.9Z" style="fill: #24396b;"/>
                                    <path d="M288.64,711.87s6.46,7.85,5.63,8.43c-3.45,2.43-11.59-4.96-11.59-4.96,0,0,4.47-3.84,5.96-3.47Z" style="fill: #de593f;"/>
                                    <path d="M282.68,715.34c3.13-.07,5.92,1.53,6.26-3.11-.27-25.9,5.27-47.95,5.03-72.16-.27-27.18-2.24-27.59-2.71-69.25l-24.85,4.79c4.83,29.82,7.06,67.61,7.06,67.61-6.36,29.25,4.15,36.57,9.21,72.12Z" style="fill: #de593f;"/>
                                    <path d="M245.48,718.21c1.92,4.53,5.66,5.72,6.41,1.12,2.06-25.87,10.23-47.28,12.17-71.46,2.18-27.15,.26-27.74,3.54-69.35l-25.12,2.47c2.11,30.21,.93,68.12,.93,68.12-8.95,28.6,.25,33.16,2.08,69.11Z" style="fill: #de593f;"/>
                                    <path d="M289.62,536.22s17.16-4.08,12.76,91.33c0,0-17.9,7.54-34.5,11.98-15.64,4.19-25.39-14.2-38.07-9.72,0,0,8.14-18.3,7.27-26.83-.88-8.53-5.1-58.4,8.88-60.13,13.97-1.72,43.67-6.64,43.67-6.64Z" style="fill: #4b6eb5;"/>
                                    <path d="M229.8,629.83s1.44-19.9,.56-28.44c-.88-8.53,2.52-64.23,16.5-65.95,3.19-.39,6.29,6.48,10.57,5.85-1.14,8.31-3.35,21.94-7.63,44.23-5.7,29.72,3.64,46.03,12.97,54.63-12.78-.31-22.8,.16-32.97-10.33Z" style="fill: #4264af;"/>
                                    <path d="M280.46,468.92c-1.25-.27-2.53-.35-3.82-.24-5.92,.52-14.16-1.51-14.77-1.06l-11.03,5.9c-21.17,8.18-9.01,15.3-15.51,25.75,0,0,13.15,19.37,13.79,27.8,.55,7.28-5.36,19.02-6.48,21.45-1.45,3.14,9.08,21.42,36.66,16.23,21.72-4.09,18.81-13.05,17.79-25.09-.64-7.58-6.16-27.52-6.33-33.55-.17-6.03,4.16-10.86,.54-20.31-3.62-9.45-6.23-15.88-6.23-15.88l-4.62-1Z" style="fill: #4b6eb5;"/>
                                    <path d="M266.66,473.39l.68-.7c1.73,.43,3.27,.17,3.63-1.58l2-9.87c.36-1.75-.77-3.53-2.5-3.96l-.51-.13c-1.73-.43-4.45,.03-4.81,1.78l-2.56,10.42c-.36,1.75,2.34,3.61,4.07,4.04Z" style="fill: #de593f;"/>
                                    <path d="M271.85,466.52s-4.22-.26-6.79-4.6c0,0,2.49,6.41,6.31,7.27l.48-2.67Z" style="fill: #bc4242;"/>
                                    <path d="M263.72,446.07c1.63-2.67,4-3.17,6.15-1.69,2.18-.96,4.73,.36,6.55,3.78,2.53,4.77,3.01,12.39,.64,16.29-1.03,1.7-2.62,2.09-4.11,2.14-1.39,.05-2.79-.21-4.12-.7-4.75-1.77-4.85-1.05-6.54-4.23-2.53-4.77-.95-11.71,1.42-15.6Z" style="fill: #de593f;"/>
                                    <path d="M266.73,447.74c-1.94,4.67-2.66,15.44-2.98,16.87,0,0-11.46,.27-9.67-10.79,2.23-13.76,11.45-7.39,11.45-7.39l1.19,1.31Z" style="fill: #24396b;"/>
                                    <path d="M263.35,449.56c5.37-2.08,9.8-3.72,17.64,3.44,.67-1.16-.74-5.15-2.39-6.46-3.44-2.75-5.18-4.24-9-5.19l-.93-.13c-5.63-.77-8.73,1.36-10.19,6.87-.13,.48-1.2,2.68-1.25,3.09l1.84-.57c-.41,3.27,1.06-1.58,4.29-1.05Z" style="fill: #24396b;"/>
                                    <path d="M273.9,463.38h0c1.09-.3,2.12-1.91,2.3-3.61l-3.95,1.07c-.18,1.7,.56,2.83,1.65,2.54Z" style="fill: #fff;"/>
                                    <path d="M260.57,459.11c-.16,1.54,.93,2.9,2.45,3.03,1.52,.13,2.88-1.01,3.04-2.56,.16-1.54-.93-2.9-2.45-3.03-1.52-.13-2.88,1.01-3.04,2.56Z" style="fill: #de593f;"/>
                                    <path d="M242.47,548.77c1.12-2.42,7.03-14.16,6.48-21.45-.36-4.77-2.91-13.27-5.05-19.75,7.34,13.1,7.67,17.87,15.96,18.94-12.42,21.25-2.59,29.29-2.97,36.91-20.94,.24-15.7-11.87-14.42-14.65Z" style="fill: #ced7a6;"/>
                                    <path d="M271.71,467.28l2.9,1.28s1.37,4.61-.97,6.64l-4.23-2.63s1.37-1.49,1.96-3.38l.34-1.91Z" style="fill: #fff;"/>
                                    <path d="M269.41,472.57l-2.61,4.32s-7.8-3.47-7.92-8.41l4.3-1.57s2.83,6.14,6.23,5.66Z" style="fill: #fff;"/>
                                    <path d="M251.89,719.33s-1.4,8.89-5.06,8.25c-3.65-.63-1.35-9.37-1.35-9.37l6.41,1.12Z" style="fill: #de593f;"/>
                                    <path d="M253.89,469.64c.94-.52,2.12-.04,2.42,.98,1.31,4.43,4.23,14.81,4.17,19.26-.08,5.73,3.02,51.39,3.02,51.39,0,0-3.7,72.15-1.63,82.86,0,0-23.33,3.98-34.56-3.87,0,0,.57-28.79,.68-34.52,.11-5.73,6.27-44.12,7.7-50.22s-3.07-47.92-3.07-47.92c0,0-1.41-7.52,12.3-13.61,4.61-2.05,7.38-3.47,8.96-4.34Z" style="fill: #fff;"/>
                                    <path d="M278.7,468.12c-.48-.14-.89,.36-.65,.8,1.38,2.59,4.56,9.11,5.51,16.01,1.23,8.9,2.03,31.95,2.03,31.95,0,0,5.59,31.45,6.25,41.35,.65,9.9-.02,59.77-.02,59.77,5.54-.13,13.81-2.82,16.76-7.73,0,0-3.82-32.44-5.32-39.47-1.5-7.03-4.51-33.01-4.51-33.01,0,0-3.8-23.24-3.39-29.25,.42-6.01-1.85-25-1.85-25l-8.27-13.58-6.53-1.84Z" style="fill: #fff;"/>
                                    <path d="M259.19,552.46l24.93-.76c2.46-.08,4.74-2.11,5.06-4.52l6.08-44.74c.33-2.41-1.42-4.32-3.87-4.24l-24.93,.76c-2.46,.08-4.74,2.11-5.06,4.52l-6.08,44.74c-.33,2.41,1.42,4.32,3.87,4.24Z" style="fill: #26326d;"/>
                                    <path d="M291.66,536.53h0c.08,1.5-1.03,2.74-2.47,2.75l-4.98,.02c-1.43,0-2.66-1.22-2.74-2.72h0c-.08-1.5,1.03-2.74,2.47-2.75l4.98-.02c1.43,0,2.66,1.22,2.74,2.72Z" style="fill: #de593f;"/>
                                    <path d="M235.45,492.68s-6.4,34.06,3.46,48.2,45.98-1.56,45.98-1.56l-1.06-4.97-30.83-2.46-2.3-38.94-15.25-.26Z" style="fill: #de593f;"/>
                                    <path d="M277.55,533.43l.09,11.78s-16.9,6.41-28.95,4.42c-12.05-1.99-17.51-13.31-17.6-25.68-.09-12.37,1.5-37.24,1.5-37.24l14.99-7.01,6.46,12.42,1.25,33.82s1.04,6.08,22.25,7.49Z" style="fill: #fff;"/>
                                    <path d="M344.81,504.75h0c.66,.24,1.41-.1,1.65-.76l18.03-48.86c.24-.66-.1-1.41-.76-1.65h0c-.66-.24-1.41,.1-1.65,.76l-18.03,48.86c-.24,.66,.1,1.41,.76,1.65Z" style="fill: #26326d;"/>
                                    <path d="M251.9,505.31s-1.12,16.44,1.49,20.49" style="fill: none; stroke: #b4c5d5; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.25px;"/>
                                    <line x1="296.94" y1="514.77" x2="296.3" y2="510.25" style="fill: none; stroke: #b4c5d5; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.25px;"/>
                                    </g>
                                    <g>
                                    <path d="M675.18,659.34l82.08-68.27c11.36-9.75,4.14-27.64-12.88-31.89l-246.19-61.51,176.99,161.67Z" style="fill: #d4e7f7;"/>
                                    <path d="M649.2,665.75l-246.17-67.58c-8.04-2.36-13.29-9.59-13.26-18.28l1.53-396.21c.06-14.73,14.7-26.62,28.56-23.18l246.19,61.24c8.45,2.1,14.06,9.5,14.03,18.49l-1.57,407.16c-.06,15.08-15.33,22.45-29.3,18.36Z" style="fill: #c1cde9;"/>
                                    <path d="M643.03,669.52l-246.17-67.58c-8.04-2.36-13.29-9.59-13.26-18.28l1.53-396.21c.06-14.73,14.7-26.62,28.56-23.18l246.19,61.24c8.45,2.1,14.06,9.5,14.03,18.49l-1.57,407.16c-.06,15.08-15.33,22.45-29.3,18.36Z" style="fill: #017296;"/>
                                    <polygon points="654.5 644.21 401.49 576.03 402.98 191.74 656.01 252.62 654.5 644.21" style="fill: #dfedf9;"/>
                                    <path d="M582.14,196.57l-14.21-4.53,.03-6.76c.09-18.74-14.95-38.9-33.41-44.79h0c-18.46-5.89-33.64,4.62-33.73,23.36l-.03,6.76-14.21-4.53c-13-4.15-23.68,3.25-23.75,16.45h0c-.06,13.2,10.52,27.39,23.52,31.54l95.54,30.5c13,4.15,23.68-3.25,23.75-16.45h0c.06-13.2-10.52-27.39-23.52-31.54Zm-46.48-21.48l-2.51-.8c-4.56-1.46-8.28-6.44-8.26-11.07,.02-4.63,3.77-7.23,8.34-5.78l2.51,.8c4.56,1.46,8.28,6.44,8.26,11.07-.02,4.63-3.77,7.23-8.34,5.78Z" style="fill: #7889c4;"/>
                                    <path d="M574.48,200.63l-14.21-3.87,.03-6.76c.09-18.74-14.95-38.19-33.41-43.22h0c-18.47-5.03-33.65,6.2-33.73,24.94l-.03,6.76-14.21-3.87c-13-3.54-23.69,4.36-23.75,17.56h0c-.06,13.2,10.53,26.89,23.53,30.43l95.57,26.01c13,3.54,23.69-4.36,23.75-17.56h0c.06-13.2-10.53-26.89-23.53-30.43Zm-46.49-19.3l-2.51-.68c-4.56-1.24-8.28-6.05-8.26-10.68s3.77-7.41,8.34-6.17l2.51,.68c4.56,1.24,8.28,6.05,8.26,10.68-.02,4.63-3.77,7.41-8.34,6.17Z" style="fill: #bdd0eb;"/>
                                    </g>
                                    <path d="M714.02,181.37c.14,4.29-3.22,7.89-7.51,8.03-4.29,.14-7.89-3.22-8.03-7.51-.14-4.29,3.22-7.89,7.51-8.03,4.29-.14,7.89,3.22,8.03,7.51Z" style="fill: none; fill-rule: evenodd; stroke: #243c7c; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.43px;"/>
                                    <path d="M145.65,324.82c.14,4.29-3.22,7.89-7.51,8.03-4.29,.14-7.89-3.22-8.03-7.51-.14-4.29,3.22-7.89,7.51-8.03,4.29-.14,7.89,3.22,8.03,7.51Z" style="fill: none; fill-rule: evenodd; stroke: #243c7c; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.43px;"/>
                                    <path d="M804.28,587.68c.14,4.29-3.22,7.89-7.51,8.03-4.29,.14-7.89-3.22-8.03-7.51-.14-4.29,3.22-7.89,7.51-8.03,4.29-.14,7.89,3.22,8.03,7.51Z" style="fill: none; fill-rule: evenodd; stroke: #243c7c; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.43px;"/>
                                    <path class="animate-medical-card" d="M626.45,522.81h0c-49.64-32.5-86.34-71.41-85.8-122.74l1.26-120.44,89.61-16.88,88.77,63.51-1.26,120.44c.83,17.23-34.58,61.15-92.58,76.11Z" style="fill: #017296;"/>
                                    <path class="animate-medical-card" d="M557.63,302.87l71.67-13.5,70.99,50.79-1.01,96.33c-3.62,20.14-27.86,48.72-71.57,66.21-33.47-31.3-71.52-62.45-71.09-103.5l1.01-96.33Z" style="fill: #fff;"/>
                                    <g class="animate-medical-card">
                                    <polygon points="638.19 430.98 609.08 423.53 609.55 341.85 638.66 349.31 638.19 430.98" style="fill: #017296;"/>
                                    <polygon points="584.81 391.42 584.98 360.92 662.94 380.9 662.77 411.39 584.81 391.42" style="fill: #017296;"/>
                                    </g>
                                    <g class="animate-medical-card-two">
                                    <path  d="M373.97,536.21l3.31-157.75c.2-9.45,9.69-14.89,21.09-12.1l117.94,28.94c11.4,2.8,20.56,12.82,20.37,22.27l-3.31,157.75c-.2,9.45-9.69,14.89-21.09,12.1l-117.94-28.94c-11.4-2.8-20.56-12.82-20.36-22.27Z" style="fill: #fff;"/>
                                    <path d="M450.55,545.92h0c-25.66-16.9-44.56-37.29-44.02-64.54l1.26-63.96,46.7-9.61,45.86,33.07-1.26,63.96c.34,9.14-18.3,32.72-48.54,41.09Z" style="fill: #f47f4f;"/>
                                    <g>
                                        <polygon points="457.12 497.07 442.01 493.32 442.67 449.96 457.78 453.7 457.12 497.07" style="fill: #fff;"/>
                                        <polygon points="429.55 476.45 429.79 460.26 470.25 470.3 470 486.49 429.55 476.45" style="fill: #fff;"/>
                                    </g>
                                    </g>
                                </g>
                            </svg>
                        </div>

                        <div class="svg2">
                            <svg class="svg-main-lawyer" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 710.81 636.06">
                                <g id="Layer_1-2" data-name="Layer 1">
                                    <path d="M652.53,267.85c85.45,103.67,37.35,213.63-22.33,266.46-15.76,13.95-40.38,20.53-59.01,23.86-100.24,17.9-115.69-89.66-215.14-82.87s-206.23,76.6-321.15-92.85S115.08,14.18,241.42,2.28c204.77-19.3,262.56,85.36,411.11,265.57Z" style="fill: #33f18a; fill-rule: evenodd;"/>
                                    <path d="M589.42,127.14c-1.58,4.38-6.41,6.66-10.79,5.08-4.38-1.58-6.66-6.41-5.08-10.79,1.58-4.38,6.41-6.66,10.79-5.08,4.38,1.58,6.66,6.41,5.08,10.79Z" style="fill: none; fill-rule: evenodd; stroke: #3a2712; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.79px;"/>
                                    <circle cx="29.09" cy="415.54" r="8.43" transform="translate(-359.4 265.19) rotate(-64.84)" style="fill: none; stroke: #3a2712; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.79px;"/>
                                    <path d="M150.58,43.93c-1.58,4.38-6.41,6.66-10.79,5.08s-6.66-6.41-5.08-10.79c1.58-4.38,6.41-6.66,10.79-5.08,4.38,1.58,6.66,6.41,5.08,10.79Z" style="fill: none; fill-rule: evenodd; stroke: #3a2712; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.79px;"/>
                                    <path d="M408.52,334.26v-4.63c0-8.48-6.88-15.36-15.36-15.36h-106.8c-8.48,0-15.36,6.88-15.36,15.36v4.64c-9.32,1.06-16.56,8.96-16.56,18.56v9.52c0,5.06,4.1,9.17,9.17,9.17h152.35c5.06,0,9.17-4.1,9.17-9.17v-9.52c0-9.62-7.26-17.53-16.6-18.57Z" style="fill: #735530;"/>
                                    <path d="M416.4,371.52c5.06,0,9.17-4.1,9.17-9.17v-9.52c0-9.62-7.26-17.53-16.6-18.57v-4.63c0-8.48-6.88-15.36-15.36-15.36h-19.11c-25.3,33.59-60.07,49.62-86.67,57.25h128.57Z" style="fill: #5f4727;"/>
                                    <g>
                                    <g>
                                        <ellipse cx="307.62" cy="622.04" rx="306.92" ry="14.02" style="fill: #ecded4;"/>
                                        <path d="M84.66,617.52h222.96s0-94.02,0-94.02H84.66c21.68,0,21.68,94.02,0,94.02Z" style="fill: #f9f2ed;"/>
                                        <path d="M85.61,526.35h222.01v-11.42H85.61c-3.15,0-5.71,2.56-5.71,5.71h0c0,3.15,2.56,5.71,5.71,5.71Z" style="fill: #2bb8d8;"/>
                                        <path d="M86.04,623.65h221.58v-12.27H86.04c-3.39,0-6.14,2.75-6.14,6.14h0c0,3.39,2.75,6.14,6.14,6.14Z" style="fill: #2bb8d8;"/>
                                        <path d="M248.24,514.93h230.45c4.93,0,4.93,108.73,0,108.73H248.24c26.14,0,26.14-108.73,0-108.73Z" style="fill: #2bb8d8;"/>
                                        <path d="M263.67,514.93h260.54c19.07,0,34.53,15.46,34.53,34.53v39.66c0,19.07-15.46,34.53-34.53,34.53H263.67c26.14,0,26.14-108.73,0-108.73Z" style="fill: #32ccfe;"/>
                                        <line x1="248.24" y1="539.36" x2="108.46" y2="539.36" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <line x1="248.24" y1="561.25" x2="108.46" y2="561.25" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <line x1="248.24" y1="583.14" x2="108.46" y2="583.14" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <line x1="248.24" y1="605.04" x2="108.46" y2="605.04" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <g>
                                        <rect x="108.46" y="448.58" width="22.99" height="60.01" style="fill: #98928a;"/>
                                        <g>
                                            <path d="M119.95,504.9h216.22s0-53.46,0-53.46H119.95c-2.53,19.42-2.61,37.29,0,53.46Z" style="fill: #f9f2ed;"/>
                                            <path d="M114.17,454.3h222.01v-11.42H114.17c-3.15,0-5.71,2.56-5.71,5.71h0c0,3.15,2.56,5.71,5.71,5.71Z" style="fill: #98928a;"/>
                                            <path d="M114.59,514.73h221.58v-12.27H114.59c-3.39,0-6.14,2.75-6.14,6.14h0c0,3.39,2.75,6.14,6.14,6.14Z" style="fill: #98928a;"/>
                                            <path d="M280.5,442.87h255.67c9.16,0,16.59,2.26,16.59,11.42-15.31,14.11-17.87,36.69,0,48.16,0,9.16-7.43,12.27-16.59,12.27h-255.67v-71.86Z" style="fill: #7d756a;"/>
                                            <path d="M280.5,454.29h272.26c-10.65,16.99-10.07,32.99,0,48.16H280.5c-2.75-16.47-3.16-32.59,0-48.16Z" style="fill: #e0d5cc;"/>
                                            <line x1="271.23" y1="467.3" x2="131.45" y2="467.3" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                            <line x1="271.23" y1="489.2" x2="131.45" y2="489.2" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        </g>
                                        </g>
                                        <g>
                                        <path d="M177.86,438.73h150.42s0-63.43,0-63.43H177.86c14.63,0,14.63,63.43,0,63.43Z" style="fill: #f9f2ed;"/>
                                        <path d="M178.5,377.42h149.78s0-7.71,0-7.71H178.5c-2.13,0-3.85,1.72-3.85,3.85h0c0,2.13,1.73,3.85,3.85,3.85Z" style="fill: #ecaf7e;"/>
                                        <path d="M174.65,434.79h149.49c2.28,0,4.14,1.85,4.14,4.14h0c0,2.28-1.85,4.14-4.14,4.14H174.65v-8.28h0Z" transform="translate(502.93 877.86) rotate(-180)" style="fill: #ecaf7e;"/>
                                        <path d="M288.22,369.52h155.48c3.33,0,3.33,73.35,0,73.35h-155.48c17.64,0,17.64-73.35,0-73.35Z" style="fill: #ecaf7e;"/>
                                        <path d="M298.63,369.52h175.78c12.87,0,23.3,10.43,23.3,23.3v26.76c0,12.87-10.43,23.3-23.3,23.3h-175.78c17.64,0,17.64-73.35,0-73.35Z" style="fill: #f37f4f;"/>
                                        <line x1="288.22" y1="386" x2="193.91" y2="386" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <line x1="288.22" y1="400.77" x2="193.91" y2="400.77" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <line x1="288.22" y1="415.54" x2="193.91" y2="415.54" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <line x1="288.22" y1="430.31" x2="193.91" y2="430.31" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        </g>
                                    </g>
                                    <path d="M394.33,623.65h-54.32c16.75,0,16.75-108.92,0-108.92h54.32c17.2,0,17.2,108.92,0,108.92Z" style="fill: #f9f2ed;"/>
                                    </g>
                                    <rect x="325.73" y="74.22" width="28.56" height="257.93" style="fill: #735530;"/>
                                    <path d="M349.28,90.44h-18.39c-8.38,0-15.67-5.72-17.66-13.85h0c-1.11-4.51,2.31-8.87,6.95-8.87h39.83c4.8,0,8.24,4.63,6.86,9.22l-.16,.55c-2.31,7.69-9.39,12.95-17.42,12.95Z" style="fill: #735530;"/>
                                    <path class="rotate-lawyer" d="M475.53,124.28H204.66c-3.81,0-6.92-3.12-6.92-6.92h0c0-3.81,3.12-6.92,6.92-6.92H475.53c3.81,0,6.92,3.12,6.92,6.92h0c0,3.81-3.12,6.92-6.92,6.92Z" style="fill: #5f4727;"/>
                                    <path class="rotate-scale" d="M158.76,208.35c-1.81,0-2.85,2.08-1.75,3.52,8.4,10.98,21.6,17.85,36.11,17.85h45.98c14.46,0,27.68-6.84,36.11-17.84,1.1-1.44,.06-3.52-1.75-3.52h-114.69Z" style="fill: #735530;"/>
                                    <polyline class="rotate-scale" points="158.76 208.35 216.1 122.96 273.44 208.35" style="fill: none; stroke: #5f4727; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px;"/>
                                    <path class="rotate-scale-two" d="M405.61,208.35c-1.81,0-2.85,2.08-1.75,3.52,8.4,10.98,21.6,17.85,36.11,17.85h45.98c14.46,0,27.68-6.84,36.11-17.84,1.1-1.44,.06-3.52-1.75-3.52h-114.69Z" style="fill: #735530;"/>
                                    <polyline class="rotate-scale-two" points="405.61 208.35 462.96 122.96 520.3 208.35" style="fill: none; stroke: #5f4727; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px;"/>
                                    <path d="M594.85,345.6s-5.38-.73-17.18,3.61c-14.92,5.49-34.66,12.72-37.42,15.71-2.76,2.98,11.3,15.09,11.3,15.09l41.1-8.78,2.2-25.63Z" style="fill: #c1ac9f; fill-rule: evenodd;"/>
                                    <path d="M564.51,625.59c0,2.76,32.75,5,73.15,5,40.4,0,73.15-2.24,73.15-5,0-2.76-32.75-5-73.15-5-40.4,0-73.15,2.24-73.15,5Z" style="fill: #ecded4; fill-rule: evenodd;"/>
                                    <path d="M642.83,351.94c-.24-1.37,.26-2.74,1.12-3.83,7.01-8.81-6.58-15.82-10.5-18.96-4.09-3.27,1.17-10.41-7.72-13.8-8.89-3.39-12.01,1.21-12.44,1.05-.62-.23,.74,8.77,.74,8.77,0,0,4.44,1.64,3.98,10.64-.46,9.01-3.04,13.59,2.22,20.9,5.26,7.31,27.72-.9,27.72-.9-3.67-.19-4.82-2.15-5.12-3.88Z" style="fill: #4a2a1b; fill-rule: evenodd;"/>
                                    <path d="M614.75,616.46s4.46-58.32-7.27-82.47l-5.51-79.03-27.24,10.05,31.26,151.94,8.77-.48Z" style="fill: #e2623d; fill-rule: evenodd;"/>
                                    <polygon points="664.74 617.61 655.63 599.47 670.77 595.37 674.27 618.2 664.74 617.61" style="fill: #e2623d; fill-rule: evenodd;"/>
                                    <path d="M609.73,465.62l17.51,60.33s12.93,59.7,24.21,76.97l25.73,.54-19.42-80.38-15-66.86-33.03,9.4Z" style="fill: #735530; fill-rule: evenodd;"/>
                                    <path d="M605.7,614.38l-7.62,5.55c-1.5,1.37-9.68,4.04-9.68,4.04h0c-.82,1.7,.78,2.6,2.13,2.83l24.13-.51s5.57-1.16,.63-11.9c-4.39,1.94-8.44,3.33-9.59-.01Z" style="fill: #4a2a1b; fill-rule: evenodd;"/>
                                    <path d="M673.54,614.47l7.62,5.55c1.5,1.37,9.68,4.04,9.68,4.04h0c.82,1.7-.78,2.6-2.13,2.83l-24.13-.51s-5.57-1.16-.63-11.9c4.39,1.94,8.44,3.33,9.59-.01Z" style="fill: #4a2a1b; fill-rule: evenodd;"/>
                                    <path d="M571.94,465.2l14.79,72.32,11.37,67.43h22.51s-2.62-12.16-2.31-16.02c.31-3.86,1.33-40.47-7.23-57.31l.68-68.59-39.81,2.18Z" style="fill: #735530; fill-rule: evenodd;"/>
                                    <path d="M611.27,531.61l.68-68.59-13.34,.73,1.09,40.52c-.09,9.36,.75,22.42,3.06,31.67,4.56,18.28,9.6,53.68,10.37,56.78,2.6,10.42-5.64,12.23-5.64,12.23h13.33s-2.62-12.16-2.31-16.02c.31-3.86,1.33-40.47-7.23-57.31Z" style="fill: #5f4727; fill-rule: evenodd;"/>
                                    <path d="M535.99,366.07c-15.07,.05-20.15-.89-35.28-1.19l-6.49,8.92c30.28,5.14,38.13,10.15,50.49,5.88,5.04-12.95-5.25-12.84-8.73-13.61Z" style="fill: #c85835;"/>
                                    <path d="M629.57,408.84l-52.49,4c-8.54,3.14-5.13,52.36-5.13,52.36l34.52,1.6c16.04-.33,35,12.24,37-14.48,2.28-30.54-13.89-43.48-13.89-43.48Z" style="fill: #735530; fill-rule: evenodd;"/>
                                    <path d="M642.83,455.92s-33.73,3.33-45.06-11.97l46.7-4.01s.48,10.64-1.63,15.98Z" style="fill: #5f4727; fill-rule: evenodd;"/>
                                    <path d="M592.18,346.3l19.28-2.26,5.29,.21,20.09,7.01c6.77,3.35,9.91,11.21,7.32,18.33l-4.92,23c-1.67,20.19,2.11,35.72,7.01,47.36-28.49,10.58-67.64,10.06-76.63-3.01,1.52-35.73,8.69-67.64,22.56-90.63Z" style="fill: #c1ac9f; fill-rule: evenodd;"/>
                                    <path d="M601.97,333.92s1.01,7.59,1.85,13.87c.22,1.67,1.32,3.1,2.87,3.72,1.55,.62,3.32,.35,4.62-.71,.43-.35,.84-.69,1.23-1.01,1.78-1.46,2.58-3.82,2.04-6.07-1.39-5.77-3.91-16.28-3.91-16.28l-8.7,6.48h0Z" style="fill: #c85835; fill-rule: evenodd;"/>
                                    <polygon points="602.17 338.1 603.12 342.6 606.89 338.1 602.17 338.1" style="fill: #863b25; fill-rule: evenodd;"/>
                                    <path d="M600.94,345.33s-6.32,15.64,4.42,16.32c10.73,.69,16.61-15.57,16.61-15.57l-7.84-3.48-13.19,2.73Z" style="fill: #c85835;"/>
                                    <path d="M614.53,325.77c.72-2.13-.41-4.43-2.51-5.15-2.24-.77-5.07-1.73-7.31-2.5-2.1-.72-4.07,.56-5.1,2.55-1.22,2.35-2.57,7.62-3.09,11.57-.29,2.22,.69,4.7,2.79,5.42,2.24,.77,9.69,.9,11.71-2.94,1.53-2.92,2.47-5.83,3.52-8.96h0Z" style="fill: #c85835; fill-rule: evenodd;"/>
                                    <path d="M620.81,336.17s-.05-11.51-2.8-15.26c-3.69-5.03-9.25-8.39-16.66-4.01,0,0,2.62,9.33,16.66,18.92l2.81,.35Z" style="fill: #4a2a1b; fill-rule: evenodd;"/>
                                    <path d="M614.02,335.01c-1.14,1.44-3.02,1.84-4.2,.88-1.18-.95-1.2-2.89-.06-4.33,1.14-1.44,3.02-1.84,4.2-.88,1.18,.95,1.2,2.89,.06,4.33Z" style="fill: #c85835; fill-rule: evenodd;"/>
                                    <path d="M597.91,330.94l3.67,1.17s-.87,2.51-2.57,1.74c-1.7-.77-1.1-2.91-1.1-2.91Z" style="fill: #fff; fill-rule: evenodd;"/>
                                    <path d="M657.91,405.89l-26.58-30.76c-5.79-5.77-5.03-15.35,1.59-20.14h0c2.61-1.89,6.25-1.33,8.18,1.25l26.09,33.13-9.28,16.52Z" style="fill: #c85835; fill-rule: evenodd;"/>
                                    <path d="M664.12,386.85c6.15,4.09,8.89,10.98,5.01,18.61l-26.16,32.64-4.28-7.59,15.47-27.38,9.97-16.28Z" style="fill: #c85835; fill-rule: evenodd;"/>
                                    <path d="M638.72,430.56l-1.01,7.55c-.2,1.51,.14,3.04,.98,4.32l3.37,5.17c1.17,1.8,3.79,1.87,5.06,.14h0l.73-9.56c.16-2.11-.52-4.35-1.89-6.26l-2.3-3.19-4.93,1.83Z" style="fill: #c85835;"/>
                                    <path d="M613.59,316.59s4.88-.3,5.87,6.59" style="fill: none; fill-rule: evenodd; stroke: #8a929b; stroke-linecap: round; stroke-linejoin: round; stroke-width: .89px;"/>
                                    <path d="M624.24,369.41l24.43,28.48,3.24,4.63-9.03,18.87,9.72,8.45,18.41-22.81s5.08-9.35-2.2-18.29c-7.28-8.95-27.04-33.59-27.04-33.59l-12.64-4.4-4.89,18.66Z" style="fill: #c1ac9f; fill-rule: evenodd;"/>
                                    <polyline points="640.45 387.57 632.1 376.33 632.72 372.53" style="fill: none; fill-rule: evenodd; stroke: #807262; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.44px;"/>
                                    <path d="M500.71,364.88l-9.41-3.23c-1.88-.65-3.93-.59-5.78,.14l-7.47,2.99c-2.6,1.04-3.36,4.37-1.47,6.44h0l12.06,3.39c2.66,.75,5.69,.45,8.49-.82l4.66-2.13-1.09-6.79Z" style="fill: #c85835;"/>
                                    <path d="M545.65,366.97s16.11,10.85,6.24,12.96c-17.59,3.76-47.86,.48-47.86,.48l3.22-16.03,39.91-1.82-1.51,4.41Z" style="fill: #c1ac9f;"/>
                                    <polyline points="582.79 361.67 583.58 365.48 579.38 378.03" style="fill: none; fill-rule: evenodd; stroke: #807262; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.44px;"/>
                                </g>
                                </svg>
                        </div>

                        <div class="svg3">
                            <svg class="svg-main-insurance" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 904.81 694.23">
                                <g id="Layer_1-2" data-name="Layer 1">
                                    <ellipse cx="444.43" cy="682.58" rx="332.47" ry="11.65" style="fill: #eae1d6;"/>
                                    <path d="M49.73,536.99S-33.93,425.1,15.77,343.45c49.71-81.65,177.49-2.9,230.16-68.54,52.68-65.64-10.68-219.88,159.29-268.54,169.96-48.66,222.05,198.1,293.83,188.05,0,0,147.9-23.98,199.37,142.32s-219.88,267.55-407.54,80.6c-187.66-186.95-215.37,373.58-441.16,119.65Z" style="fill: #fbcccc;"/>
                                    <g>
                                    <path d="M643.24,150.7c-10.08,26.93,2.29,45.79-37.85,93.2-15.28,18.05-23.73,49.38-28.34,81.27l46.28,83.25c38.84-36.11,78.81-103.73,71.64-133.55-7.21-29.97,2.72-53.29,24.02-82.98,38.74-54.01-1.42-127.84-1.42-127.84,0,0-57.9,42.76-74.33,86.65Z" style="fill: #dacdc6;"/>
                                    <path d="M692.48,128.39c-.84-.37-1.82,0-2.2,.84-35.58,79.97-66.45,152.66-90.52,236.79l2.29,4.13c24.14-85.32,55.29-158.71,91.26-239.56,.37-.84,0-1.82-.84-2.2Z" style="fill: #c3b6b0;"/>
                                    <path d="M645.84,318.82c-11.02,15.36-23.12,42.26-33.7,69.47l39.35,70.8c64.08-40.98,107.9-157.21,107.9-157.21,75.92,24.38,99.62-39.36,99.62-39.36-151.33-57.51-213.18,56.3-213.18,56.3Z" style="fill: #dacdc6;"/>
                                    <path d="M778.36,267.81c-.46,.15-46.99,15.83-90.08,52.51-25.35,21.57-44.59,46.09-57.19,72.86-2.59,5.49-4.88,11.09-6.91,16.77l2.28,4.1c13.76-40.61,39.79-70.59,63.9-91.12,42.6-36.28,88.59-51.8,89.05-51.95,.87-.29,1.35-1.23,1.06-2.1-.29-.87-1.23-1.35-2.1-1.06Z" style="fill: #c3b6b0;"/>
                                    </g>
                                    <rect x="252.25" y="157.58" width="419.81" height="521.61" rx="32.46" ry="32.46" style="fill: #b5aca7;"/>
                                    <path d="M508.35,61.09c-1.54,4.28-6.26,6.5-10.53,4.96-4.28-1.54-6.5-6.26-4.96-10.53,1.54-4.28,6.26-6.5,10.53-4.96,4.28,1.54,6.5,6.26,4.96,10.53Z" style="fill: none; fill-rule: evenodd; stroke: #3b2713; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.48px;"/>
                                    <path d="M781.32,417.14c-1.54,4.28-6.26,6.5-10.53,4.96-4.28-1.54-6.5-6.26-4.96-10.53,1.54-4.28,6.26-6.5,10.53-4.96,4.28,1.54,6.5,6.26,4.96,10.53Z" style="fill: none; fill-rule: evenodd; stroke: #3b2713; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.48px;"/>
                                    <path d="M152.31,243.86c-1.54,4.28-6.26,6.5-10.53,4.96-4.28-1.54-6.5-6.26-4.96-10.53,1.54-4.28,6.26-6.5,10.53-4.96,4.28,1.54,6.5,6.26,4.96,10.53Z" style="fill: none; fill-rule: evenodd; stroke: #3b2713; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.48px;"/>
                                    <g>
                                    <rect x="279.55" y="200.83" width="357.91" height="440.78" style="fill: #fff1e9;"/>
                                    <path d="M595.11,353.83H318.87c-2.46,0-4.45-1.99-4.45-4.45h0c0-2.46,1.99-4.45,4.45-4.45h276.24c2.46,0,4.45,1.99,4.45,4.45h0c0,2.46-1.99,4.45-4.45,4.45Z" style="fill: #f0e2da;"/>
                                    <path d="M595.11,393.22H318.87c-2.46,0-4.45-1.99-4.45-4.45h0c0-2.46,1.99-4.45,4.45-4.45h276.24c2.46,0,4.45,1.99,4.45,4.45h0c0,2.46-1.99,4.45-4.45,4.45Z" style="fill: #f0e2da;"/>
                                    <g>
                                        <path d="M569.39,554.4h-128.08c-2.17,0-3.93-1.76-3.93-3.93h0c0-2.17,1.76-3.93,3.93-3.93h128.08c2.17,0,3.93,1.76,3.93,3.93h0c0,2.17-1.76,3.93-3.93,3.93Z" style="fill: #f0e2da;"/>
                                        <rect x="437.39" y="495.52" width="135.94" height="7.86" rx="3.93" ry="3.93" style="fill: #f0e2da;"/>
                                        <rect x="437.39" y="450.77" width="135.94" height="7.86" rx="3.93" ry="3.93" style="fill: #f0e2da;"/>
                                        <rect x="314.43" y="428.74" width="285.4" height="147.87" style="fill: none; stroke: #ab9a87; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.02px;"/>
                                        <line x1="314.43" y1="478.8" x2="599.83" y2="478.8" style="fill: none; stroke: #ab9a87; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.02px;"/>
                                        <line x1="314.43" y1="526.22" x2="599.83" y2="526.22" style="fill: none; stroke: #ab9a87; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.02px;"/>
                                        <line x1="411.14" y1="428.74" x2="411.14" y2="576.61" style="fill: none; stroke: #ab9a87; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.02px;"/>
                                        <polyline points="350.09 449.66 360.02 465.53 374.48 443.86" style="fill: none; stroke: #ab9a87; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px;"/>
                                        <polyline points="350.09 497.64 360.02 513.51 374.48 491.84" style="fill: none; stroke: #ab9a87; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px;"/>
                                        <polyline points="350.09 545.61 360.02 561.49 374.48 539.82" style="fill: none; stroke: #ab9a87; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px;"/>
                                    </g>
                                    <rect x="314.76" y="241.49" width="285.06" height="71.11" style="fill: #f47f4f;"/>
                                    <g>
                                        <path d="M361.33,263.46h3.44v27.21h-3.44v-27.21Z" style="fill: #fff;"/>
                                        <path d="M372.24,263.46h3.57l9.83,17.09,2.95,5.64h.17c-.08-1.38-.17-2.81-.27-4.29-.1-1.48-.14-2.94-.14-4.38v-14.06h3.28v27.21h-3.57l-9.87-17.13-2.94-5.6h-.17c.11,1.38,.21,2.79,.31,4.21,.1,1.42,.14,2.86,.14,4.29v14.23h-3.28v-27.21Z" style="fill: #fff;"/>
                                        <path d="M406.63,291.18c-1.91,0-3.68-.36-5.31-1.08-1.63-.72-3.04-1.7-4.23-2.95l2.07-2.41c.97,1.02,2.11,1.85,3.42,2.47,1.31,.62,2.68,.93,4.09,.93,1.8,0,3.19-.41,4.19-1.22,1-.82,1.49-1.89,1.49-3.21,0-.69-.12-1.28-.35-1.76-.24-.48-.55-.9-.95-1.24-.4-.35-.88-.66-1.43-.93-.55-.28-1.15-.57-1.78-.87l-3.9-1.7c-.64-.28-1.29-.61-1.95-1-.66-.39-1.26-.86-1.78-1.41-.53-.55-.95-1.21-1.29-1.97-.33-.76-.5-1.64-.5-2.63s.21-1.98,.64-2.86c.43-.88,1.02-1.65,1.78-2.3,.76-.65,1.66-1.15,2.7-1.51,1.04-.36,2.18-.54,3.42-.54,1.63,0,3.14,.31,4.52,.93,1.38,.62,2.56,1.43,3.53,2.43l-1.87,2.24c-.83-.8-1.75-1.43-2.76-1.89-1.01-.46-2.15-.68-3.42-.68-1.52,0-2.75,.35-3.67,1.06-.93,.71-1.39,1.68-1.39,2.92,0,.66,.13,1.22,.39,1.68,.26,.46,.62,.86,1.06,1.2,.44,.35,.93,.65,1.45,.91,.52,.26,1.06,.51,1.62,.73l3.86,1.66c.77,.33,1.51,.71,2.2,1.14,.69,.43,1.29,.93,1.78,1.49,.5,.57,.89,1.23,1.18,1.99,.29,.76,.44,1.64,.44,2.63,0,1.08-.22,2.09-.64,3.03-.43,.94-1.04,1.76-1.85,2.47-.8,.71-1.77,1.26-2.9,1.66-1.13,.4-2.42,.6-3.86,.6Z" style="fill: #fff;"/>
                                        <path d="M430.89,291.18c-1.38,0-2.68-.2-3.88-.6-1.2-.4-2.24-1.06-3.11-1.99-.87-.93-1.56-2.14-2.05-3.63s-.75-3.33-.75-5.52v-15.97h3.44v16.05c0,1.63,.17,3,.5,4.11,.33,1.11,.78,1.99,1.35,2.65,.57,.66,1.24,1.14,2.01,1.43,.77,.29,1.6,.44,2.49,.44s1.76-.14,2.53-.44c.77-.29,1.45-.77,2.03-1.43,.58-.66,1.04-1.55,1.37-2.65,.33-1.11,.5-2.47,.5-4.11v-16.05h3.32v15.97c0,2.19-.25,4.02-.75,5.52-.5,1.49-1.18,2.7-2.05,3.63-.87,.93-1.9,1.59-3.09,1.99-1.19,.4-2.48,.6-3.86,.6Z" style="fill: #fff;"/>
                                        <path d="M462.92,290.68l-6.55-11.49h-4.94v11.49h-3.44v-27.21h8.5c1.38,0,2.66,.13,3.84,.39,1.18,.26,2.18,.7,3.03,1.31,.84,.61,1.5,1.4,1.97,2.36,.47,.97,.7,2.16,.7,3.57,0,2.13-.55,3.83-1.66,5.1-1.11,1.27-2.59,2.14-4.44,2.61l6.89,11.86h-3.9Zm-11.49-14.31h4.56c2.13,0,3.76-.44,4.89-1.31,1.13-.87,1.7-2.19,1.7-3.96s-.57-3.06-1.7-3.78c-1.13-.72-2.77-1.08-4.89-1.08h-4.56v10.12Z" style="fill: #fff;"/>
                                        <path d="M483.87,282.38h-9.91l-2.61,8.3h-3.53l9.21-27.21h3.9l9.21,27.21h-3.69l-2.57-8.3Zm-.87-2.78l-1.29-4.15c-.5-1.52-.97-3.03-1.41-4.54-.44-1.51-.89-3.05-1.33-4.63h-.17c-.42,1.58-.84,3.12-1.29,4.63-.44,1.51-.91,3.02-1.41,4.54l-1.29,4.15h8.17Z" style="fill: #fff;"/>
                                        <path d="M493.99,263.46h3.57l9.83,17.09,2.95,5.64h.17c-.08-1.38-.17-2.81-.27-4.29-.1-1.48-.15-2.94-.15-4.38v-14.06h3.28v27.21h-3.57l-9.87-17.13-2.95-5.6h-.17c.11,1.38,.21,2.79,.31,4.21,.1,1.42,.15,2.86,.15,4.29v14.23h-3.28v-27.21Z" style="fill: #fff;"/>
                                        <path d="M531.11,291.18c-1.72,0-3.29-.32-4.73-.95-1.44-.64-2.69-1.56-3.75-2.76-1.07-1.2-1.89-2.68-2.49-4.44-.6-1.76-.89-3.74-.89-5.95s.3-4.15,.91-5.89c.61-1.74,1.45-3.22,2.53-4.44,1.08-1.22,2.35-2.15,3.82-2.8,1.47-.65,3.07-.98,4.81-.98s3.12,.34,4.38,1.02c1.26,.68,2.29,1.46,3.09,2.34l-1.87,2.24c-.72-.77-1.53-1.4-2.45-1.87-.91-.47-1.95-.71-3.11-.71-1.3,0-2.48,.26-3.53,.77-1.05,.51-1.95,1.24-2.7,2.2-.75,.95-1.32,2.11-1.72,3.46-.4,1.36-.6,2.88-.6,4.56s.2,3.26,.6,4.63c.4,1.37,.96,2.54,1.68,3.51,.72,.97,1.6,1.72,2.63,2.24,1.04,.53,2.2,.79,3.5,.79s2.49-.27,3.48-.81c1-.54,1.94-1.29,2.82-2.26l1.91,2.16c-1.08,1.24-2.3,2.21-3.65,2.9-1.36,.69-2.92,1.04-4.69,1.04Z" style="fill: #fff;"/>
                                        <path d="M544.51,263.46h15.68v2.9h-12.24v8.55h10.33v2.95h-10.33v9.87h12.65v2.95h-16.1v-27.21Z" style="fill: #fff;"/>
                                    </g>
                                    <polyline points="314.76 312.6 599.83 312.6 599.83 241.49" style="fill: none; fill-rule: evenodd; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.84px;"/>
                                    </g>
                                    <g>
                                    <path d="M237.72,477.85c7.88,1.55,9.7,1.23,14.33-4.27l11.98-25.55-6.08-4.62-18.64,22.77-1.59,11.68Z" style="fill: #c95835; fill-rule: evenodd;"/>
                                    <path d="M237.55,484.57c8.06,1.44,12.36-6.89,16.54-12.14l7.21-13.66-9.23-8.44-19.33,26.62,4.82,7.62Z" style="fill: #44c8f5; fill-rule: evenodd;"/>
                                    <path d="M268.22,688.24c-.08,2.61-28.55,4.73-63.59,4.73-35.04,0-63.39-2.12-63.31-4.73s28.55-4.73,63.59-4.73,63.39,2.12,63.31,4.73Z" style="fill: #eae1d6; fill-rule: evenodd;"/>
                                    <path d="M217.86,678.55c4.44,5.68,7.97,7.12,9.82,.89l-.25-12.14-9.87,.14,.3,11.11Z" style="fill: #c95835; fill-rule: evenodd;"/>
                                    <path d="M215.15,495.38c15.74,20.22,17.4,7.96,17.4,7.96,0,0,3.62,76.3,3.2,78.83l-2.63,80.65c-.12,3.8,.9,7.23-2.42,7.66l-6.86,1.01c-4-23.84-23.69-41.79-14.13-79.09l-15.85-58.32c-21.74-43.35,21.29-38.7,21.29-38.7Z" style="fill: #bfb5af; fill-rule: evenodd;"/>
                                    <path d="M224.58,671.38l-8.69-.05c-5.24,.74-1.91-2.72-2.52-5.67-4.52-21.76-12.51-38.72-3.66-73.25l-15.85-58.32h0c5.27-1.27,9.66,1.52,11.58,6.06,21.39,50.67,8.16,101.34,19.14,131.24Z" style="fill: #a08e84; fill-rule: evenodd;"/>
                                    <path d="M200.54,502.76l-12.16,94.77-12.31,79.69-8.02,1.61c-1.1-28.71-14.59-50.21-2.6-84.97l4.6-64.7,15.28-23.27,15.2-3.13Z" style="fill: #c95835; fill-rule: evenodd;"/>
                                    <path d="M204.34,504.07l-12.49,93.66-10.12,69.31c-.2,2.08-2.04,3.82-4.11,3.88l-14.09,.42c-1.51,.04-2.71-1.14-2.68-2.65,.12-6.11,.63-15.5,.63-19.07,.04-19.22-5.29-27.12,2.96-52.73,.67-2.07,1.05-4.21,1.11-6.35l1.71-63.09,18.09-21.58,18.99-1.81Z" style="fill: #bfb5af; fill-rule: evenodd;"/>
                                    <path d="M176.07,677.22s2.83,6.4,3.44,10.45c.1,.69-.2,1.46-.82,2.06-.62,.6-1.48,.96-2.3,.96-1.77,.01-3.79,.02-5.04,.03-.78,0-1.48-.22-2-.64-.31-.25-.69-.55-1.08-.87-1.81-1.45-1.39-3.17-.88-5.58,.52-2.49,.71-5.31,.71-5.31,3.91-3.04,7.98-1.09,7.98-1.09Z" style="fill: #3c2913; fill-rule: evenodd;"/>
                                    <path d="M167.78,527.47s32.82,3.54,43.96-10.91l-44.05-9.71s-.47,16.93,.08,20.62Z" style="fill: #a08e84; fill-rule: evenodd;"/>
                                    <path d="M227.74,677.72l6.82,5.25c1.32,1.3,8.86,3.82,8.86,3.82h0c.65,1.61-.92,2.46-2.21,2.67l-22.77-.48s-6.19-1.09-.76-11.25c4.02,1.83,8.75,3.15,10.06-.01Z" style="fill: #3c2913; fill-rule: evenodd;"/>
                                    <path d="M207.24,404.47s4.18-5.64-2.4-10.49-6.12,8.19-5.91,8.34c.21,.15,8.31,2.15,8.31,2.15Z" style="fill: #3c2913; fill-rule: evenodd;"/>
                                    <path d="M189.23,407.19s1.53,6.56,6.56,6.16c5.03-.4,3.5-14.83,3.5-14.83l-10.06,8.67Z" style="fill: #3c2913; fill-rule: evenodd;"/>
                                    <path d="M205.32,408.81s.32,7.26,.58,13.28c.07,1.6-.84,3.11-2.38,3.94-1.54,.83-3.47,.86-5.05,.08-.52-.26-1.02-.51-1.5-.74-2.17-1.08-3.45-3.16-3.28-5.35,.42-5.62,1.17-15.86,1.17-15.86l10.46,4.66h0Z" style="fill: #c95835; fill-rule: evenodd;"/>
                                    <polygon points="206 413.41 205.71 417.53 200.97 414.17 206 413.41" style="fill: #ab4b52; fill-rule: evenodd;"/>
                                    <path d="M192.02,401.94c-.61-2.04,.54-4.19,2.56-4.8,2.15-.65,4.87-1.47,7.03-2.11,2.02-.61,3.84,.67,4.75,2.6,1.07,2.27,2.18,7.32,2.53,11.08,.2,2.12-.82,4.44-2.84,5.05-2.15,.65-9.23,.51-11.01-3.19-1.35-2.82-2.14-5.61-3.03-8.62h0Z" style="fill: #c95835; fill-rule: evenodd;"/>
                                    <path d="M188.33,408.6s-2.18-7.93,.56-11.39c3.68-4.65,9.06-7.64,15.95-3.23,0,0,3.7,1.63-7.16,4.55-1.38,.37,1.52,6.83-.18,7.65-2.3,1.1-5.28,1.98-9.17,2.43h0Z" style="fill: #3c2913; fill-rule: evenodd;"/>
                                    <path d="M192.19,410.73c1.03,1.41,2.8,1.85,3.95,.98,1.15-.86,1.24-2.7,.21-4.11-1.03-1.41-2.8-1.85-3.95-.98-1.15,.86-1.24,2.7-.21,4.11Z" style="fill: #c95835; fill-rule: evenodd;"/>
                                    <path d="M248.13,462.05c-7.61-12.47-20.99-30.69-20.99-30.69-3.67-6.49-10.88-9.71-15.16-6.78h0c-1.69,1.15-1.67,4.02,.05,6.44l8.74,45.86c9.05,2,18,9.78,25.62,1.13,4.14-4.7,4.71-11.09,1.74-15.95Z" style="fill: #44c8f5; fill-rule: evenodd;"/>
                                    <path d="M218.69,424.13l-11.24-3.84-15.21-1.04-24.38,8.21c-6.51,3.22-4.5,9.33-2.01,16.18l-1.89,22.01c-5.03,16.7-4.98,29.04-4.1,46.22,27.42,10.18,72.66,8.25,81.32-4.33-1.46-34.39-9.13-61.28-22.48-83.41Z" style="fill: #44c8f5; fill-rule: evenodd;"/>
                                    <path d="M207.45,420.29s6.08,15.05-4.25,15.71c-10.33,.66-15.99-14.98-15.99-14.98l7.55-3.35,12.69,2.62Z" style="fill: #c95835;"/>
                                    <line x1="222.25" y1="442.78" x2="223.98" y2="450.62" style="fill: none; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.74px;"/>
                                    <g>
                                        <polygon points="277.02 426.87 286.28 404.62 265.42 414.22 277.02 426.87" style="fill: #232030; fill-rule: evenodd;"/>
                                        <path d="M277.02,426.87l6.26-15.05c-.12-2.61-1.49-3.96-4.29-3.85l-13.58,6.25,11.61,12.65Z" style="fill: #fff; fill-rule: evenodd;"/>
                                        <path d="M160.19,531.82h0c3.11,3.78,9.18,3.34,13.51-.99l102.49-102.64c4.32-4.33-6.98-18.09-11.3-13.76l-102.49,102.64c-4.32,4.33-5.32,10.96-2.21,14.75Z" style="fill: #f2be7d;"/>
                                        <path d="M163.87,529.22c3.46,3.34,7.41,4.59,8.84,2.79,1.42-1.8-.22-5.97-3.68-9.32-3.46-3.34-7.41-4.59-8.84-2.79-1.42,1.8,.22,5.97,3.68,9.32Z" style="fill: #ffde98; fill-rule: evenodd;"/>
                                        <polygon points="172.71 532.01 164 540.69 152.28 527.82 160.45 519.63 172.71 532.01" style="fill: #ffde98; fill-rule: evenodd;"/>
                                        <g>
                                        <path d="M155.23,537.78c3.46,3.34,7.41,4.59,8.84,2.79,1.42-1.8-.22-5.97-3.68-9.32s-7.41-4.59-8.84-2.79c-1.42,1.8,.22,5.97,3.68,9.32Z" style="fill: #3d76bb; fill-rule: evenodd;"/>
                                        <polygon points="164.07 540.57 155.36 549.26 143.65 536.38 151.82 528.19 164.07 540.57" style="fill: #3d76bb; fill-rule: evenodd;"/>
                                        <path d="M146.97,545.92c3.34,3.39,7.16,4.74,8.52,3.02,1.36-1.72-.24-5.87-3.59-9.26s-7.16-4.74-8.52-3.02c-1.36,1.72,.24,5.87,3.59,9.26Z" style="fill: #4f89c7; fill-rule: evenodd;"/>
                                        </g>
                                        <line x1="275.06" y1="420.41" x2="170.94" y2="524.23" style="fill: none; stroke: #c2912c; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                    </g>
                                    <path d="M141.64,487.33c-1.28,6.99-.24,8.86,7.64,11.27l42,8.34-2.4-8.04-32.19-14.52-15.05,2.96Z" style="fill: #c95835; fill-rule: evenodd;"/>
                                    <path d="M188.88,498.89l6.63,3.14c1.32,.63,2.38,1.71,2.98,3.05l2.41,5.43c.84,1.89-.47,4.04-2.53,4.16h0l-8.11-4.42c-1.79-.97-3.24-2.69-4.06-4.81l-1.37-3.52,4.06-3.03Z" style="fill: #c95835;"/>
                                    <path d="M169.38,427.26s-7.5-.1-11.75,9.97c-4.25,10.07-17.34,38.74-17.74,40.6-.39,1.86-8.8,17.11,5.87,21.07,17.54,4.73,35.02,9.87,35.02,9.87l4.17-16.88-24.71-8.34s16.96-48.45,16.18-51.64c-.78-3.19-7.06-4.65-7.06-4.65Z" style="fill: #44c8f5; fill-rule: evenodd;"/>
                                    <polyline points="171.62 449.77 161.56 479.8 182.47 490.36" style="fill: none; fill-rule: evenodd; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.74px;"/>
                                    <path d="M264.03,448.03l2.9-7c.58-1.4,.64-2.96,.16-4.4l-1.92-5.83c-.67-2.03-3.16-2.77-4.83-1.43h0l-3.15,9.01c-.69,1.99-.61,4.31,.22,6.5l1.4,3.65,5.21-.5Z" style="fill: #c95835;"/>
                                    </g>
                                    <polyline points="314.76 267.46 314.76 241.49 368.83 241.49" style="fill: none; fill-rule: evenodd; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.84px;"/>
                                    <polyline points="391.61 200.83 637.47 200.83 637.47 432.92" style="fill: none; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.84px;"/>
                                    <g class="umbrella-element">
                                    <path d="M694.47,497.93l-150.32,178.07c-8.44,9.94-17.61,11.22-25.94,1.55,0,0-5.87-7.18,2.57-17.12" style="fill: none; fill-rule: evenodd; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3.91px;"/>
                                    <g>
                                        <path d="M503.58,518.57c38.28,3.86,60.78,32.66,67.65,59.17,32.37-1.57,56.71,25.01,63.06,54.7,36.31,1.05,58.31,28.85,61.4,53.72,47.24-53.21,38.72-137.26-10.21-179.89-48.93-42.63-134.65-40.93-181.89,12.29Z" style="fill: #017296; fill-rule: evenodd;"/>
                                        <path d="M634.28,632.45s56.51-63.67,51.18-126.16c0,0-61,9.81-114.24,71.46,0,0,46.67-5.38,63.06,54.7Z" style="fill: #036686; fill-rule: evenodd;"/>
                                    </g>
                                    </g>
                                    <rect x="367.35" y="179.22" width="180.18" height="36.62" rx="18.31" ry="18.31" style="fill: #3c2913;"/>
                                </g>
                                </svg>
                        </div>

                    </div>

                    <div class="svg-container" v-if="index == 2">
                        <div class="svg1">
                            <svg class="svg-main-realestate" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 737.58 651.15">
                                <g id="Layer_1-2" data-name="Layer 1">
                                    <path d="M110.78,75.79C-62.04,156.89-25.53,441.8,170.71,543.4c59.15,30.63,147.71,62.56,223.96,57.03,161.18-11.68,256.07-23.52,321.22-113.27,60.39-83.2-3.37-259.77-215.72-234.3C344.96,271.48,265.58,3.14,110.78,75.79Z" style="fill: #44c8f5;"/>
                                    <ellipse cx="425.64" cy="629.99" rx="204.03" ry="7.66" style="fill: #eee5da;"/>
                                    <circle cx="65.77" cy="189.2" r="10.63" style="fill: none; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.69px;"/>
                                    <circle cx="429.73" cy="11.97" r="10.63" transform="translate(238.7 397.09) rotate(-65.21)" style="fill: none; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.69px;"/>
                                    <circle cx="679.75" cy="470.87" r="10.63" transform="translate(65.3 1024.26) rotate(-76.72)" style="fill: none; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.69px;"/>
                                    <path d="M394.25,103.13h198.49c52.65,0,95.33,42.68,95.33,95.33h0s-293.81,0-293.81,0V103.13Z" style="fill: #c4bdb3;"/>
                                    <path d="M593.6,629.46H220.41V172.03c0-38.05,29.95-68.9,66.9-68.9h306.29c19,1.48,37.15,3.4,36.73,14.95-16.96-3.28-32.07-3.25-36.73,15.48v67.74s0,428.16,0,428.16Z" style="fill: #ded5ca;"/>
                                    <path d="M593.6,198.46v-65.78s-1.78-24.29,36.73-14.22" style="fill: none; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3.7px;"/>
                                    <path d="M480.77,225.58h-160c-3.26,0-5.92-2.67-5.92-5.92h0c0-3.26,2.66-5.92,5.92-5.92h160c3.26,0,5.92,2.67,5.92,5.92h0c0,3.26-2.66,5.92-5.92,5.92Z" style="fill: #fff;"/>
                                    <path d="M480.77,279.46h-160c-3.26,0-5.92-2.67-5.92-5.92h0c0-3.26,2.66-5.92,5.92-5.92h160c3.26,0,5.92,2.67,5.92,5.92h0c0,3.26-2.66,5.92-5.92,5.92Z" style="fill: #fff;"/>
                                    <path d="M480.77,333.33h-90.51c-3.26,0-5.92-2.67-5.92-5.92h0c0-3.26,2.66-5.92,5.92-5.92h90.51c3.26,0,5.92,2.67,5.92,5.92h0c0,3.26-2.66,5.92-5.92,5.92Z" style="fill: #fff;"/>
                                    <path d="M331.82,105.64h-44.51c-36.95,0-66.9,29.95-66.9,66.9v20.04" style="fill: none; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3.7px;"/>
                                    <g>
                                    <rect x="398.1" y="518.79" width="223" height="109.02" transform="translate(1019.19 1146.59) rotate(-180)" style="fill: #d3cbc0;"/>
                                    <rect x="398.1" y="518.79" width="74.62" height="109.02" transform="translate(870.81 1146.59) rotate(-180)" style="fill: #f6ede0;"/>
                                    <polygon points="462.38 526.36 628.11 526.36 587.02 447.74 431.98 447.74 462.38 526.36" style="fill: #735631;"/>
                                    <polygon points="431.98 447.74 383.67 527.31 472.72 526.36 431.98 447.74" style="fill: #5a4326;"/>
                                    <path d="M398.1,527.25l37.64-61,30.75,60.12c-20.14,8.09-43.48,6.8-68.38,.88Z" style="fill: #f6ede0;"/>
                                    <polygon points="472.72 526.36 466.48 526.36 431.98 458.9 390.23 527.24 383.67 527.31 431.98 447.74 472.72 526.36" style="fill: #977140;"/>
                                    <rect x="419.48" y="587.44" width="25.01" height="39.85" transform="translate(863.97 1214.73) rotate(180)" style="fill: #c4b8a9;"/>
                                    <rect x="486.9" y="537.05" width="23.3" height="21.5" transform="translate(997.1 1095.61) rotate(180)" style="fill: #b0a597;"/>
                                    <rect x="419.48" y="537.05" width="23.3" height="21.5" transform="translate(862.25 1095.61) rotate(180)" style="fill: #c4b8a9;"/>
                                    <rect x="536.88" y="537.05" width="21.22" height="21.5" transform="translate(1094.99 1095.61) rotate(180)" style="fill: #b0a597;"/>
                                    <rect x="584.96" y="537.05" width="19.54" height="21.5" transform="translate(1189.45 1095.62) rotate(-180)" style="fill: #b0a597;"/>
                                    <rect x="486.9" y="587.03" width="23.3" height="21.5" transform="translate(997.1 1195.56) rotate(180)" style="fill: #b0a597;"/>
                                    <rect x="536.88" y="587.03" width="21.22" height="21.5" transform="translate(1094.99 1195.56) rotate(180)" style="fill: #b0a597;"/>
                                    <rect x="584.96" y="587.03" width="19.54" height="21.5" transform="translate(1189.45 1195.56) rotate(180)" style="fill: #b0a597;"/>
                                    <polyline points="621.1 535.09 621.1 627.81 565.86 627.81" style="fill: none; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.69px;"/>
                                    <line x1="472.72" y1="627.81" x2="503.73" y2="627.81" style="fill: none; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.69px;"/>
                                    <line x1="472.72" y1="532.06" x2="472.72" y2="612.63" style="fill: none; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.69px;"/>
                                    </g>
                                    <path d="M388.9,425.3s69.52-42.41,44.86-56.09c-20.35-11.29-28.55,64.24-17.43,65.02,11.12,.78,26.89-22.12,34.21-20.57,7.32,1.55,14.73,27.56,28.08,13.59" style="fill: none; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3.16px;"/>
                                    <line x1="526.78" y1="162.38" x2="526.78" y2="438.25" style="fill: none; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3.16px;"/>
                                    <path d="M521.66,413.64h0c1.74-4.11,7.59-4.16,9.27-.08h0c1.9,4.62,7.24,6.78,11.92,4.82l2.41-1.01c4.69-1.96,6.95-7.29,5.05-11.91h0c-1.68-4.08,2.49-8.22,6.6-6.56h0c4.66,1.88,10.03-.37,12-5.02l1.02-2.39c1.97-4.65-.2-9.95-4.86-11.83h0c-4.11-1.66-4.07-7.46,.07-9.19h0c4.69-1.96,6.95-7.29,5.05-11.91l-.98-2.38c-1.9-4.62-7.24-6.78-11.92-4.82h0c-4.14,1.73-8.24-2.34-6.5-6.45h0c1.97-4.65-.2-9.95-4.86-11.83l-2.4-.97c-4.66-1.88-10.03,.37-12,5.02-1.74,4.11-7.59,4.16-9.27,.08h0c-1.9-4.62-7.24-6.78-11.92-4.82l-2.41,1.01c-4.69,1.96-6.95,7.29-5.05,11.91h0c1.68,4.08-2.49,8.22-6.6,6.56h0c-4.66-1.88-10.03,.37-12,5.02l-1.02,2.39c-1.97,4.65,.2,9.95,4.86,11.83,4.11,1.66,4.07,7.46-.07,9.19-4.69,1.96-6.95,7.29-5.05,11.91l.98,2.38c1.9,4.62,7.24,6.78,11.92,4.82h0c4.14-1.73,8.24,2.34,6.5,6.45h0c-1.97,4.65,.2,9.95,4.86,11.83l2.4,.97c4.66,1.88,10.03-.37,12-5.02Zm-15.98-46.71c4.9-11.55,18.23-17.12,29.79-12.45,11.56,4.67,16.96,17.81,12.06,29.36-4.9,11.55-18.23,17.12-29.79,12.45-11.56-4.67-16.96-17.81-12.06-29.36Z" style="fill: #5868b0;"/>
                                    <circle cx="525.55" cy="375.52" r="24.74" transform="translate(-22.43 717.48) rotate(-67.51)" style="fill: #35429a;"/>
                                    <line x1="399.55" y1="628.07" x2="456.3" y2="628.07" style="fill: none; stroke: #21180e; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.69px;"/>
                                    <path d="M301.24,325.09s-14.21-6.06-17.97,12.04c-2.51,12.07-9.24,16.73-5.05,27.86,4.19,11.13,36.09-7.3,36.09-7.3l-2.51-21.05-10.56-11.53Z" style="fill: #572b23; fill-rule: evenodd;"/>
                                    <path d="M283.47,632.85s18.6-59.4,9.15-84.47l12.29-89.94-37.6,7.21,7.15,167.7,9-.5Z" style="fill: #e3633d; fill-rule: evenodd;"/>
                                    <path d="M237.06,641.78c-.11,2.82,30.48,5.1,68.32,5.1s68.62-2.29,68.73-5.1c.11-2.82-30.48-5.1-68.32-5.1s-68.62,2.29-68.73,5.1Z" style="fill: #eee5da; fill-rule: evenodd;"/>
                                    <path class="lady-arm" d="M256.81,407.24c-13.39,7.57-22.48,11.79-36.1,19.08l-.85,10.62c29.52-10.54,40.26-8.84,49.13-18.82-1.97-23.07,8.36-5.68-12.18-10.88Z" style="fill: #e3633d;"/>
                                    <path class="lady-arm" d="M220.73,426.35l-6.22,4.64c-1.24,.93-2.11,2.27-2.45,3.78l-1.37,6.13c-.48,2.14,1.33,4.09,3.5,3.78h0l7.49-6.27c1.65-1.38,2.8-3.47,3.21-5.83l.68-3.94-4.84-2.29Z" style="fill: #e3633d;"/>
                                    <path d="M274.31,630.43l-8.01,5.67c-1.59,1.4-10.04,4.12-10.04,4.12h0c-.9,1.74,.69,2.66,2.06,2.88l24.65-.52s5.74-1.18,1.13-12.15c-4.56,1.98-8.76,3.4-9.79-.01Z" style="fill: #4a2b1b; fill-rule: evenodd;"/>
                                    <path d="M297.28,443.43l15.07,100.89,23.57,87.98,5.55-2.28c.6-30.56,9.24-52.59-4.43-89.6l-6.87-91.52-16.41-2.13-16.48-3.33Z" style="fill: #e3633d; fill-rule: evenodd;"/>
                                    <path d="M338.98,628.24c-2.2-.42-4.23,1.17-4.49,3.46-.21,1.88-.62,4.54-1.38,7.14-.21,.71-.82,3.13-.26,3.72,.56,.58,1.33,.89,2.05,.83,1.55-.14,3.32-.29,4.41-.39,.68-.06,1.29-.36,1.73-.84,.26-.29,.58-.64,.92-1.01,1.53-1.69,1.11-3.48,.58-5.99-.54-2.6-.81-5.58-.81-5.58-.94-.77-1.88-1.17-2.75-1.33Z" style="fill: #4a2b1b; fill-rule: evenodd;"/>
                                    <path d="M279.75,360.47l22.75-6.11,5.4,.21,20.51,7.15c6.91,3.42,10.11,11.44,7.47,18.71l-5.02,23.47c5.33,17.71,8.09,30.12,7.16,48.34-29.08,10.8-42.81,10.93-51.99-2.42,.61-14.47-4.97-30.02-8.31-42.75-6.45-24.54-6.51-32.46,2.03-46.62Z" style="fill: #94b947; fill-rule: evenodd;"/>
                                    <path d="M293.43,343.43s.92,7.76,1.69,14.19c.2,1.71,1.3,3.18,2.88,3.84,1.58,.66,3.38,.41,4.72-.66,.44-.35,.87-.69,1.27-1.01,1.84-1.46,2.68-3.86,2.16-6.17-1.33-5.91-3.76-16.67-3.76-16.67l-8.98,6.49h0Z" style="fill: #e3633d; fill-rule: evenodd;"/>
                                    <polygon points="293.57 348.42 294.54 352.75 298.39 348.49 293.57 348.42" style="fill: #bb5232; fill-rule: evenodd;"/>
                                    <path d="M292.22,356.89s-6.91,14.75,4.04,15.45c10.96,.7,16.96-15.89,16.96-15.89l-8-3.56-13,4Z" style="fill: #e3633d;"/>
                                    <path d="M307.6,335.8c.6-2.21-.69-4.49-2.87-5.09-2.33-.64-5.27-1.45-7.61-2.09-2.19-.6-4.11,.82-5.04,2.91-1.1,2.47-2.15,7.92-2.44,11.98-.16,2.28,.99,4.75,3.18,5.35,2.33,.64,9.93,.32,11.75-3.72,1.38-3.07,2.15-6.09,3.03-9.34h0Z" style="fill: #e3633d; fill-rule: evenodd;"/>
                                    <path d="M311.74,342.86s2.14-8.58-.89-12.23c-4.07-4.9-9.94-7.98-17.23-3.06,0,0-2.16,6.47,7.93,10.13,3.6,1.31,1.63,4.37,10.19,5.16h0Z" style="fill: #572b23; fill-rule: evenodd;"/>
                                    <path d="M307.66,345.25c-1.08,1.54-2.97,2.06-4.22,1.16-1.26-.9-1.41-2.87-.33-4.41s2.97-2.06,4.22-1.16c1.26,.9,1.41,2.87,.33,4.41Z" style="fill: #e3633d; fill-rule: evenodd;"/>
                                    <path d="M291.49,343.16l3.82,.97s-.73,2.62-2.51,1.93c-1.78-.68-1.31-2.9-1.31-2.9Z" style="fill: #fff; fill-rule: evenodd;"/>
                                    <path d="M277.2,405.3s-9.47,24.2-10.63,57.47c-1.32,37.73-2.07,88.99-2.07,88.99,30.73,3.4,13.11,25.85,88.27-2.46,0,0-9.01-22.25-10.24-40.88-1.22-18.63,6.62-66.96-11.68-104.49,0,0-50.47,15.6-53.66,1.38Z" style="fill: #735631; fill-rule: evenodd;"/>
                                    <path d="M342.39,508.41c-1.22-18.63,6.62-66.96-11.68-104.49,0,0-7.05,2.18-16.04,4.16,15.83,36.87,8.61,82.38,9.79,100.33,.17,2.61,.5,5.29,.93,7.98,3.43,21.36-11.69,42.11-33.28,45.97-.1,.02-.19,.03-.29,.05,8.83,2.5,23.21,1.04,60.82-13.12,0,0-9.01-22.25-10.24-40.88Z" style="fill: #5f4728; fill-rule: evenodd;"/>
                                    <path d="M312.77,348.7s9.99,7.27,8.32,12.33c-1.67,5.06-15.3,18.1-12.14,23.76,3.17,5.66-14.46-5.17-6.01-16.67,8.45-11.49,5.22-16.46,5.22-16.46l4.61-2.96Z" style="fill: #572b23; fill-rule: evenodd;"/>
                                    <path class="lady-arm" d="M250.46,411.6s-3.2-4.07,3.2-13.34c4-5.81,13.27-33.64,26.04-37.79l-1.01,31.89s-4.79,26.05-17.47,32.94l-10.76-13.7Z" style="fill: #94b947; fill-rule: evenodd;"/>
                                    <path d="M318.38,389.43c.09,.35,19.7,28.77,21.97,32.48,2.27,3.7,8.64,3.57,8.64,3.57,0,0,6.48-10.97,8.2-13.26,0,0,1.31-5.9-1.19-10.2-2.51-4.3-21.19-34.24-21.19-34.24,0,0-22.04-.55-16.43,21.66Z" style="fill: #94b947; fill-rule: evenodd;"/>
                                    <path d="M323.55,394.95c-.27,.09-5.95-14.45-5.95-14.45" style="fill: none; fill-rule: evenodd; stroke: #6a8338; stroke-linecap: round; stroke-linejoin: round;"/>
                                    <line x1="275.76" y1="392.19" x2="279.74" y2="382.84" style="fill: none; stroke: #6a8338; stroke-linecap: round; stroke-linejoin: round;"/>
                                    <path d="M196.44,644.81c.04,2.94-31.89,5.74-71.32,6.26-39.43,.52-71.42-1.44-71.46-4.37-.04-2.94,31.89-5.74,71.32-6.26,39.43-.52,71.42,1.44,71.46,4.37Z" style="fill: #eee5da; fill-rule: evenodd;"/>
                                    <path d="M94.37,636.95s-12.08-64.53,.06-90.25l.5-73.08,32.41-12.19-22.82,175.94-10.15-.42Z" style="fill: #e3633d; fill-rule: evenodd;"/>
                                    <path d="M104.89,634.55l5.69,5.47c1.61,1.44,10.35,4.16,10.35,4.16h0c.89,1.8-.79,2.78-2.23,3.03l-25.67-.2s-4.23-1.17,.88-12.67c4.7,2,9.81,3.77,10.98,.2Z" style="fill: #4a2b1b; fill-rule: evenodd;"/>
                                    <path d="M130.36,475.09l-8.47,74.33-11.45,74.56-28.61,.38s1.34-12.96,.96-17.06c-.38-4.1-1.99-43.02,6.89-61.05l.31-83.19,40.37,12.02Z" style="fill: #d7cfc4; fill-rule: evenodd;"/>
                                    <path d="M143.21,636.27s-16.48-64.44-6.31-90.14l-14.69-87.45,41.09,2.27-9.35,175.76-10.75-.44Z" style="fill: #e3633d; fill-rule: evenodd;"/>
                                    <path d="M80.13,405.61c-7.85-.03-14.35,4.44-15.43,13.48l3.82,44.33,8.27-4.18,2.53-33.35,.82-20.28Z" style="fill: #c95835; fill-rule: evenodd;"/>
                                    <path d="M76.79,459.25l-2.12,7.82c-.42,1.56-1.39,2.92-2.73,3.83l-5.43,3.68c-1.89,1.28-4.48,.28-5.02-1.94h0l3.22-9.68c.71-2.14,2.29-4.05,4.43-5.36l3.57-2.18,4.08,3.82Z" style="fill: #c95835;"/>
                                    <path d="M139.29,335.04s-1.45,8.04-2.65,14.7c-.32,1.77-1.74,3.25-3.7,3.87-1.97,.62-4.18,.28-5.79-.88-.53-.38-1.04-.75-1.53-1.11-2.21-1.6-3.15-4.14-2.42-6.51,1.88-6.1,5.3-17.2,5.3-17.2l10.79,7.13h0Z" style="fill: #c95835; fill-rule: evenodd;"/>
                                    <polygon points="138.93 339.47 137.63 344.24 133 339.34 138.93 339.47" style="fill: #883c25; fill-rule: evenodd;"/>
                                    <path d="M126.88,325.36c-.47-2.34,1.02-4.62,3.33-5.1,2.47-.51,5.58-1.15,8.05-1.66,2.31-.48,4.22,1.13,5.04,3.37,.97,2.64,1.7,8.38,1.73,12.61,.02,2.39-1.35,4.87-3.66,5.35-2.47,.51-10.34-.34-11.96-4.65-1.23-3.28-1.83-6.48-2.53-9.92h0Z" style="fill: #c95835; fill-rule: evenodd;"/>
                                    <path d="M129.86,337.69c-6.64-1.32-10.56-8.39-7.95-14.64,.56-1.35,1.21-2.51,1.94-3.28,4.57-4.82,10.87-7.63,18.11-2.03,0,0-.69,10.7-12.09,19.95h-.01Z" style="fill: #673b25; fill-rule: evenodd;"/>
                                    <path d="M133.26,332.53c1.01,1.67,2.95,2.34,4.31,1.49,1.37-.85,1.65-2.89,.64-4.56-1.01-1.67-2.95-2.34-4.31-1.49-1.37,.85-1.65,2.89-.64,4.56Z" style="fill: #c95835; fill-rule: evenodd;"/>
                                    <path d="M104.05,415.49l55.88,3.51c9.12,3.21,6.19,55.61,6.19,55.61l-36.68,2.19c-17.51-.05-38.53,2.85-39.55-14.88-1.87-32.52,14.16-46.44,14.16-46.44Z" style="fill: #d7cfc4; fill-rule: evenodd;"/>
                                    <path d="M146.64,348.68l-20.4-3.17h-3.68s-16.36,3.72-16.36,3.72c-7.33,3.29-18.19,14.44-15.73,22.11l4.77,13.21c-5.18,18.27-5.29,47.69-7.26,66.59,29.85,12.39,71.81,12.62,81.89-.91-.09-20.04,1.5-51.81-2.21-68.94-3.33-15.38-14.48-20.78-21.02-32.61Z" style="fill: #014c64; fill-rule: evenodd;"/>
                                    <path d="M154.11,633.9l6.12,5.46c1.72,1.44,10.68,4.15,10.68,4.15h0c1.03,1.8-.58,2.77-1.99,3.03l-25.71-.2s-4.71-.63-.48-12.11c4.85,2,10.5,3.23,11.39-.34Z" style="fill: #4a2b1b; fill-rule: evenodd;"/>
                                    <path d="M166.12,474.62l-1.51,74.24-5.74,74.48-27.53,.36s-.73-12.93-1.43-17.02c-.7-4.1-5.29-42.97,2.21-60.98l-7.28-72.86,41.28,1.77Z" style="fill: #d7cfc4; fill-rule: evenodd;"/>
                                    <line x1="110.41" y1="477.08" x2="123.46" y2="477.34" style="fill: none; stroke: #a39288; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.32px;"/>
                                    <path d="M99.74,353.83c-10.73,4.21-36.02,51.7-35.9,56.58,.13,5.49-.23,37.43-.23,37.43l17.11-1.39s4.12-27.42,5.8-29.84c1.68-2.43,24.84-36.39,24.84-36.39l-11.62-26.39Z" style="fill: #014c64; fill-rule: evenodd;"/>
                                    <polyline points="88.89 432.05 93.83 373.96 91.53 370.89" style="fill: none; fill-rule: evenodd; stroke: #505aa8; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.32px;"/>
                                    <path class="lady-arm" d="M179.23,404.53c11.47,11.19,21.73,14.36,33.5,25.33l-3.48,8.6c-26.93-18.48-36.69-17.31-42.97-29.72,5.74-13.62,9.72-6.2,12.94-4.21Z" style="fill: #c95835;"/>
                                    <path class="lady-arm" d="M211.34,428.43l6.87,4.26c1.37,.85,2.4,2.17,2.88,3.71l1.97,6.24c.69,2.18-1.01,4.37-3.29,4.24h0l-8.34-5.84c-1.84-1.29-3.22-3.35-3.86-5.77l-1.06-4.03,4.82-2.81Z" style="fill: #c95835;"/>
                                    <path d="M290.21,405.29l18.16,47.92c.47,1.23,1.85,1.85,3.08,1.39l34.5-13.01c1.23-.47,1.86-1.84,1.39-3.08l-18.16-47.92c-.47-1.23-1.85-1.85-3.08-1.39l-34.5,13.01c-1.23,.47-1.86,1.84-1.39,3.08Z" style="fill: #fff; fill-rule: evenodd;"/>
                                    <path class="lady-arm" d="M143.97,372.83l21.41,46.54,33.26,16.37,9.15-12.89-27.67-22.05s-5.64-12.53-13.96-28.5c-3.71-7.11-7.88-23-19.52-23.62-17.33-.92-2.66,24.16-2.66,24.16Z" style="fill: #014c64; fill-rule: evenodd;"/>
                                    <polyline points="165.96 409.83 149.81 377.02 149.66 374.61" style="fill: none; fill-rule: evenodd; stroke: #505aa8; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.32px;"/>
                                    <line x1="124.91" y1="477.93" x2="127.93" y2="506.08" style="fill: none; stroke: #a39288; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.32px;"/>
                                    <path d="M309.08,431.56l-6.94,3.43c-1.39,.69-2.48,1.85-3.09,3.27l-.14,3.18c.23,3.39,1.26,6.18,3.44,6.27l5.49-4.14c1.87-1.06,3.37-2.9,4.2-5.15l1.38-3.74-4.34-3.12Z" style="fill: #e3633d;"/>
                                    <path d="M356.96,412.06c2.47,7.12,.44,14.41-7.43,18.21l-41.43,10.35,1.22-8.81,29.49-12.69,18.16-7.06Z" style="fill: #e3633d; fill-rule: evenodd;"/>
                                </g>
                                </svg>
                        </div>

                        <div class="svg2">
                            <svg class="svg-main-commerce" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 818.43 632.63">
                                <g id="Layer_1-2" data-name="Layer 1">
                                    <path d="M716.75,536.55C848.2,382.07,768.51,74.8,468.58,9.36,301.85-27.01,52.87,37.49,2.78,292.91c-22.93,116.93,97.92,291.86,286.5,185.75,137.84-77.56,309.71,196.27,427.46,57.89Z" style="fill: #33f18a;"/>
                                    <path d="M570.98,312.45c25.57,28.2,28.05,55.79,25.79,73.64,10.88-20.33,22.26-39.14,33.29-56.01-50.03-50.93-13.52-89.01-13.52-89.01,24.27,27.77,26.87,54.57,24.66,72.41,.05-.07,.1-.15,.15-.22,15.45-22.37,30.69-42.11,44.06-58.39-42.77-61.47,1.75-92.86,1.75-92.86,20.23,34.84,15.31,63.61,8.78,80.27,14.42-16.9,25.59-28.69,30.78-34.04,31.27-54.2,80.95-47.59,80.95-47.59-22.8,53.84-57.09,55-73.16,52.07-4.07,4.14-16.13,16.62-32.28,35.58,48.69-15.57,79.65,12.79,79.65,12.79-50.5,31.74-79.44,11.68-90.47,.16-13.09,15.98-27.95,35.26-43.02,57.09-1.56,2.27-3.15,4.59-4.74,6.95,46.73-28.32,84.76-5.04,84.76-5.04-47.07,44.14-80.95,23.95-91.58,15.3-11.56,17.72-23.5,37.62-34.8,59.12,45.12-26.91,82.25-5.12,82.25-5.12-43.51,42.33-76.4,27.52-89.12,18.58-23.26,46.89-42.67,100.53-48.34,155.79-.24,2.39-2.38,4.13-4.77,3.88-.48-.05-.93-.17-1.34-.36-1.66-.75-2.73-2.5-2.54-4.41,5.84-56.92,25.89-112.03,49.83-160.03-53.73-50.89-17.05-90.57-17.05-90.57Z" style="fill: #44c8f5;"/>
                                    <path d="M463.75,243.99c32.96,19.04,43.75,44.56,47.06,62.24,4.15-22.68,9.24-44.07,14.59-63.5-63.2-33.21-40.06-80.62-40.06-80.62,31.59,19.03,42.26,43.75,45.6,61.41,.03-.09,.05-.18,.08-.26,7.88-26.02,16.36-49.47,24.12-69.06-59.5-45.46-26.7-88.95-26.7-88.95,29.91,26.99,34.01,55.89,32.88,73.75,8.56-20.5,15.6-35.14,18.92-41.81,13.22-61.16,62.54-70.04,62.54-70.04-5.26,58.24-37.56,69.81-53.76,71.93-2.62,5.18-10.28,20.76-19.87,43.74,41.6-29.69,79.75-12.15,79.75-12.15-38.39,45.65-72.08,35.39-86.1,27.79-7.58,19.21-15.84,42.11-23.52,67.5-.8,2.63-1.59,5.33-2.39,8.06,35.85-41.24,79.17-30.69,79.17-30.69-31.34,56.41-69.77,47.53-82.52,42.55-5.59,20.41-10.89,43-15.08,66.93,34.74-39.41,76.75-29.99,76.75-29.99-28.5,53.6-64.34,49.54-79.18,44.92-7.83,51.76-9.92,108.76,1.57,163.11,.5,2.35-1.01,4.66-3.36,5.15-.47,.1-.94,.12-1.39,.07-1.81-.21-3.37-1.54-3.76-3.42-11.83-55.99-9.57-114.59-1.44-167.6-66.7-32.04-43.9-81.03-43.9-81.03Z" style="fill: #44c8f5;"/>
                                    <g class="commerce-dollar">
                                    <rect x="541.68" y="370.06" width="271.05" height="129.11" transform="translate(1462.5 259.07) rotate(134.71)" style="fill: #8999cd;"/>
                                    <circle cx="680.45" cy="432.62" r="41.63" transform="translate(-22.61 37.8) rotate(-3.13)" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.61px;"/>
                                    <line x1="783.2" y1="403.61" x2="650.97" y2="537.2" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.61px;"/>
                                    <line x1="708.56" y1="329.73" x2="572.04" y2="467.65" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.61px;"/>
                                    <line x1="779.43" y1="365.93" x2="745.72" y2="332.57" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.61px;"/>
                                    <line x1="608.49" y1="538.62" x2="574.78" y2="505.25" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.61px;"/>
                                    <path d="M708.88,329.62s17.62,21.32,36.7,3.11" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.61px;"/>
                                    <path d="M781.55,371.23s-17.88,14.9,.33,33.98" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.61px;"/>
                                    <path d="M571.7,468.2s21.49,17.4,3.48,36.66" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.61px;"/>
                                    <path d="M611.3,540.54s17.46-21.49,36.74-3.48" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.61px;"/>
                                    <path d="M669.36,441.48c-1.98-2.46-3.05-5.82-3.12-8.64l3.31-.62c.17,2.79,.86,5.61,2.96,7.76,2.54,2.61,5.25,2.51,7.44,.38,5.71-5.56-5.09-14.19,1.78-20.88,3.14-3.05,7.38-3.21,10.83-.58l3.56-3.47,2.06,2.12-3.49,3.4c1.95,2.5,2.3,5.04,2.19,7.61l-3.24,.13c0-2.54-.32-4.35-2.18-6.26-2.09-2.15-4.77-2.22-6.82-.23-5.11,4.97,5.87,13.44-1.71,20.82-3.35,3.26-7.74,3.41-11.45,.5l-3.56,3.47-2.06-2.12,3.49-3.4Z" style="fill: #fff;"/>
                                    </g>
                                    <ellipse cx="414.53" cy="589.71" rx="320.38" ry="42.92" style="fill: #dce0ee;"/>
                                    <g>
                                    <rect x="207.1" y="349.38" width="401.18" height="203.94" style="fill: #9eaad6;"/>
                                    <rect x="573.62" y="349.38" width="69.32" height="216.65" style="fill: #576ab0;"/>
                                    <path d="M262.27,553.32h394.55c8.79,0,15.93,7.14,15.93,15.93v19.08H246.35v-19.08c0-8.79,7.14-15.93,15.93-15.93Z" style="fill: #576ab0;"/>
                                    <rect x="373.31" y="211.2" width="97.42" height="42.26" style="fill: #576ab0;"/>
                                    <path d="M268.26,333h380.15c6.83,0,12.37,5.54,12.37,12.37v18.76H268.26v-31.13h0Z" style="fill: #576ab0;"/>
                                    <path d="M652.77,335.68l-360.52-2.68,168.49-118.57c6.11-4.3,13.86-4.3,19.97,0l172.05,121.25Z" style="fill: #576ab0;"/>
                                    <rect x="469.55" y="380.05" width="67.55" height="147.4" style="fill: #bec8e5;"/>
                                    <path d="M470.41,364.18h65.83c10.05,0,18.21,8.16,18.21,18.21v13.54h-102.24v-13.54c0-10.05,8.16-18.21,18.21-18.21Z" transform="translate(1006.65 760.1) rotate(180)" style="fill: #bec8e5;"/>
                                    <rect x="338.13" y="380.05" width="67.55" height="147.4" style="fill: #bec8e5;"/>
                                    <path d="M338.99,364.18h65.83c10.05,0,18.21,8.16,18.21,18.21v13.54h-102.24v-13.54c0-10.05,8.16-18.21,18.21-18.21Z" transform="translate(743.81 760.1) rotate(180)" style="fill: #bec8e5;"/>
                                    <rect x="207.78" y="380.05" width="67.55" height="147.4" style="fill: #bec8e5;"/>
                                    <path d="M208.64,364.18h65.83c10.05,0,18.21,8.16,18.21,18.21v13.54h-102.24v-13.54c0-10.05,8.16-18.21,18.21-18.21Z" transform="translate(483.11 760.1) rotate(180)" style="fill: #bec8e5;"/>
                                    <path d="M193.75,333h373.08c9.21,0,16.7,7.48,16.7,16.7v14.43H177.05v-14.43c0-9.21,7.48-16.7,16.7-16.7Z" style="fill: #6e7dbc;"/>
                                    <path d="M552.87,333H195.91s168.49-118.57,168.49-118.57c6.11-4.3,13.86-4.3,19.97,0l168.49,118.57Z" style="fill: #99a6d4;"/>
                                    <path d="M516.96,325.14H233.65s133.73-92.38,133.73-92.38c4.85-3.41,11-3.41,15.85,0l133.73,92.38Z" style="fill: #6e7dbc;"/>
                                    <path d="M210.38,516.32h65.83c10.05,0,18.21,8.16,18.21,18.21v13.54h-102.24v-13.54c0-10.05,8.16-18.21,18.21-18.21Z" style="fill: #bec8e5;"/>
                                    <path d="M340.4,516.32h65.83c10.05,0,18.21,8.16,18.21,18.21v13.54h-102.24v-13.54c0-10.05,8.16-18.21,18.21-18.21Z" style="fill: #bec8e5;"/>
                                    <path d="M470.41,516.32h65.83c10.05,0,18.21,8.16,18.21,18.21v13.54h-102.24v-13.54c0-10.05,8.16-18.21,18.21-18.21Z" style="fill: #bec8e5;"/>
                                    <path d="M193.9,537.57h365.5c8.9,0,16.13,7.23,16.13,16.13v34.64H177.77v-34.64c0-8.9,7.23-16.13,16.13-16.13Z" style="fill: #6e7dbc;"/>
                                    <path d="M178.86,553.32h394.55c8.79,0,15.93,7.14,15.93,15.93v19.08H162.93v-19.08c0-8.79,7.14-15.93,15.93-15.93Z" style="fill: #919dcf;"/>
                                    </g>
                                    <line x1="210.67" y1="395.92" x2="272.43" y2="395.92" style="fill: none; stroke: #243c7b; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.9px;"/>
                                    <line x1="472.45" y1="395.92" x2="534.21" y2="395.92" style="fill: none; stroke: #243c7b; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.9px;"/>
                                    <line x1="341.03" y1="395.92" x2="402.79" y2="395.92" style="fill: none; stroke: #243c7b; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.9px;"/>
                                    <line x1="589.19" y1="364.13" x2="638.39" y2="364.13" style="fill: none; stroke: #243c7b; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.9px;"/>
                                    <line x1="589.19" y1="553.32" x2="638.39" y2="553.32" style="fill: none; stroke: #243c7b; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.9px;"/>
                                    <line x1="472.45" y1="516.32" x2="534.21" y2="516.32" style="fill: none; stroke: #243c7b; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.9px;"/>
                                    <line x1="341.03" y1="516.32" x2="402.78" y2="516.32" style="fill: none; stroke: #243c7b; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.9px;"/>
                                    <line x1="209.6" y1="516.32" x2="271.36" y2="516.32" style="fill: none; stroke: #243c7b; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.9px;"/>
                                    <ellipse cx="572.71" cy="609.15" rx="79.16" ry="11.38" style="fill: #d7dcef;"/>
                                    <g>
                                    <g>
                                        <g>
                                        <rect x="531.44" y="584.07" width="82.54" height="21.34" style="fill: #f9a968;"/>
                                        <rect x="580.31" y="584.07" width="30.63" height="21.34" style="fill: #eb9049;"/>
                                        <rect x="564.62" y="584.07" width="12.83" height="21.34" style="fill: #f69f59;"/>
                                        <rect x="538.6" y="584.07" width="7.04" height="21.34" style="fill: #fbc08f;"/>
                                        </g>
                                        <rect x="531.44" y="602.24" width="82.54" height="3.17" style="fill: #d57b2d;"/>
                                    </g>
                                    <g>
                                        <g>
                                        <rect x="538.9" y="562.88" width="82.54" height="21.34" style="fill: #f9a968;"/>
                                        <rect x="587.77" y="562.88" width="30.63" height="21.34" style="fill: #eb9049;"/>
                                        <rect x="572.07" y="562.88" width="12.83" height="21.34" style="fill: #f69f59;"/>
                                        <rect x="546.06" y="562.88" width="7.04" height="21.34" style="fill: #fbc08f;"/>
                                        </g>
                                        <rect x="538.9" y="581.05" width="82.54" height="3.17" style="fill: #d57b2d;"/>
                                    </g>
                                    <g>
                                        <g>
                                        <rect x="529.8" y="541.22" width="82.54" height="21.34" style="fill: #f9a968;"/>
                                        <rect x="578.67" y="541.22" width="30.63" height="21.34" style="fill: #eb9049;"/>
                                        <rect x="562.98" y="541.22" width="12.83" height="21.34" style="fill: #f69f59;"/>
                                        <rect x="536.96" y="541.22" width="7.04" height="21.34" style="fill: #fbc08f;"/>
                                        </g>
                                        <rect x="529.8" y="559.39" width="82.54" height="3.17" style="fill: #d57b2d;"/>
                                    </g>
                                    <g>
                                        <g>
                                        <rect x="540.2" y="520" width="82.54" height="21.34" style="fill: #f9a968;"/>
                                        <rect x="589.07" y="520" width="30.63" height="21.34" style="fill: #eb9049;"/>
                                        <rect x="573.37" y="520" width="12.83" height="21.34" style="fill: #f69f59;"/>
                                        <rect x="547.36" y="519.99" width="7.04" height="21.34" style="fill: #fbc08f;"/>
                                        </g>
                                        <rect x="540.2" y="538.17" width="82.54" height="3.17" style="fill: #d57b2d;"/>
                                    </g>
                                    </g>
                                    <path d="M275.91,144.69c0,4.23-3.43,7.65-7.65,7.65-4.23,0-7.65-3.43-7.65-7.65s3.43-7.65,7.65-7.65c4.23,0,7.65,3.43,7.65,7.65Z" style="fill: none; fill-rule: evenodd; stroke: #2e4974; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 1.75px;"/>
                                    <path d="M688.1,88.99c0,4.23-3.43,7.65-7.65,7.65-4.23,0-7.65-3.43-7.65-7.65s3.43-7.65,7.65-7.65c4.23,0,7.65,3.43,7.65,7.65Z" style="fill: none; fill-rule: evenodd; stroke: #2e4974; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 1.75px;"/>
                                    <path d="M742.56,522.33c0,4.23-3.43,7.65-7.65,7.65-4.22,0-7.65-3.43-7.65-7.65s3.43-7.65,7.65-7.65c4.23,0,7.65,3.43,7.65,7.65Z" style="fill: none; fill-rule: evenodd; stroke: #2e4974; stroke-linecap: round; stroke-miterlimit: 10; stroke-width: 1.75px;"/>
                                    <g>
                                    <path d="M147.44,337.71c9.69-14.35,12.72-20.29,22.12-34.93l8.64,3.16c-14.47,32.2-8.7,36.6-20.7,45.67-15.59-3.48-11.56-10.09-10.06-13.9Z" style="fill: #c85835;"/>
                                    <path d="M112.27,297.39s8.93,1.71,21.9,16.77c11.93,13.85,30.52,26.39,30.43,31.06s-13.28,11.53-13.28,11.53l-43.56-23.33,4.5-36.02Z" style="fill: #d0d9ee; fill-rule: evenodd;"/>
                                    <path d="M173.23,308.87l8.29-3.7c1.66-.74,2.99-2.05,3.77-3.69l3.13-6.65c1.09-2.32-.47-5.01-3.03-5.21h0l-10.16,5.24c-2.24,1.16-4.08,3.24-5.16,5.83l-1.79,4.32,4.95,3.85Z" style="fill: #c85835;"/>
                                    <path d="M151.32,356.74s9.03,1.47,15.43-8.21c6.4-9.68,11.46-33.54,11.46-33.54l-18.41-3.81-16.96,36.73,8.48,8.83Z" style="fill: #d0d9ee;"/>
                                    </g>
                                    <path d="M150.58,614.31c.26,5.35-26.71,9.68-60.25,9.68s-60.93-4.34-61.19-9.68,26.71-9.68,60.25-9.68c33.53,0,60.93,4.34,61.19,9.68Z" style="fill: #dce0ee; fill-rule: evenodd;"/>
                                    <path d="M111.46,599.99s-15.61-65.64-6.45-92.83l-7.86-88.96,33.16,11.31-8.68,171.03-10.18-.54Z" style="fill: #d35d38; fill-rule: evenodd;"/>
                                    <polygon points="58.02 601.27 61.21 580.44 45.3 577.15 47.29 601.95 58.02 601.27" style="fill: #d35d38; fill-rule: evenodd;"/>
                                    <path d="M121.75,597.67l9.23,6.23c1.84,1.54,11.47,4.53,11.47,4.53h0c1.08,1.91-.68,2.92-2.22,3.17l-27.82-.57s-6.51-1.3-1.71-13.34c5.21,2.17,9.99,3.73,11.04-.01Z" style="fill: #4a2a1b; fill-rule: evenodd;"/>
                                    <path d="M58.4,597.76l8.88,6.23c1.8,1.54,8.53,4.53,8.53,4.53,1.03,1.91-.75,2.92-2.3,3.17l-24.97-.57s-6.83-1.31-1.73-13.36c2.79,2.53,9.86,5.51,11.59,0Z" style="fill: #4a2a1b; fill-rule: evenodd;"/>
                                    <path d="M133.07,430.41l-2.8,80.28-1.37,74.91h-25.92s.91-13.51-.12-17.8c-1.03-4.29-8.57-44.96-1.64-63.67l-12.71-76.21,44.56,2.48Z" style="fill: #6f83c0; fill-rule: evenodd;"/>
                                    <path d="M98.83,491.18l-10.55-63.25,15.48,.81,5.79,45.02c1.73,10.4,3.04,24.91,1.99,35.18-2.07,20.3-1.72,59.64-2.07,63.08-1.18,11.58,8.62,13.58,8.62,13.58h-15.35s.91-13.51-.12-17.8c-.9-3.74-6.75-35.18-3.63-55.57,1.05-6.84,1.02-13.92-.17-21.06Z" style="fill: #576ab0; fill-rule: evenodd;"/>
                                    <path d="M64.82,367.16l60.64,4.48c10,3.52,7.4,58.78,7.4,58.78l-38.28,1.73c-18.48-.38-45.27,17.89-42.36-11.86,3.92-40.15,12.6-53.14,12.6-53.14Z" style="fill: #6f83c0; fill-rule: evenodd;"/>
                                    <path d="M52.14,426.94l-3.65,72.47s-10.84,32.12-7.24,86.47l23.26-.4,16.57-93.08,12.97-76.12-41.91,10.67Z" style="fill: #6f83c0; fill-rule: evenodd;"/>
                                    <path d="M112.27,297.39l-22.14-5.13-6.08,.24-23.1,8.05c-7.78,3.85-11.39,12.89-8.42,21.07l5.65,26.44c1.92,23.21-2.43,41.06-8.06,54.44,32.75,12.16,75.25,12.5,85.58-2.53-1.74-41.08-7.5-76.15-23.45-102.59Z" style="fill: #d0d9ee; fill-rule: evenodd;"/>
                                    <path d="M102.22,293.74s7.26,17.98-5.08,18.77c-12.34,.79-19.09-17.9-19.09-17.9l9.01-4,15.16,3.13Z" style="fill: #c85835;"/>
                                    <polyline points="128.35 343.85 119.59 324.06 119.83 317.69" style="fill: none; fill-rule: evenodd; stroke: #9498c7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.62px;"/>
                                    <path d="M55.51,304.79s17.59,12.74,12.62,25.64c0,0-19.89,52.26-24.6,59.96-6.31,10.32-9.96-11.57-9.96-11.57l-23.85-16.89,18.07,5.45,.82-28.8,26.89-33.79Z" style="fill: #d0d9ee;"/>
                                    <path d="M29.5,395.82l37.11,1.61c1.9,.08,2.95-1.35,2.33-3.19l-19.53-57.5c-.62-1.84-2.69-3.41-4.59-3.49l-37.11-1.61c-1.9-.08-2.95,1.35-2.33,3.19l19.53,57.5c.62,1.84,2.69,3.41,4.59,3.49Z" style="fill: #4a2a1b;"/>
                                    <path d="M16.9,373.56l-5.76-5.09c-1.15-1.02-1.91-2.44-2.13-4l-.91-6.35c-.32-2.21,1.59-4.11,3.68-3.68h0l6.89,6.83c1.52,1.51,2.5,3.7,2.73,6.14l.16,1.64c.14,1.44-.67,2.81-2.01,3.38l-2.65,1.13Z" style="fill: #c85835;"/>
                                    <line x1="65.68" y1="319.03" x2="63.7" y2="343.7" style="fill: none; stroke: #9498c7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.62px;"/>
                                    <path d="M101.43,300.05l-8.92-1.87,3.6-29.19,11.03,7.72s1.77,18.28-5.72,23.33Z" style="fill: #3b1c16; fill-rule: evenodd;"/>
                                    <path d="M108.1,272.72s5.44,18.92-2.77,22.62c0,0-2.77,.71-2.77,.53s4.03-6.26,2.33-12.97c-1.7-6.71-.98-7.87-.98-7.87l4.2-2.31Z" style="fill: #3b1c16; fill-rule: evenodd;"/>
                                    <path d="M105.93,278.98s5.44,18.92-2.77,22.62c0,0-2.77,.71-2.77,.53s4.03-6.26,2.33-12.97c-1.7-6.71-.98-7.87-.98-7.87l4.2-2.31Z" style="fill: #3b1c16; fill-rule: evenodd;"/>
                                    <path d="M101.1,263.36s7.81-3.28,8.76,17.31c.65,14.01-17.71-5.17-17.71-5.17l8.94-12.14Z" style="fill: #3b1c16; fill-rule: evenodd;"/>
                                    <path d="M101.12,281.64s-1.78,8.52-3.26,15.58c-.39,1.88-1.73,3.41-3.49,4.01-1.77,.6-3.69,.17-5.03-1.13-.44-.42-.87-.84-1.27-1.23-1.84-1.77-2.5-4.51-1.71-7.02,2.03-6.43,5.74-18.16,5.74-18.16l9.02,7.94h0Z" style="fill: #c85835; fill-rule: evenodd;"/>
                                    <path d="M100.39,285.48l-1.23,5.09c-3.51-1.3-5.27-4.75-6.65-8.65l7.88,3.56Z" style="fill: #863b25; fill-rule: evenodd;"/>
                                    <path d="M88.38,271.86c-.42-2.39,1.09-4.69,3.38-5.15,2.44-.49,5.53-1.1,7.97-1.59,2.29-.46,4.14,1.2,4.91,3.49,.91,2.7,1.53,8.55,1.48,12.86-.03,2.43-1.42,4.94-3.71,5.4-2.44,.49-10.2-.47-11.72-4.88-1.15-3.36-1.69-6.61-2.31-10.12h0Z" style="fill: #c85835; fill-rule: evenodd;"/>
                                    <path d="M104.86,279.87l-3.99,.71s.52,2.82,2.41,2.25c1.88-.58,1.58-2.96,1.58-2.96Z" style="fill: #fff; fill-rule: evenodd;"/>
                                    <path d="M103.01,264.88s-5.01,12.36-9.63,13.26c-2.38,.46-2.34,3.9-4.22,5.16-3.4,2.29-8.73-7.23-7.88-11.24,1.25-5.91,2.94-8.11,9.95-10.54,4.28-1.49,9.28-3.39,11.78,3.36Z" style="fill: #3b1c16; fill-rule: evenodd;"/>
                                    <path d="M82.63,267.68s-14.51,26.05-1.05,31.91c0,0,9.26,3.46,8.81,3.19s-2.59-4.76-2.59-6.9l4.72,2.31s-5.87-7.9-2.2-17.4c3.67-9.5,2.2-8.08,2.2-8.08l-9.88-5.02Z" style="fill: #3b1c16; fill-rule: evenodd;"/>
                                    <path d="M87.52,281.85c.97,1.71,2.86,2.42,4.23,1.57s1.69-2.92,.72-4.64c-.97-1.71-2.86-2.42-4.23-1.57-1.37,.85-1.69,2.92-.72,4.64Z" style="fill: #c85835; fill-rule: evenodd;"/>
                                    <path d="M106.12,286.77s-.99,7.16-4.46,8c0,0,4.36,1.28,5.5-1.31" style="fill: none; fill-rule: evenodd; stroke: #261210; stroke-linecap: round; stroke-linejoin: round; stroke-width: .68px;"/>
                                    <path d="M87.84,295.5s-4.16-1.27-5.43-7.11" style="fill: none; fill-rule: evenodd; stroke: #261210; stroke-linecap: round; stroke-linejoin: round; stroke-width: .68px;"/>
                                    <g>
                                    <circle cx="374.39" cy="265.05" r="61.17" transform="translate(-45.28 450.24) rotate(-59.11)" style="fill: #f8a46e;"/>
                                    <path d="M396.19,215.18c-.15-2.4-.48-4.74-.9-7.05-7.71-2.81-16.1-4.13-24.81-3.57-33.71,2.16-59.29,31.25-57.12,64.96,.15,2.4,.48,4.74,.9,7.05,7.71,2.81,16.1,4.13,24.81,3.57,33.71-2.16,59.29-31.25,57.12-64.96Z" style="fill: #f8a46e;"/>
                                    <path d="M370.68,295.04c-6.48-.63-12.96-3.9-17.2-7.87l3.87-5.76c4.35,3.77,9.5,6.83,15.69,6.85,7.5,.03,11.26-4.11,11.29-10.4,.07-16.42-28.23-12.98-28.15-32.75,.04-9.02,5.94-15.48,14.76-16.77l.04-10.24,6.08,.02-.04,10.03c6.48,.74,10.73,3.89,14.36,7.76l-4.48,4.95c-3.74-3.66-6.87-5.8-12.34-5.83-6.18-.02-10.15,3.81-10.17,9.69-.06,14.7,28.24,10.75,28.15,32.55-.04,9.63-6.15,16.29-15.78,17.57l-.04,10.24-6.08-.02,.04-10.03Z" style="fill: #fff;"/>
                                    </g>
                                </g>
                                </svg>
                        </div>

                        <div class="svg3">
                            <svg class="svg-main-medical" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 859.09 742.62">
                                <g id="Layer_1-2" data-name="Layer 1">
                                    <path d="M844.27,471.2C919.83,234.38,694.84,14.93,434.12,76.7c-78.59,18.62-151.13,62.36-194.68,150.5C138.69,431.12,8.68,411.8,.21,558.22c-8.47,146.43,245.86,276.41,419.57,71.11,126.97-150.06,266.29,160.06,397.79-84.67,13.09-24.35,19.25-50.1,26.7-73.46Z" style="fill: #fe804d;"/>
                                    <path d="M481.45,193.56c-30.68,24.48-37.75,52.16-38.41,70.7-7.71-22.48-16.2-43.51-24.64-62.5,59.33-43.58,28.45-88.36,28.45-88.36-29.29,24.26-36.36,51.11-37.05,69.63-.04-.08-.08-.17-.12-.25-12.03-25.32-24.29-47.92-35.21-66.7,53.68-55.5,13.54-94.8,13.54-94.8-26.34,32.12-26.08,62.22-22.19,80.25-11.88-19.58-21.31-33.43-25.72-39.72C317.22,1.47,265.56,0,265.56,0c14.32,58.57,49.03,65.41,65.87,65.07,3.46,4.88,13.68,19.58,26.98,41.54-46.99-23.88-83.19-.13-83.19-.13,46.16,40.65,78.93,25,92.06,15.09,10.68,18.42,22.63,40.5,34.36,65.21,1.22,2.56,2.44,5.19,3.67,7.85-42.89-36.53-85.44-19.12-85.44-19.12,40.62,52.69,78.44,37.74,90.68,30.69,8.84,19.95,17.72,42.17,25.67,65.92-41.49-34.84-82.87-18.78-82.87-18.78,37.3,50.27,73.22,40.62,87.64,33.62,15.94,51.57,26.84,109.36,23.49,166.55-.15,2.47,1.74,4.59,4.22,4.74,.49,.03,.97-.02,1.43-.15,1.81-.49,3.2-2.09,3.31-4.07,3.45-58.9-7.86-118.3-24.3-171.11,63.09-42.93,32.3-89.37,32.3-89.37Z" style="fill: #b5d3ef;"/>
                                    <path d="M406.26,332.94c-24.76,30.46-25.77,59.01-22.45,77.26-12.33-20.32-25.1-39.06-37.4-55.81,48.68-55.23,8.96-92.39,8.96-92.39-23.44,29.94-24.63,57.68-21.36,75.93-.06-.07-.11-.15-.17-.22-17.15-22.18-33.95-41.64-48.62-57.66,40.61-65.67-6.98-95.51-6.98-95.51-18.89,37-12.22,66.35-4.57,83.14-15.78-16.6-27.95-28.12-33.59-33.33-35.21-54.06-86-44.49-86-44.49,26.48,54.17,61.85,53.45,78.23,49.53,4.43,4.03,17.54,16.22,35.22,34.84-51-13.31-81.3,17.61-81.3,17.61,53.77,29.87,82.45,7.6,93.16-4.88,14.37,15.72,30.74,34.75,47.47,56.39,1.74,2.25,3.49,4.55,5.26,6.89-49.69-26.55-87.55-.47-87.55-.47,50.92,42.82,84.68,20.15,95.14,10.65,12.89,17.6,26.3,37.42,39.13,58.93-47.96-25.19-84.97-.68-84.97-.68,47.16,41.16,80.2,24.08,92.8,14.16,26.57,46.98,49.53,101.13,58.45,157.71,.38,2.45,2.68,4.12,5.13,3.73,.49-.08,.95-.23,1.36-.45,1.67-.86,2.68-2.72,2.37-4.68-9.18-58.28-32.9-113.91-60.22-161.99,52.48-55.39,12.51-94.2,12.51-94.2Z" style="fill: #b5d3ef;"/>
                                    <g>
                                    <g>
                                        <ellipse cx="607.41" cy="716.5" rx="59.81" ry="25.92" transform="translate(-42 37.83) rotate(-3.45)" style="fill: #d4e7f7;"/>
                                        <g>
                                        <path d="M637.98,696.29c.51,1.86-.03,15.92-.92,17.96-1.62,6.46-7.66,12.69-18.01,17.41-22.7,10.35-57.44,9.5-77.6-1.9-9.4-5.31-14.56-10.81-14.84-17.8-.39-3.78-.77-14.33-.77-14.33,.68-2.32,3.69,.02,5.51-2.18,2.99-4.31,8.09-8.33,15.29-11.61,22.7-10.35,57.44-9.5,77.6,1.9,8.49,4.8,13.02,4.55,13.74,10.55Z" style="fill: #036686;"/>
                                        <ellipse cx="581.93" cy="695.92" rx="56.11" ry="28.7" transform="translate(-14.33 12.23) rotate(-1.19)" style="fill: #017296;"/>
                                        </g>
                                        <path d="M578.39,738.83s22.46-8.11,27.24-17.25c0,0,32.44-7.35,32.55-26.41,0,0,.77,1.48-.63,16.61,0,0-.32,9.83-13.67,17.39,0,0-16.79,10.68-45.48,9.66Z" style="fill: #014c64;"/>
                                    </g>
                                    <polyline points="565.37 690.38 566.36 701.92 612.75 689.2" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.49px;"/>
                                    </g>
                                    <g>
                                    <path d="M254.93,450.34s-6.67,13.25-21.39,16.1c-11.07,2.14-15.57,10.1-20.31,22.08-7.58,19.17-26.6,9.83-29.51,38.31-1.79,17.46,31.1,41.72,59.51,27.44,28.41-14.28,62.23,24.47,59-58.15-.4-10.29-10.87-9.43-9.9-18.86,1.06-10.34-12.38-27.11-12.38-27.11l-25.02,.19Z" style="fill: #24396b; fill-rule: evenodd;"/>
                                    <path d="M272.6,494.64c-7.08-7.02,.85-12.32,.85-12.32l14.79-3.1c5.7,3.13,13.08,15.86,20.06,26.32,2.52,2.14,5.71,3.16,8.92,2.84l24.17-7.92,.56,4.52-22.84,16.8c-9.71,4.38-20.88-5.03-22.88-6.43,0,0-15.21-12.36-23.63-20.71Z" style="fill: #de593f;"/>
                                    <path d="M347.98,503.62h0c-.22,1.66-1.45,2.88-2.74,2.73l-4.65-1.8c-1.3-.15-.37-.17-.15-1.83h0c.22-1.66-.99-2.01,1.56-2.28l3.65,.52c.47,.07,.94,.2,1.37,.42,.79,.42,1.14,.93,.97,2.23Z" style="fill: #de593f;"/>
                                    <path d="M335.06,501.98s-1.02,5.22,.37,11.07l-11.54,7.68c-4.63,3.08-10.32,4.31-15.73,3.04-7.51-1.76-13.95-7.02-16.96-14.65-.06-.15-.12-.31-.18-.47-5.97-15.64-5.94-38.75-5.94-38.75,0,0,4.42,1.02,7.67,6.4,2.41,3.99,12.51,18.74,17.56,26.08,1.81,2.63,4.81,4.15,8,4.05l16.75-4.47Z" style="fill: #fff;"/>
                                    <path d="M224.63,719.68c13.76-6.09,37.31-7.55,52.6-3.25,2.61,.73,4.8,1.59,6.58,2.53,9.71-2.73,22.87-3.07,31.93-.52,10.74,3.02,11.62,8.93,1.95,13.21-9.29,4.11-24.92,5.21-35.66,2.61-.64,.33-1.31,.66-2.03,.98-13.76,6.09-37.31,7.55-52.6,3.25-15.29-4.29-16.53-12.71-2.77-18.8Z" style="fill: #d4e7f7;"/>
                                    <path d="M252.15,717.77l-.1,8.22c-.06,.86-.85,5.44-1.21,6.23-1.03,2.3-2.74,3.26-4.4,3.43-2.2,.22-6.66-3.59-5.12-8.55,1.34-4.32,4.03-11.23,4.03-11.23,3.12,1.35,4.56,1.97,6.8,1.9Z" style="fill: #24396b;"/>
                                    <path d="M300.4,723.66l-11.31-13.16c-1.74-.89-5-1.18-7.65-.65-1.19,.24-1.81,1.05-1.89,2.26l-.29,2.25c-.37,3.77-.83,5.01,1.48,6.19l13.67,7.01c2.81,2.16,10.74,.87,5.99-3.9Z" style="fill: #24396b;"/>
                                    <path d="M288.64,711.87s6.46,7.85,5.63,8.43c-3.45,2.43-11.59-4.96-11.59-4.96,0,0,4.47-3.84,5.96-3.47Z" style="fill: #de593f;"/>
                                    <path d="M282.68,715.34c3.13-.07,5.92,1.53,6.26-3.11-.27-25.9,5.27-47.95,5.03-72.16-.27-27.18-2.24-27.59-2.71-69.25l-24.85,4.79c4.83,29.82,7.06,67.61,7.06,67.61-6.36,29.25,4.15,36.57,9.21,72.12Z" style="fill: #de593f;"/>
                                    <path d="M245.48,718.21c1.92,4.53,5.66,5.72,6.41,1.12,2.06-25.87,10.23-47.28,12.17-71.46,2.18-27.15,.26-27.74,3.54-69.35l-25.12,2.47c2.11,30.21,.93,68.12,.93,68.12-8.95,28.6,.25,33.16,2.08,69.11Z" style="fill: #de593f;"/>
                                    <path d="M289.62,536.22s17.16-4.08,12.76,91.33c0,0-17.9,7.54-34.5,11.98-15.64,4.19-25.39-14.2-38.07-9.72,0,0,8.14-18.3,7.27-26.83-.88-8.53-5.1-58.4,8.88-60.13,13.97-1.72,43.67-6.64,43.67-6.64Z" style="fill: #4b6eb5;"/>
                                    <path d="M229.8,629.83s1.44-19.9,.56-28.44c-.88-8.53,2.52-64.23,16.5-65.95,3.19-.39,6.29,6.48,10.57,5.85-1.14,8.31-3.35,21.94-7.63,44.23-5.7,29.72,3.64,46.03,12.97,54.63-12.78-.31-22.8,.16-32.97-10.33Z" style="fill: #4264af;"/>
                                    <path d="M280.46,468.92c-1.25-.27-2.53-.35-3.82-.24-5.92,.52-14.16-1.51-14.77-1.06l-11.03,5.9c-21.17,8.18-9.01,15.3-15.51,25.75,0,0,13.15,19.37,13.79,27.8,.55,7.28-5.36,19.02-6.48,21.45-1.45,3.14,9.08,21.42,36.66,16.23,21.72-4.09,18.81-13.05,17.79-25.09-.64-7.58-6.16-27.52-6.33-33.55-.17-6.03,4.16-10.86,.54-20.31-3.62-9.45-6.23-15.88-6.23-15.88l-4.62-1Z" style="fill: #4b6eb5;"/>
                                    <path d="M266.66,473.39l.68-.7c1.73,.43,3.27,.17,3.63-1.58l2-9.87c.36-1.75-.77-3.53-2.5-3.96l-.51-.13c-1.73-.43-4.45,.03-4.81,1.78l-2.56,10.42c-.36,1.75,2.34,3.61,4.07,4.04Z" style="fill: #de593f;"/>
                                    <path d="M271.85,466.52s-4.22-.26-6.79-4.6c0,0,2.49,6.41,6.31,7.27l.48-2.67Z" style="fill: #bc4242;"/>
                                    <path d="M263.72,446.07c1.63-2.67,4-3.17,6.15-1.69,2.18-.96,4.73,.36,6.55,3.78,2.53,4.77,3.01,12.39,.64,16.29-1.03,1.7-2.62,2.09-4.11,2.14-1.39,.05-2.79-.21-4.12-.7-4.75-1.77-4.85-1.05-6.54-4.23-2.53-4.77-.95-11.71,1.42-15.6Z" style="fill: #de593f;"/>
                                    <path d="M266.73,447.74c-1.94,4.67-2.66,15.44-2.98,16.87,0,0-11.46,.27-9.67-10.79,2.23-13.76,11.45-7.39,11.45-7.39l1.19,1.31Z" style="fill: #24396b;"/>
                                    <path d="M263.35,449.56c5.37-2.08,9.8-3.72,17.64,3.44,.67-1.16-.74-5.15-2.39-6.46-3.44-2.75-5.18-4.24-9-5.19l-.93-.13c-5.63-.77-8.73,1.36-10.19,6.87-.13,.48-1.2,2.68-1.25,3.09l1.84-.57c-.41,3.27,1.06-1.58,4.29-1.05Z" style="fill: #24396b;"/>
                                    <path d="M273.9,463.38h0c1.09-.3,2.12-1.91,2.3-3.61l-3.95,1.07c-.18,1.7,.56,2.83,1.65,2.54Z" style="fill: #fff;"/>
                                    <path d="M260.57,459.11c-.16,1.54,.93,2.9,2.45,3.03,1.52,.13,2.88-1.01,3.04-2.56,.16-1.54-.93-2.9-2.45-3.03-1.52-.13-2.88,1.01-3.04,2.56Z" style="fill: #de593f;"/>
                                    <path d="M242.47,548.77c1.12-2.42,7.03-14.16,6.48-21.45-.36-4.77-2.91-13.27-5.05-19.75,7.34,13.1,7.67,17.87,15.96,18.94-12.42,21.25-2.59,29.29-2.97,36.91-20.94,.24-15.7-11.87-14.42-14.65Z" style="fill: #ced7a6;"/>
                                    <path d="M271.71,467.28l2.9,1.28s1.37,4.61-.97,6.64l-4.23-2.63s1.37-1.49,1.96-3.38l.34-1.91Z" style="fill: #fff;"/>
                                    <path d="M269.41,472.57l-2.61,4.32s-7.8-3.47-7.92-8.41l4.3-1.57s2.83,6.14,6.23,5.66Z" style="fill: #fff;"/>
                                    <path d="M251.89,719.33s-1.4,8.89-5.06,8.25c-3.65-.63-1.35-9.37-1.35-9.37l6.41,1.12Z" style="fill: #de593f;"/>
                                    <path d="M253.89,469.64c.94-.52,2.12-.04,2.42,.98,1.31,4.43,4.23,14.81,4.17,19.26-.08,5.73,3.02,51.39,3.02,51.39,0,0-3.7,72.15-1.63,82.86,0,0-23.33,3.98-34.56-3.87,0,0,.57-28.79,.68-34.52,.11-5.73,6.27-44.12,7.7-50.22s-3.07-47.92-3.07-47.92c0,0-1.41-7.52,12.3-13.61,4.61-2.05,7.38-3.47,8.96-4.34Z" style="fill: #fff;"/>
                                    <path d="M278.7,468.12c-.48-.14-.89,.36-.65,.8,1.38,2.59,4.56,9.11,5.51,16.01,1.23,8.9,2.03,31.95,2.03,31.95,0,0,5.59,31.45,6.25,41.35,.65,9.9-.02,59.77-.02,59.77,5.54-.13,13.81-2.82,16.76-7.73,0,0-3.82-32.44-5.32-39.47-1.5-7.03-4.51-33.01-4.51-33.01,0,0-3.8-23.24-3.39-29.25,.42-6.01-1.85-25-1.85-25l-8.27-13.58-6.53-1.84Z" style="fill: #fff;"/>
                                    <path d="M259.19,552.46l24.93-.76c2.46-.08,4.74-2.11,5.06-4.52l6.08-44.74c.33-2.41-1.42-4.32-3.87-4.24l-24.93,.76c-2.46,.08-4.74,2.11-5.06,4.52l-6.08,44.74c-.33,2.41,1.42,4.32,3.87,4.24Z" style="fill: #26326d;"/>
                                    <path d="M291.66,536.53h0c.08,1.5-1.03,2.74-2.47,2.75l-4.98,.02c-1.43,0-2.66-1.22-2.74-2.72h0c-.08-1.5,1.03-2.74,2.47-2.75l4.98-.02c1.43,0,2.66,1.22,2.74,2.72Z" style="fill: #de593f;"/>
                                    <path d="M235.45,492.68s-6.4,34.06,3.46,48.2,45.98-1.56,45.98-1.56l-1.06-4.97-30.83-2.46-2.3-38.94-15.25-.26Z" style="fill: #de593f;"/>
                                    <path d="M277.55,533.43l.09,11.78s-16.9,6.41-28.95,4.42c-12.05-1.99-17.51-13.31-17.6-25.68-.09-12.37,1.5-37.24,1.5-37.24l14.99-7.01,6.46,12.42,1.25,33.82s1.04,6.08,22.25,7.49Z" style="fill: #fff;"/>
                                    <path d="M344.81,504.75h0c.66,.24,1.41-.1,1.65-.76l18.03-48.86c.24-.66-.1-1.41-.76-1.65h0c-.66-.24-1.41,.1-1.65,.76l-18.03,48.86c-.24,.66,.1,1.41,.76,1.65Z" style="fill: #26326d;"/>
                                    <path d="M251.9,505.31s-1.12,16.44,1.49,20.49" style="fill: none; stroke: #b4c5d5; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.25px;"/>
                                    <line x1="296.94" y1="514.77" x2="296.3" y2="510.25" style="fill: none; stroke: #b4c5d5; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.25px;"/>
                                    </g>
                                    <g>
                                    <path d="M675.18,659.34l82.08-68.27c11.36-9.75,4.14-27.64-12.88-31.89l-246.19-61.51,176.99,161.67Z" style="fill: #d4e7f7;"/>
                                    <path d="M649.2,665.75l-246.17-67.58c-8.04-2.36-13.29-9.59-13.26-18.28l1.53-396.21c.06-14.73,14.7-26.62,28.56-23.18l246.19,61.24c8.45,2.1,14.06,9.5,14.03,18.49l-1.57,407.16c-.06,15.08-15.33,22.45-29.3,18.36Z" style="fill: #c1cde9;"/>
                                    <path d="M643.03,669.52l-246.17-67.58c-8.04-2.36-13.29-9.59-13.26-18.28l1.53-396.21c.06-14.73,14.7-26.62,28.56-23.18l246.19,61.24c8.45,2.1,14.06,9.5,14.03,18.49l-1.57,407.16c-.06,15.08-15.33,22.45-29.3,18.36Z" style="fill: #017296;"/>
                                    <polygon points="654.5 644.21 401.49 576.03 402.98 191.74 656.01 252.62 654.5 644.21" style="fill: #dfedf9;"/>
                                    <path d="M582.14,196.57l-14.21-4.53,.03-6.76c.09-18.74-14.95-38.9-33.41-44.79h0c-18.46-5.89-33.64,4.62-33.73,23.36l-.03,6.76-14.21-4.53c-13-4.15-23.68,3.25-23.75,16.45h0c-.06,13.2,10.52,27.39,23.52,31.54l95.54,30.5c13,4.15,23.68-3.25,23.75-16.45h0c.06-13.2-10.52-27.39-23.52-31.54Zm-46.48-21.48l-2.51-.8c-4.56-1.46-8.28-6.44-8.26-11.07,.02-4.63,3.77-7.23,8.34-5.78l2.51,.8c4.56,1.46,8.28,6.44,8.26,11.07-.02,4.63-3.77,7.23-8.34,5.78Z" style="fill: #7889c4;"/>
                                    <path d="M574.48,200.63l-14.21-3.87,.03-6.76c.09-18.74-14.95-38.19-33.41-43.22h0c-18.47-5.03-33.65,6.2-33.73,24.94l-.03,6.76-14.21-3.87c-13-3.54-23.69,4.36-23.75,17.56h0c-.06,13.2,10.53,26.89,23.53,30.43l95.57,26.01c13,3.54,23.69-4.36,23.75-17.56h0c.06-13.2-10.53-26.89-23.53-30.43Zm-46.49-19.3l-2.51-.68c-4.56-1.24-8.28-6.05-8.26-10.68s3.77-7.41,8.34-6.17l2.51,.68c4.56,1.24,8.28,6.05,8.26,10.68-.02,4.63-3.77,7.41-8.34,6.17Z" style="fill: #bdd0eb;"/>
                                    </g>
                                    <path d="M714.02,181.37c.14,4.29-3.22,7.89-7.51,8.03-4.29,.14-7.89-3.22-8.03-7.51-.14-4.29,3.22-7.89,7.51-8.03,4.29-.14,7.89,3.22,8.03,7.51Z" style="fill: none; fill-rule: evenodd; stroke: #243c7c; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.43px;"/>
                                    <path d="M145.65,324.82c.14,4.29-3.22,7.89-7.51,8.03-4.29,.14-7.89-3.22-8.03-7.51-.14-4.29,3.22-7.89,7.51-8.03,4.29-.14,7.89,3.22,8.03,7.51Z" style="fill: none; fill-rule: evenodd; stroke: #243c7c; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.43px;"/>
                                    <path d="M804.28,587.68c.14,4.29-3.22,7.89-7.51,8.03-4.29,.14-7.89-3.22-8.03-7.51-.14-4.29,3.22-7.89,7.51-8.03,4.29-.14,7.89,3.22,8.03,7.51Z" style="fill: none; fill-rule: evenodd; stroke: #243c7c; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.43px;"/>
                                    <path class="animate-medical-card" d="M626.45,522.81h0c-49.64-32.5-86.34-71.41-85.8-122.74l1.26-120.44,89.61-16.88,88.77,63.51-1.26,120.44c.83,17.23-34.58,61.15-92.58,76.11Z" style="fill: #017296;"/>
                                    <path class="animate-medical-card" d="M557.63,302.87l71.67-13.5,70.99,50.79-1.01,96.33c-3.62,20.14-27.86,48.72-71.57,66.21-33.47-31.3-71.52-62.45-71.09-103.5l1.01-96.33Z" style="fill: #fff;"/>
                                    <g class="animate-medical-card">
                                    <polygon points="638.19 430.98 609.08 423.53 609.55 341.85 638.66 349.31 638.19 430.98" style="fill: #017296;"/>
                                    <polygon points="584.81 391.42 584.98 360.92 662.94 380.9 662.77 411.39 584.81 391.42" style="fill: #017296;"/>
                                    </g>
                                    <g class="animate-medical-card-two">
                                    <path  d="M373.97,536.21l3.31-157.75c.2-9.45,9.69-14.89,21.09-12.1l117.94,28.94c11.4,2.8,20.56,12.82,20.37,22.27l-3.31,157.75c-.2,9.45-9.69,14.89-21.09,12.1l-117.94-28.94c-11.4-2.8-20.56-12.82-20.36-22.27Z" style="fill: #fff;"/>
                                    <path d="M450.55,545.92h0c-25.66-16.9-44.56-37.29-44.02-64.54l1.26-63.96,46.7-9.61,45.86,33.07-1.26,63.96c.34,9.14-18.3,32.72-48.54,41.09Z" style="fill: #32ccfe;"/>
                                    <g>
                                        <polygon points="457.12 497.07 442.01 493.32 442.67 449.96 457.78 453.7 457.12 497.07" style="fill: #fff;"/>
                                        <polygon points="429.55 476.45 429.79 460.26 470.25 470.3 470 486.49 429.55 476.45" style="fill: #fff;"/>
                                    </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>

                    <div style="display: none;" class="svg-container" v-if="index == 3">
                        <div class="svg1">
                            <svg class="svg-main-medical" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 859.09 742.62">
                                <g id="Layer_1-2" data-name="Layer 1">
                                    <path d="M844.27,471.2C919.83,234.38,694.84,14.93,434.12,76.7c-78.59,18.62-151.13,62.36-194.68,150.5C138.69,431.12,8.68,411.8,.21,558.22c-8.47,146.43,245.86,276.41,419.57,71.11,126.97-150.06,266.29,160.06,397.79-84.67,13.09-24.35,19.25-50.1,26.7-73.46Z" style="fill: #44c8f5;"/>
                                    <path d="M481.45,193.56c-30.68,24.48-37.75,52.16-38.41,70.7-7.71-22.48-16.2-43.51-24.64-62.5,59.33-43.58,28.45-88.36,28.45-88.36-29.29,24.26-36.36,51.11-37.05,69.63-.04-.08-.08-.17-.12-.25-12.03-25.32-24.29-47.92-35.21-66.7,53.68-55.5,13.54-94.8,13.54-94.8-26.34,32.12-26.08,62.22-22.19,80.25-11.88-19.58-21.31-33.43-25.72-39.72C317.22,1.47,265.56,0,265.56,0c14.32,58.57,49.03,65.41,65.87,65.07,3.46,4.88,13.68,19.58,26.98,41.54-46.99-23.88-83.19-.13-83.19-.13,46.16,40.65,78.93,25,92.06,15.09,10.68,18.42,22.63,40.5,34.36,65.21,1.22,2.56,2.44,5.19,3.67,7.85-42.89-36.53-85.44-19.12-85.44-19.12,40.62,52.69,78.44,37.74,90.68,30.69,8.84,19.95,17.72,42.17,25.67,65.92-41.49-34.84-82.87-18.78-82.87-18.78,37.3,50.27,73.22,40.62,87.64,33.62,15.94,51.57,26.84,109.36,23.49,166.55-.15,2.47,1.74,4.59,4.22,4.74,.49,.03,.97-.02,1.43-.15,1.81-.49,3.2-2.09,3.31-4.07,3.45-58.9-7.86-118.3-24.3-171.11,63.09-42.93,32.3-89.37,32.3-89.37Z" style="fill: #b5d3ef;"/>
                                    <path d="M406.26,332.94c-24.76,30.46-25.77,59.01-22.45,77.26-12.33-20.32-25.1-39.06-37.4-55.81,48.68-55.23,8.96-92.39,8.96-92.39-23.44,29.94-24.63,57.68-21.36,75.93-.06-.07-.11-.15-.17-.22-17.15-22.18-33.95-41.64-48.62-57.66,40.61-65.67-6.98-95.51-6.98-95.51-18.89,37-12.22,66.35-4.57,83.14-15.78-16.6-27.95-28.12-33.59-33.33-35.21-54.06-86-44.49-86-44.49,26.48,54.17,61.85,53.45,78.23,49.53,4.43,4.03,17.54,16.22,35.22,34.84-51-13.31-81.3,17.61-81.3,17.61,53.77,29.87,82.45,7.6,93.16-4.88,14.37,15.72,30.74,34.75,47.47,56.39,1.74,2.25,3.49,4.55,5.26,6.89-49.69-26.55-87.55-.47-87.55-.47,50.92,42.82,84.68,20.15,95.14,10.65,12.89,17.6,26.3,37.42,39.13,58.93-47.96-25.19-84.97-.68-84.97-.68,47.16,41.16,80.2,24.08,92.8,14.16,26.57,46.98,49.53,101.13,58.45,157.71,.38,2.45,2.68,4.12,5.13,3.73,.49-.08,.95-.23,1.36-.45,1.67-.86,2.68-2.72,2.37-4.68-9.18-58.28-32.9-113.91-60.22-161.99,52.48-55.39,12.51-94.2,12.51-94.2Z" style="fill: #b5d3ef;"/>
                                    <g>
                                    <g>
                                        <ellipse cx="607.41" cy="716.5" rx="59.81" ry="25.92" transform="translate(-42 37.83) rotate(-3.45)" style="fill: #d4e7f7;"/>
                                        <g>
                                        <path d="M637.98,696.29c.51,1.86-.03,15.92-.92,17.96-1.62,6.46-7.66,12.69-18.01,17.41-22.7,10.35-57.44,9.5-77.6-1.9-9.4-5.31-14.56-10.81-14.84-17.8-.39-3.78-.77-14.33-.77-14.33,.68-2.32,3.69,.02,5.51-2.18,2.99-4.31,8.09-8.33,15.29-11.61,22.7-10.35,57.44-9.5,77.6,1.9,8.49,4.8,13.02,4.55,13.74,10.55Z" style="fill: #036686;"/>
                                        <ellipse cx="581.93" cy="695.92" rx="56.11" ry="28.7" transform="translate(-14.33 12.23) rotate(-1.19)" style="fill: #017296;"/>
                                        </g>
                                        <path d="M578.39,738.83s22.46-8.11,27.24-17.25c0,0,32.44-7.35,32.55-26.41,0,0,.77,1.48-.63,16.61,0,0-.32,9.83-13.67,17.39,0,0-16.79,10.68-45.48,9.66Z" style="fill: #014c64;"/>
                                    </g>
                                    <polyline points="565.37 690.38 566.36 701.92 612.75 689.2" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.49px;"/>
                                    </g>
                                    <g>
                                    <path d="M254.93,450.34s-6.67,13.25-21.39,16.1c-11.07,2.14-15.57,10.1-20.31,22.08-7.58,19.17-26.6,9.83-29.51,38.31-1.79,17.46,31.1,41.72,59.51,27.44,28.41-14.28,62.23,24.47,59-58.15-.4-10.29-10.87-9.43-9.9-18.86,1.06-10.34-12.38-27.11-12.38-27.11l-25.02,.19Z" style="fill: #24396b; fill-rule: evenodd;"/>
                                    <path d="M272.6,494.64c-7.08-7.02,.85-12.32,.85-12.32l14.79-3.1c5.7,3.13,13.08,15.86,20.06,26.32,2.52,2.14,5.71,3.16,8.92,2.84l24.17-7.92,.56,4.52-22.84,16.8c-9.71,4.38-20.88-5.03-22.88-6.43,0,0-15.21-12.36-23.63-20.71Z" style="fill: #de593f;"/>
                                    <path d="M347.98,503.62h0c-.22,1.66-1.45,2.88-2.74,2.73l-4.65-1.8c-1.3-.15-.37-.17-.15-1.83h0c.22-1.66-.99-2.01,1.56-2.28l3.65,.52c.47,.07,.94,.2,1.37,.42,.79,.42,1.14,.93,.97,2.23Z" style="fill: #de593f;"/>
                                    <path d="M335.06,501.98s-1.02,5.22,.37,11.07l-11.54,7.68c-4.63,3.08-10.32,4.31-15.73,3.04-7.51-1.76-13.95-7.02-16.96-14.65-.06-.15-.12-.31-.18-.47-5.97-15.64-5.94-38.75-5.94-38.75,0,0,4.42,1.02,7.67,6.4,2.41,3.99,12.51,18.74,17.56,26.08,1.81,2.63,4.81,4.15,8,4.05l16.75-4.47Z" style="fill: #fff;"/>
                                    <path d="M224.63,719.68c13.76-6.09,37.31-7.55,52.6-3.25,2.61,.73,4.8,1.59,6.58,2.53,9.71-2.73,22.87-3.07,31.93-.52,10.74,3.02,11.62,8.93,1.95,13.21-9.29,4.11-24.92,5.21-35.66,2.61-.64,.33-1.31,.66-2.03,.98-13.76,6.09-37.31,7.55-52.6,3.25-15.29-4.29-16.53-12.71-2.77-18.8Z" style="fill: #d4e7f7;"/>
                                    <path d="M252.15,717.77l-.1,8.22c-.06,.86-.85,5.44-1.21,6.23-1.03,2.3-2.74,3.26-4.4,3.43-2.2,.22-6.66-3.59-5.12-8.55,1.34-4.32,4.03-11.23,4.03-11.23,3.12,1.35,4.56,1.97,6.8,1.9Z" style="fill: #24396b;"/>
                                    <path d="M300.4,723.66l-11.31-13.16c-1.74-.89-5-1.18-7.65-.65-1.19,.24-1.81,1.05-1.89,2.26l-.29,2.25c-.37,3.77-.83,5.01,1.48,6.19l13.67,7.01c2.81,2.16,10.74,.87,5.99-3.9Z" style="fill: #24396b;"/>
                                    <path d="M288.64,711.87s6.46,7.85,5.63,8.43c-3.45,2.43-11.59-4.96-11.59-4.96,0,0,4.47-3.84,5.96-3.47Z" style="fill: #de593f;"/>
                                    <path d="M282.68,715.34c3.13-.07,5.92,1.53,6.26-3.11-.27-25.9,5.27-47.95,5.03-72.16-.27-27.18-2.24-27.59-2.71-69.25l-24.85,4.79c4.83,29.82,7.06,67.61,7.06,67.61-6.36,29.25,4.15,36.57,9.21,72.12Z" style="fill: #de593f;"/>
                                    <path d="M245.48,718.21c1.92,4.53,5.66,5.72,6.41,1.12,2.06-25.87,10.23-47.28,12.17-71.46,2.18-27.15,.26-27.74,3.54-69.35l-25.12,2.47c2.11,30.21,.93,68.12,.93,68.12-8.95,28.6,.25,33.16,2.08,69.11Z" style="fill: #de593f;"/>
                                    <path d="M289.62,536.22s17.16-4.08,12.76,91.33c0,0-17.9,7.54-34.5,11.98-15.64,4.19-25.39-14.2-38.07-9.72,0,0,8.14-18.3,7.27-26.83-.88-8.53-5.1-58.4,8.88-60.13,13.97-1.72,43.67-6.64,43.67-6.64Z" style="fill: #4b6eb5;"/>
                                    <path d="M229.8,629.83s1.44-19.9,.56-28.44c-.88-8.53,2.52-64.23,16.5-65.95,3.19-.39,6.29,6.48,10.57,5.85-1.14,8.31-3.35,21.94-7.63,44.23-5.7,29.72,3.64,46.03,12.97,54.63-12.78-.31-22.8,.16-32.97-10.33Z" style="fill: #4264af;"/>
                                    <path d="M280.46,468.92c-1.25-.27-2.53-.35-3.82-.24-5.92,.52-14.16-1.51-14.77-1.06l-11.03,5.9c-21.17,8.18-9.01,15.3-15.51,25.75,0,0,13.15,19.37,13.79,27.8,.55,7.28-5.36,19.02-6.48,21.45-1.45,3.14,9.08,21.42,36.66,16.23,21.72-4.09,18.81-13.05,17.79-25.09-.64-7.58-6.16-27.52-6.33-33.55-.17-6.03,4.16-10.86,.54-20.31-3.62-9.45-6.23-15.88-6.23-15.88l-4.62-1Z" style="fill: #4b6eb5;"/>
                                    <path d="M266.66,473.39l.68-.7c1.73,.43,3.27,.17,3.63-1.58l2-9.87c.36-1.75-.77-3.53-2.5-3.96l-.51-.13c-1.73-.43-4.45,.03-4.81,1.78l-2.56,10.42c-.36,1.75,2.34,3.61,4.07,4.04Z" style="fill: #de593f;"/>
                                    <path d="M271.85,466.52s-4.22-.26-6.79-4.6c0,0,2.49,6.41,6.31,7.27l.48-2.67Z" style="fill: #bc4242;"/>
                                    <path d="M263.72,446.07c1.63-2.67,4-3.17,6.15-1.69,2.18-.96,4.73,.36,6.55,3.78,2.53,4.77,3.01,12.39,.64,16.29-1.03,1.7-2.62,2.09-4.11,2.14-1.39,.05-2.79-.21-4.12-.7-4.75-1.77-4.85-1.05-6.54-4.23-2.53-4.77-.95-11.71,1.42-15.6Z" style="fill: #de593f;"/>
                                    <path d="M266.73,447.74c-1.94,4.67-2.66,15.44-2.98,16.87,0,0-11.46,.27-9.67-10.79,2.23-13.76,11.45-7.39,11.45-7.39l1.19,1.31Z" style="fill: #24396b;"/>
                                    <path d="M263.35,449.56c5.37-2.08,9.8-3.72,17.64,3.44,.67-1.16-.74-5.15-2.39-6.46-3.44-2.75-5.18-4.24-9-5.19l-.93-.13c-5.63-.77-8.73,1.36-10.19,6.87-.13,.48-1.2,2.68-1.25,3.09l1.84-.57c-.41,3.27,1.06-1.58,4.29-1.05Z" style="fill: #24396b;"/>
                                    <path d="M273.9,463.38h0c1.09-.3,2.12-1.91,2.3-3.61l-3.95,1.07c-.18,1.7,.56,2.83,1.65,2.54Z" style="fill: #fff;"/>
                                    <path d="M260.57,459.11c-.16,1.54,.93,2.9,2.45,3.03,1.52,.13,2.88-1.01,3.04-2.56,.16-1.54-.93-2.9-2.45-3.03-1.52-.13-2.88,1.01-3.04,2.56Z" style="fill: #de593f;"/>
                                    <path d="M242.47,548.77c1.12-2.42,7.03-14.16,6.48-21.45-.36-4.77-2.91-13.27-5.05-19.75,7.34,13.1,7.67,17.87,15.96,18.94-12.42,21.25-2.59,29.29-2.97,36.91-20.94,.24-15.7-11.87-14.42-14.65Z" style="fill: #ced7a6;"/>
                                    <path d="M271.71,467.28l2.9,1.28s1.37,4.61-.97,6.64l-4.23-2.63s1.37-1.49,1.96-3.38l.34-1.91Z" style="fill: #fff;"/>
                                    <path d="M269.41,472.57l-2.61,4.32s-7.8-3.47-7.92-8.41l4.3-1.57s2.83,6.14,6.23,5.66Z" style="fill: #fff;"/>
                                    <path d="M251.89,719.33s-1.4,8.89-5.06,8.25c-3.65-.63-1.35-9.37-1.35-9.37l6.41,1.12Z" style="fill: #de593f;"/>
                                    <path d="M253.89,469.64c.94-.52,2.12-.04,2.42,.98,1.31,4.43,4.23,14.81,4.17,19.26-.08,5.73,3.02,51.39,3.02,51.39,0,0-3.7,72.15-1.63,82.86,0,0-23.33,3.98-34.56-3.87,0,0,.57-28.79,.68-34.52,.11-5.73,6.27-44.12,7.7-50.22s-3.07-47.92-3.07-47.92c0,0-1.41-7.52,12.3-13.61,4.61-2.05,7.38-3.47,8.96-4.34Z" style="fill: #fff;"/>
                                    <path d="M278.7,468.12c-.48-.14-.89,.36-.65,.8,1.38,2.59,4.56,9.11,5.51,16.01,1.23,8.9,2.03,31.95,2.03,31.95,0,0,5.59,31.45,6.25,41.35,.65,9.9-.02,59.77-.02,59.77,5.54-.13,13.81-2.82,16.76-7.73,0,0-3.82-32.44-5.32-39.47-1.5-7.03-4.51-33.01-4.51-33.01,0,0-3.8-23.24-3.39-29.25,.42-6.01-1.85-25-1.85-25l-8.27-13.58-6.53-1.84Z" style="fill: #fff;"/>
                                    <path d="M259.19,552.46l24.93-.76c2.46-.08,4.74-2.11,5.06-4.52l6.08-44.74c.33-2.41-1.42-4.32-3.87-4.24l-24.93,.76c-2.46,.08-4.74,2.11-5.06,4.52l-6.08,44.74c-.33,2.41,1.42,4.32,3.87,4.24Z" style="fill: #26326d;"/>
                                    <path d="M291.66,536.53h0c.08,1.5-1.03,2.74-2.47,2.75l-4.98,.02c-1.43,0-2.66-1.22-2.74-2.72h0c-.08-1.5,1.03-2.74,2.47-2.75l4.98-.02c1.43,0,2.66,1.22,2.74,2.72Z" style="fill: #de593f;"/>
                                    <path d="M235.45,492.68s-6.4,34.06,3.46,48.2,45.98-1.56,45.98-1.56l-1.06-4.97-30.83-2.46-2.3-38.94-15.25-.26Z" style="fill: #de593f;"/>
                                    <path d="M277.55,533.43l.09,11.78s-16.9,6.41-28.95,4.42c-12.05-1.99-17.51-13.31-17.6-25.68-.09-12.37,1.5-37.24,1.5-37.24l14.99-7.01,6.46,12.42,1.25,33.82s1.04,6.08,22.25,7.49Z" style="fill: #fff;"/>
                                    <path d="M344.81,504.75h0c.66,.24,1.41-.1,1.65-.76l18.03-48.86c.24-.66-.1-1.41-.76-1.65h0c-.66-.24-1.41,.1-1.65,.76l-18.03,48.86c-.24,.66,.1,1.41,.76,1.65Z" style="fill: #26326d;"/>
                                    <path d="M251.9,505.31s-1.12,16.44,1.49,20.49" style="fill: none; stroke: #b4c5d5; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.25px;"/>
                                    <line x1="296.94" y1="514.77" x2="296.3" y2="510.25" style="fill: none; stroke: #b4c5d5; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.25px;"/>
                                    </g>
                                    <g>
                                    <path d="M675.18,659.34l82.08-68.27c11.36-9.75,4.14-27.64-12.88-31.89l-246.19-61.51,176.99,161.67Z" style="fill: #d4e7f7;"/>
                                    <path d="M649.2,665.75l-246.17-67.58c-8.04-2.36-13.29-9.59-13.26-18.28l1.53-396.21c.06-14.73,14.7-26.62,28.56-23.18l246.19,61.24c8.45,2.1,14.06,9.5,14.03,18.49l-1.57,407.16c-.06,15.08-15.33,22.45-29.3,18.36Z" style="fill: #c1cde9;"/>
                                    <path d="M643.03,669.52l-246.17-67.58c-8.04-2.36-13.29-9.59-13.26-18.28l1.53-396.21c.06-14.73,14.7-26.62,28.56-23.18l246.19,61.24c8.45,2.1,14.06,9.5,14.03,18.49l-1.57,407.16c-.06,15.08-15.33,22.45-29.3,18.36Z" style="fill: #017296;"/>
                                    <polygon points="654.5 644.21 401.49 576.03 402.98 191.74 656.01 252.62 654.5 644.21" style="fill: #dfedf9;"/>
                                    <path d="M582.14,196.57l-14.21-4.53,.03-6.76c.09-18.74-14.95-38.9-33.41-44.79h0c-18.46-5.89-33.64,4.62-33.73,23.36l-.03,6.76-14.21-4.53c-13-4.15-23.68,3.25-23.75,16.45h0c-.06,13.2,10.52,27.39,23.52,31.54l95.54,30.5c13,4.15,23.68-3.25,23.75-16.45h0c.06-13.2-10.52-27.39-23.52-31.54Zm-46.48-21.48l-2.51-.8c-4.56-1.46-8.28-6.44-8.26-11.07,.02-4.63,3.77-7.23,8.34-5.78l2.51,.8c4.56,1.46,8.28,6.44,8.26,11.07-.02,4.63-3.77,7.23-8.34,5.78Z" style="fill: #7889c4;"/>
                                    <path d="M574.48,200.63l-14.21-3.87,.03-6.76c.09-18.74-14.95-38.19-33.41-43.22h0c-18.47-5.03-33.65,6.2-33.73,24.94l-.03,6.76-14.21-3.87c-13-3.54-23.69,4.36-23.75,17.56h0c-.06,13.2,10.53,26.89,23.53,30.43l95.57,26.01c13,3.54,23.69-4.36,23.75-17.56h0c.06-13.2-10.53-26.89-23.53-30.43Zm-46.49-19.3l-2.51-.68c-4.56-1.24-8.28-6.05-8.26-10.68s3.77-7.41,8.34-6.17l2.51,.68c4.56,1.24,8.28,6.05,8.26,10.68-.02,4.63-3.77,7.41-8.34,6.17Z" style="fill: #bdd0eb;"/>
                                    </g>
                                    <path d="M714.02,181.37c.14,4.29-3.22,7.89-7.51,8.03-4.29,.14-7.89-3.22-8.03-7.51-.14-4.29,3.22-7.89,7.51-8.03,4.29-.14,7.89,3.22,8.03,7.51Z" style="fill: none; fill-rule: evenodd; stroke: #243c7c; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.43px;"/>
                                    <path d="M145.65,324.82c.14,4.29-3.22,7.89-7.51,8.03-4.29,.14-7.89-3.22-8.03-7.51-.14-4.29,3.22-7.89,7.51-8.03,4.29-.14,7.89,3.22,8.03,7.51Z" style="fill: none; fill-rule: evenodd; stroke: #243c7c; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.43px;"/>
                                    <path d="M804.28,587.68c.14,4.29-3.22,7.89-7.51,8.03-4.29,.14-7.89-3.22-8.03-7.51-.14-4.29,3.22-7.89,7.51-8.03,4.29-.14,7.89,3.22,8.03,7.51Z" style="fill: none; fill-rule: evenodd; stroke: #243c7c; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.43px;"/>
                                    <path class="animate-medical-card" d="M626.45,522.81h0c-49.64-32.5-86.34-71.41-85.8-122.74l1.26-120.44,89.61-16.88,88.77,63.51-1.26,120.44c.83,17.23-34.58,61.15-92.58,76.11Z" style="fill: #017296;"/>
                                    <path class="animate-medical-card" d="M557.63,302.87l71.67-13.5,70.99,50.79-1.01,96.33c-3.62,20.14-27.86,48.72-71.57,66.21-33.47-31.3-71.52-62.45-71.09-103.5l1.01-96.33Z" style="fill: #fff;"/>
                                    <g class="animate-medical-card">
                                    <polygon points="638.19 430.98 609.08 423.53 609.55 341.85 638.66 349.31 638.19 430.98" style="fill: #017296;"/>
                                    <polygon points="584.81 391.42 584.98 360.92 662.94 380.9 662.77 411.39 584.81 391.42" style="fill: #017296;"/>
                                    </g>
                                    <g class="animate-medical-card-two">
                                    <path  d="M373.97,536.21l3.31-157.75c.2-9.45,9.69-14.89,21.09-12.1l117.94,28.94c11.4,2.8,20.56,12.82,20.37,22.27l-3.31,157.75c-.2,9.45-9.69,14.89-21.09,12.1l-117.94-28.94c-11.4-2.8-20.56-12.82-20.36-22.27Z" style="fill: #fff;"/>
                                    <path d="M450.55,545.92h0c-25.66-16.9-44.56-37.29-44.02-64.54l1.26-63.96,46.7-9.61,45.86,33.07-1.26,63.96c.34,9.14-18.3,32.72-48.54,41.09Z" style="fill: #f47f4f;"/>
                                    <g>
                                        <polygon points="457.12 497.07 442.01 493.32 442.67 449.96 457.78 453.7 457.12 497.07" style="fill: #fff;"/>
                                        <polygon points="429.55 476.45 429.79 460.26 470.25 470.3 470 486.49 429.55 476.45" style="fill: #fff;"/>
                                    </g>
                                    </g>
                                </g>
                            </svg>
                        </div>

                        <div class="svg2">
                            <svg class="svg-main-lawyer" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 710.81 636.06">
                                <g id="Layer_1-2" data-name="Layer 1">
                                    <path d="M652.53,267.85c85.45,103.67,37.35,213.63-22.33,266.46-15.76,13.95-40.38,20.53-59.01,23.86-100.24,17.9-115.69-89.66-215.14-82.87s-206.23,76.6-321.15-92.85S115.08,14.18,241.42,2.28c204.77-19.3,262.56,85.36,411.11,265.57Z" style="fill: #33f18a; fill-rule: evenodd;"/>
                                    <path d="M589.42,127.14c-1.58,4.38-6.41,6.66-10.79,5.08-4.38-1.58-6.66-6.41-5.08-10.79,1.58-4.38,6.41-6.66,10.79-5.08,4.38,1.58,6.66,6.41,5.08,10.79Z" style="fill: none; fill-rule: evenodd; stroke: #3a2712; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.79px;"/>
                                    <circle cx="29.09" cy="415.54" r="8.43" transform="translate(-359.4 265.19) rotate(-64.84)" style="fill: none; stroke: #3a2712; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.79px;"/>
                                    <path d="M150.58,43.93c-1.58,4.38-6.41,6.66-10.79,5.08s-6.66-6.41-5.08-10.79c1.58-4.38,6.41-6.66,10.79-5.08,4.38,1.58,6.66,6.41,5.08,10.79Z" style="fill: none; fill-rule: evenodd; stroke: #3a2712; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.79px;"/>
                                    <path d="M408.52,334.26v-4.63c0-8.48-6.88-15.36-15.36-15.36h-106.8c-8.48,0-15.36,6.88-15.36,15.36v4.64c-9.32,1.06-16.56,8.96-16.56,18.56v9.52c0,5.06,4.1,9.17,9.17,9.17h152.35c5.06,0,9.17-4.1,9.17-9.17v-9.52c0-9.62-7.26-17.53-16.6-18.57Z" style="fill: #735530;"/>
                                    <path d="M416.4,371.52c5.06,0,9.17-4.1,9.17-9.17v-9.52c0-9.62-7.26-17.53-16.6-18.57v-4.63c0-8.48-6.88-15.36-15.36-15.36h-19.11c-25.3,33.59-60.07,49.62-86.67,57.25h128.57Z" style="fill: #5f4727;"/>
                                    <g>
                                    <g>
                                        <ellipse cx="307.62" cy="622.04" rx="306.92" ry="14.02" style="fill: #ecded4;"/>
                                        <path d="M84.66,617.52h222.96s0-94.02,0-94.02H84.66c21.68,0,21.68,94.02,0,94.02Z" style="fill: #f9f2ed;"/>
                                        <path d="M85.61,526.35h222.01v-11.42H85.61c-3.15,0-5.71,2.56-5.71,5.71h0c0,3.15,2.56,5.71,5.71,5.71Z" style="fill: #2bb8d8;"/>
                                        <path d="M86.04,623.65h221.58v-12.27H86.04c-3.39,0-6.14,2.75-6.14,6.14h0c0,3.39,2.75,6.14,6.14,6.14Z" style="fill: #2bb8d8;"/>
                                        <path d="M248.24,514.93h230.45c4.93,0,4.93,108.73,0,108.73H248.24c26.14,0,26.14-108.73,0-108.73Z" style="fill: #2bb8d8;"/>
                                        <path d="M263.67,514.93h260.54c19.07,0,34.53,15.46,34.53,34.53v39.66c0,19.07-15.46,34.53-34.53,34.53H263.67c26.14,0,26.14-108.73,0-108.73Z" style="fill: #32ccfe;"/>
                                        <line x1="248.24" y1="539.36" x2="108.46" y2="539.36" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <line x1="248.24" y1="561.25" x2="108.46" y2="561.25" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <line x1="248.24" y1="583.14" x2="108.46" y2="583.14" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <line x1="248.24" y1="605.04" x2="108.46" y2="605.04" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <g>
                                        <rect x="108.46" y="448.58" width="22.99" height="60.01" style="fill: #98928a;"/>
                                        <g>
                                            <path d="M119.95,504.9h216.22s0-53.46,0-53.46H119.95c-2.53,19.42-2.61,37.29,0,53.46Z" style="fill: #f9f2ed;"/>
                                            <path d="M114.17,454.3h222.01v-11.42H114.17c-3.15,0-5.71,2.56-5.71,5.71h0c0,3.15,2.56,5.71,5.71,5.71Z" style="fill: #98928a;"/>
                                            <path d="M114.59,514.73h221.58v-12.27H114.59c-3.39,0-6.14,2.75-6.14,6.14h0c0,3.39,2.75,6.14,6.14,6.14Z" style="fill: #98928a;"/>
                                            <path d="M280.5,442.87h255.67c9.16,0,16.59,2.26,16.59,11.42-15.31,14.11-17.87,36.69,0,48.16,0,9.16-7.43,12.27-16.59,12.27h-255.67v-71.86Z" style="fill: #7d756a;"/>
                                            <path d="M280.5,454.29h272.26c-10.65,16.99-10.07,32.99,0,48.16H280.5c-2.75-16.47-3.16-32.59,0-48.16Z" style="fill: #e0d5cc;"/>
                                            <line x1="271.23" y1="467.3" x2="131.45" y2="467.3" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                            <line x1="271.23" y1="489.2" x2="131.45" y2="489.2" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        </g>
                                        </g>
                                        <g>
                                        <path d="M177.86,438.73h150.42s0-63.43,0-63.43H177.86c14.63,0,14.63,63.43,0,63.43Z" style="fill: #f9f2ed;"/>
                                        <path d="M178.5,377.42h149.78s0-7.71,0-7.71H178.5c-2.13,0-3.85,1.72-3.85,3.85h0c0,2.13,1.73,3.85,3.85,3.85Z" style="fill: #ecaf7e;"/>
                                        <path d="M174.65,434.79h149.49c2.28,0,4.14,1.85,4.14,4.14h0c0,2.28-1.85,4.14-4.14,4.14H174.65v-8.28h0Z" transform="translate(502.93 877.86) rotate(-180)" style="fill: #ecaf7e;"/>
                                        <path d="M288.22,369.52h155.48c3.33,0,3.33,73.35,0,73.35h-155.48c17.64,0,17.64-73.35,0-73.35Z" style="fill: #ecaf7e;"/>
                                        <path d="M298.63,369.52h175.78c12.87,0,23.3,10.43,23.3,23.3v26.76c0,12.87-10.43,23.3-23.3,23.3h-175.78c17.64,0,17.64-73.35,0-73.35Z" style="fill: #f37f4f;"/>
                                        <line x1="288.22" y1="386" x2="193.91" y2="386" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <line x1="288.22" y1="400.77" x2="193.91" y2="400.77" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <line x1="288.22" y1="415.54" x2="193.91" y2="415.54" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        <line x1="288.22" y1="430.31" x2="193.91" y2="430.31" style="fill: none; stroke: #c8c0b7; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.72px;"/>
                                        </g>
                                    </g>
                                    <path d="M394.33,623.65h-54.32c16.75,0,16.75-108.92,0-108.92h54.32c17.2,0,17.2,108.92,0,108.92Z" style="fill: #f9f2ed;"/>
                                    </g>
                                    <rect x="325.73" y="74.22" width="28.56" height="257.93" style="fill: #735530;"/>
                                    <path d="M349.28,90.44h-18.39c-8.38,0-15.67-5.72-17.66-13.85h0c-1.11-4.51,2.31-8.87,6.95-8.87h39.83c4.8,0,8.24,4.63,6.86,9.22l-.16,.55c-2.31,7.69-9.39,12.95-17.42,12.95Z" style="fill: #735530;"/>
                                    <path class="rotate-lawyer" d="M475.53,124.28H204.66c-3.81,0-6.92-3.12-6.92-6.92h0c0-3.81,3.12-6.92,6.92-6.92H475.53c3.81,0,6.92,3.12,6.92,6.92h0c0,3.81-3.12,6.92-6.92,6.92Z" style="fill: #5f4727;"/>
                                    <path class="rotate-scale" d="M158.76,208.35c-1.81,0-2.85,2.08-1.75,3.52,8.4,10.98,21.6,17.85,36.11,17.85h45.98c14.46,0,27.68-6.84,36.11-17.84,1.1-1.44,.06-3.52-1.75-3.52h-114.69Z" style="fill: #735530;"/>
                                    <polyline class="rotate-scale" points="158.76 208.35 216.1 122.96 273.44 208.35" style="fill: none; stroke: #5f4727; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px;"/>
                                    <path class="rotate-scale-two" d="M405.61,208.35c-1.81,0-2.85,2.08-1.75,3.52,8.4,10.98,21.6,17.85,36.11,17.85h45.98c14.46,0,27.68-6.84,36.11-17.84,1.1-1.44,.06-3.52-1.75-3.52h-114.69Z" style="fill: #735530;"/>
                                    <polyline class="rotate-scale-two" points="405.61 208.35 462.96 122.96 520.3 208.35" style="fill: none; stroke: #5f4727; stroke-linecap: round; stroke-linejoin: round; stroke-width: 3px;"/>
                                    <path d="M594.85,345.6s-5.38-.73-17.18,3.61c-14.92,5.49-34.66,12.72-37.42,15.71-2.76,2.98,11.3,15.09,11.3,15.09l41.1-8.78,2.2-25.63Z" style="fill: #c1ac9f; fill-rule: evenodd;"/>
                                    <path d="M564.51,625.59c0,2.76,32.75,5,73.15,5,40.4,0,73.15-2.24,73.15-5,0-2.76-32.75-5-73.15-5-40.4,0-73.15,2.24-73.15,5Z" style="fill: #ecded4; fill-rule: evenodd;"/>
                                    <path d="M642.83,351.94c-.24-1.37,.26-2.74,1.12-3.83,7.01-8.81-6.58-15.82-10.5-18.96-4.09-3.27,1.17-10.41-7.72-13.8-8.89-3.39-12.01,1.21-12.44,1.05-.62-.23,.74,8.77,.74,8.77,0,0,4.44,1.64,3.98,10.64-.46,9.01-3.04,13.59,2.22,20.9,5.26,7.31,27.72-.9,27.72-.9-3.67-.19-4.82-2.15-5.12-3.88Z" style="fill: #4a2a1b; fill-rule: evenodd;"/>
                                    <path d="M614.75,616.46s4.46-58.32-7.27-82.47l-5.51-79.03-27.24,10.05,31.26,151.94,8.77-.48Z" style="fill: #e2623d; fill-rule: evenodd;"/>
                                    <polygon points="664.74 617.61 655.63 599.47 670.77 595.37 674.27 618.2 664.74 617.61" style="fill: #e2623d; fill-rule: evenodd;"/>
                                    <path d="M609.73,465.62l17.51,60.33s12.93,59.7,24.21,76.97l25.73,.54-19.42-80.38-15-66.86-33.03,9.4Z" style="fill: #735530; fill-rule: evenodd;"/>
                                    <path d="M605.7,614.38l-7.62,5.55c-1.5,1.37-9.68,4.04-9.68,4.04h0c-.82,1.7,.78,2.6,2.13,2.83l24.13-.51s5.57-1.16,.63-11.9c-4.39,1.94-8.44,3.33-9.59-.01Z" style="fill: #4a2a1b; fill-rule: evenodd;"/>
                                    <path d="M673.54,614.47l7.62,5.55c1.5,1.37,9.68,4.04,9.68,4.04h0c.82,1.7-.78,2.6-2.13,2.83l-24.13-.51s-5.57-1.16-.63-11.9c4.39,1.94,8.44,3.33,9.59-.01Z" style="fill: #4a2a1b; fill-rule: evenodd;"/>
                                    <path d="M571.94,465.2l14.79,72.32,11.37,67.43h22.51s-2.62-12.16-2.31-16.02c.31-3.86,1.33-40.47-7.23-57.31l.68-68.59-39.81,2.18Z" style="fill: #735530; fill-rule: evenodd;"/>
                                    <path d="M611.27,531.61l.68-68.59-13.34,.73,1.09,40.52c-.09,9.36,.75,22.42,3.06,31.67,4.56,18.28,9.6,53.68,10.37,56.78,2.6,10.42-5.64,12.23-5.64,12.23h13.33s-2.62-12.16-2.31-16.02c.31-3.86,1.33-40.47-7.23-57.31Z" style="fill: #5f4727; fill-rule: evenodd;"/>
                                    <path d="M535.99,366.07c-15.07,.05-20.15-.89-35.28-1.19l-6.49,8.92c30.28,5.14,38.13,10.15,50.49,5.88,5.04-12.95-5.25-12.84-8.73-13.61Z" style="fill: #c85835;"/>
                                    <path d="M629.57,408.84l-52.49,4c-8.54,3.14-5.13,52.36-5.13,52.36l34.52,1.6c16.04-.33,35,12.24,37-14.48,2.28-30.54-13.89-43.48-13.89-43.48Z" style="fill: #735530; fill-rule: evenodd;"/>
                                    <path d="M642.83,455.92s-33.73,3.33-45.06-11.97l46.7-4.01s.48,10.64-1.63,15.98Z" style="fill: #5f4727; fill-rule: evenodd;"/>
                                    <path d="M592.18,346.3l19.28-2.26,5.29,.21,20.09,7.01c6.77,3.35,9.91,11.21,7.32,18.33l-4.92,23c-1.67,20.19,2.11,35.72,7.01,47.36-28.49,10.58-67.64,10.06-76.63-3.01,1.52-35.73,8.69-67.64,22.56-90.63Z" style="fill: #c1ac9f; fill-rule: evenodd;"/>
                                    <path d="M601.97,333.92s1.01,7.59,1.85,13.87c.22,1.67,1.32,3.1,2.87,3.72,1.55,.62,3.32,.35,4.62-.71,.43-.35,.84-.69,1.23-1.01,1.78-1.46,2.58-3.82,2.04-6.07-1.39-5.77-3.91-16.28-3.91-16.28l-8.7,6.48h0Z" style="fill: #c85835; fill-rule: evenodd;"/>
                                    <polygon points="602.17 338.1 603.12 342.6 606.89 338.1 602.17 338.1" style="fill: #863b25; fill-rule: evenodd;"/>
                                    <path d="M600.94,345.33s-6.32,15.64,4.42,16.32c10.73,.69,16.61-15.57,16.61-15.57l-7.84-3.48-13.19,2.73Z" style="fill: #c85835;"/>
                                    <path d="M614.53,325.77c.72-2.13-.41-4.43-2.51-5.15-2.24-.77-5.07-1.73-7.31-2.5-2.1-.72-4.07,.56-5.1,2.55-1.22,2.35-2.57,7.62-3.09,11.57-.29,2.22,.69,4.7,2.79,5.42,2.24,.77,9.69,.9,11.71-2.94,1.53-2.92,2.47-5.83,3.52-8.96h0Z" style="fill: #c85835; fill-rule: evenodd;"/>
                                    <path d="M620.81,336.17s-.05-11.51-2.8-15.26c-3.69-5.03-9.25-8.39-16.66-4.01,0,0,2.62,9.33,16.66,18.92l2.81,.35Z" style="fill: #4a2a1b; fill-rule: evenodd;"/>
                                    <path d="M614.02,335.01c-1.14,1.44-3.02,1.84-4.2,.88-1.18-.95-1.2-2.89-.06-4.33,1.14-1.44,3.02-1.84,4.2-.88,1.18,.95,1.2,2.89,.06,4.33Z" style="fill: #c85835; fill-rule: evenodd;"/>
                                    <path d="M597.91,330.94l3.67,1.17s-.87,2.51-2.57,1.74c-1.7-.77-1.1-2.91-1.1-2.91Z" style="fill: #fff; fill-rule: evenodd;"/>
                                    <path d="M657.91,405.89l-26.58-30.76c-5.79-5.77-5.03-15.35,1.59-20.14h0c2.61-1.89,6.25-1.33,8.18,1.25l26.09,33.13-9.28,16.52Z" style="fill: #c85835; fill-rule: evenodd;"/>
                                    <path d="M664.12,386.85c6.15,4.09,8.89,10.98,5.01,18.61l-26.16,32.64-4.28-7.59,15.47-27.38,9.97-16.28Z" style="fill: #c85835; fill-rule: evenodd;"/>
                                    <path d="M638.72,430.56l-1.01,7.55c-.2,1.51,.14,3.04,.98,4.32l3.37,5.17c1.17,1.8,3.79,1.87,5.06,.14h0l.73-9.56c.16-2.11-.52-4.35-1.89-6.26l-2.3-3.19-4.93,1.83Z" style="fill: #c85835;"/>
                                    <path d="M613.59,316.59s4.88-.3,5.87,6.59" style="fill: none; fill-rule: evenodd; stroke: #8a929b; stroke-linecap: round; stroke-linejoin: round; stroke-width: .89px;"/>
                                    <path d="M624.24,369.41l24.43,28.48,3.24,4.63-9.03,18.87,9.72,8.45,18.41-22.81s5.08-9.35-2.2-18.29c-7.28-8.95-27.04-33.59-27.04-33.59l-12.64-4.4-4.89,18.66Z" style="fill: #c1ac9f; fill-rule: evenodd;"/>
                                    <polyline points="640.45 387.57 632.1 376.33 632.72 372.53" style="fill: none; fill-rule: evenodd; stroke: #807262; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.44px;"/>
                                    <path d="M500.71,364.88l-9.41-3.23c-1.88-.65-3.93-.59-5.78,.14l-7.47,2.99c-2.6,1.04-3.36,4.37-1.47,6.44h0l12.06,3.39c2.66,.75,5.69,.45,8.49-.82l4.66-2.13-1.09-6.79Z" style="fill: #c85835;"/>
                                    <path d="M545.65,366.97s16.11,10.85,6.24,12.96c-17.59,3.76-47.86,.48-47.86,.48l3.22-16.03,39.91-1.82-1.51,4.41Z" style="fill: #c1ac9f;"/>
                                    <polyline points="582.79 361.67 583.58 365.48 579.38 378.03" style="fill: none; fill-rule: evenodd; stroke: #807262; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.44px;"/>
                                </g>
                                </svg>
                        </div>

                        <div class="svg3">
                            <svg class="svg-main-medical" id="Layer_2" data-name="Layer 2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 859.09 742.62">
                                <g id="Layer_1-2" data-name="Layer 1">
                                    <path d="M844.27,471.2C919.83,234.38,694.84,14.93,434.12,76.7c-78.59,18.62-151.13,62.36-194.68,150.5C138.69,431.12,8.68,411.8,.21,558.22c-8.47,146.43,245.86,276.41,419.57,71.11,126.97-150.06,266.29,160.06,397.79-84.67,13.09-24.35,19.25-50.1,26.7-73.46Z" style="fill: #fe804d;"/>
                                    <path d="M481.45,193.56c-30.68,24.48-37.75,52.16-38.41,70.7-7.71-22.48-16.2-43.51-24.64-62.5,59.33-43.58,28.45-88.36,28.45-88.36-29.29,24.26-36.36,51.11-37.05,69.63-.04-.08-.08-.17-.12-.25-12.03-25.32-24.29-47.92-35.21-66.7,53.68-55.5,13.54-94.8,13.54-94.8-26.34,32.12-26.08,62.22-22.19,80.25-11.88-19.58-21.31-33.43-25.72-39.72C317.22,1.47,265.56,0,265.56,0c14.32,58.57,49.03,65.41,65.87,65.07,3.46,4.88,13.68,19.58,26.98,41.54-46.99-23.88-83.19-.13-83.19-.13,46.16,40.65,78.93,25,92.06,15.09,10.68,18.42,22.63,40.5,34.36,65.21,1.22,2.56,2.44,5.19,3.67,7.85-42.89-36.53-85.44-19.12-85.44-19.12,40.62,52.69,78.44,37.74,90.68,30.69,8.84,19.95,17.72,42.17,25.67,65.92-41.49-34.84-82.87-18.78-82.87-18.78,37.3,50.27,73.22,40.62,87.64,33.62,15.94,51.57,26.84,109.36,23.49,166.55-.15,2.47,1.74,4.59,4.22,4.74,.49,.03,.97-.02,1.43-.15,1.81-.49,3.2-2.09,3.31-4.07,3.45-58.9-7.86-118.3-24.3-171.11,63.09-42.93,32.3-89.37,32.3-89.37Z" style="fill: #b5d3ef;"/>
                                    <path d="M406.26,332.94c-24.76,30.46-25.77,59.01-22.45,77.26-12.33-20.32-25.1-39.06-37.4-55.81,48.68-55.23,8.96-92.39,8.96-92.39-23.44,29.94-24.63,57.68-21.36,75.93-.06-.07-.11-.15-.17-.22-17.15-22.18-33.95-41.64-48.62-57.66,40.61-65.67-6.98-95.51-6.98-95.51-18.89,37-12.22,66.35-4.57,83.14-15.78-16.6-27.95-28.12-33.59-33.33-35.21-54.06-86-44.49-86-44.49,26.48,54.17,61.85,53.45,78.23,49.53,4.43,4.03,17.54,16.22,35.22,34.84-51-13.31-81.3,17.61-81.3,17.61,53.77,29.87,82.45,7.6,93.16-4.88,14.37,15.72,30.74,34.75,47.47,56.39,1.74,2.25,3.49,4.55,5.26,6.89-49.69-26.55-87.55-.47-87.55-.47,50.92,42.82,84.68,20.15,95.14,10.65,12.89,17.6,26.3,37.42,39.13,58.93-47.96-25.19-84.97-.68-84.97-.68,47.16,41.16,80.2,24.08,92.8,14.16,26.57,46.98,49.53,101.13,58.45,157.71,.38,2.45,2.68,4.12,5.13,3.73,.49-.08,.95-.23,1.36-.45,1.67-.86,2.68-2.72,2.37-4.68-9.18-58.28-32.9-113.91-60.22-161.99,52.48-55.39,12.51-94.2,12.51-94.2Z" style="fill: #b5d3ef;"/>
                                    <g>
                                    <g>
                                        <ellipse cx="607.41" cy="716.5" rx="59.81" ry="25.92" transform="translate(-42 37.83) rotate(-3.45)" style="fill: #d4e7f7;"/>
                                        <g>
                                        <path d="M637.98,696.29c.51,1.86-.03,15.92-.92,17.96-1.62,6.46-7.66,12.69-18.01,17.41-22.7,10.35-57.44,9.5-77.6-1.9-9.4-5.31-14.56-10.81-14.84-17.8-.39-3.78-.77-14.33-.77-14.33,.68-2.32,3.69,.02,5.51-2.18,2.99-4.31,8.09-8.33,15.29-11.61,22.7-10.35,57.44-9.5,77.6,1.9,8.49,4.8,13.02,4.55,13.74,10.55Z" style="fill: #036686;"/>
                                        <ellipse cx="581.93" cy="695.92" rx="56.11" ry="28.7" transform="translate(-14.33 12.23) rotate(-1.19)" style="fill: #017296;"/>
                                        </g>
                                        <path d="M578.39,738.83s22.46-8.11,27.24-17.25c0,0,32.44-7.35,32.55-26.41,0,0,.77,1.48-.63,16.61,0,0-.32,9.83-13.67,17.39,0,0-16.79,10.68-45.48,9.66Z" style="fill: #014c64;"/>
                                    </g>
                                    <polyline points="565.37 690.38 566.36 701.92 612.75 689.2" style="fill: none; stroke: #fff; stroke-linecap: round; stroke-linejoin: round; stroke-width: 2.49px;"/>
                                    </g>
                                    <g>
                                    <path d="M254.93,450.34s-6.67,13.25-21.39,16.1c-11.07,2.14-15.57,10.1-20.31,22.08-7.58,19.17-26.6,9.83-29.51,38.31-1.79,17.46,31.1,41.72,59.51,27.44,28.41-14.28,62.23,24.47,59-58.15-.4-10.29-10.87-9.43-9.9-18.86,1.06-10.34-12.38-27.11-12.38-27.11l-25.02,.19Z" style="fill: #24396b; fill-rule: evenodd;"/>
                                    <path d="M272.6,494.64c-7.08-7.02,.85-12.32,.85-12.32l14.79-3.1c5.7,3.13,13.08,15.86,20.06,26.32,2.52,2.14,5.71,3.16,8.92,2.84l24.17-7.92,.56,4.52-22.84,16.8c-9.71,4.38-20.88-5.03-22.88-6.43,0,0-15.21-12.36-23.63-20.71Z" style="fill: #de593f;"/>
                                    <path d="M347.98,503.62h0c-.22,1.66-1.45,2.88-2.74,2.73l-4.65-1.8c-1.3-.15-.37-.17-.15-1.83h0c.22-1.66-.99-2.01,1.56-2.28l3.65,.52c.47,.07,.94,.2,1.37,.42,.79,.42,1.14,.93,.97,2.23Z" style="fill: #de593f;"/>
                                    <path d="M335.06,501.98s-1.02,5.22,.37,11.07l-11.54,7.68c-4.63,3.08-10.32,4.31-15.73,3.04-7.51-1.76-13.95-7.02-16.96-14.65-.06-.15-.12-.31-.18-.47-5.97-15.64-5.94-38.75-5.94-38.75,0,0,4.42,1.02,7.67,6.4,2.41,3.99,12.51,18.74,17.56,26.08,1.81,2.63,4.81,4.15,8,4.05l16.75-4.47Z" style="fill: #fff;"/>
                                    <path d="M224.63,719.68c13.76-6.09,37.31-7.55,52.6-3.25,2.61,.73,4.8,1.59,6.58,2.53,9.71-2.73,22.87-3.07,31.93-.52,10.74,3.02,11.62,8.93,1.95,13.21-9.29,4.11-24.92,5.21-35.66,2.61-.64,.33-1.31,.66-2.03,.98-13.76,6.09-37.31,7.55-52.6,3.25-15.29-4.29-16.53-12.71-2.77-18.8Z" style="fill: #d4e7f7;"/>
                                    <path d="M252.15,717.77l-.1,8.22c-.06,.86-.85,5.44-1.21,6.23-1.03,2.3-2.74,3.26-4.4,3.43-2.2,.22-6.66-3.59-5.12-8.55,1.34-4.32,4.03-11.23,4.03-11.23,3.12,1.35,4.56,1.97,6.8,1.9Z" style="fill: #24396b;"/>
                                    <path d="M300.4,723.66l-11.31-13.16c-1.74-.89-5-1.18-7.65-.65-1.19,.24-1.81,1.05-1.89,2.26l-.29,2.25c-.37,3.77-.83,5.01,1.48,6.19l13.67,7.01c2.81,2.16,10.74,.87,5.99-3.9Z" style="fill: #24396b;"/>
                                    <path d="M288.64,711.87s6.46,7.85,5.63,8.43c-3.45,2.43-11.59-4.96-11.59-4.96,0,0,4.47-3.84,5.96-3.47Z" style="fill: #de593f;"/>
                                    <path d="M282.68,715.34c3.13-.07,5.92,1.53,6.26-3.11-.27-25.9,5.27-47.95,5.03-72.16-.27-27.18-2.24-27.59-2.71-69.25l-24.85,4.79c4.83,29.82,7.06,67.61,7.06,67.61-6.36,29.25,4.15,36.57,9.21,72.12Z" style="fill: #de593f;"/>
                                    <path d="M245.48,718.21c1.92,4.53,5.66,5.72,6.41,1.12,2.06-25.87,10.23-47.28,12.17-71.46,2.18-27.15,.26-27.74,3.54-69.35l-25.12,2.47c2.11,30.21,.93,68.12,.93,68.12-8.95,28.6,.25,33.16,2.08,69.11Z" style="fill: #de593f;"/>
                                    <path d="M289.62,536.22s17.16-4.08,12.76,91.33c0,0-17.9,7.54-34.5,11.98-15.64,4.19-25.39-14.2-38.07-9.72,0,0,8.14-18.3,7.27-26.83-.88-8.53-5.1-58.4,8.88-60.13,13.97-1.72,43.67-6.64,43.67-6.64Z" style="fill: #4b6eb5;"/>
                                    <path d="M229.8,629.83s1.44-19.9,.56-28.44c-.88-8.53,2.52-64.23,16.5-65.95,3.19-.39,6.29,6.48,10.57,5.85-1.14,8.31-3.35,21.94-7.63,44.23-5.7,29.72,3.64,46.03,12.97,54.63-12.78-.31-22.8,.16-32.97-10.33Z" style="fill: #4264af;"/>
                                    <path d="M280.46,468.92c-1.25-.27-2.53-.35-3.82-.24-5.92,.52-14.16-1.51-14.77-1.06l-11.03,5.9c-21.17,8.18-9.01,15.3-15.51,25.75,0,0,13.15,19.37,13.79,27.8,.55,7.28-5.36,19.02-6.48,21.45-1.45,3.14,9.08,21.42,36.66,16.23,21.72-4.09,18.81-13.05,17.79-25.09-.64-7.58-6.16-27.52-6.33-33.55-.17-6.03,4.16-10.86,.54-20.31-3.62-9.45-6.23-15.88-6.23-15.88l-4.62-1Z" style="fill: #4b6eb5;"/>
                                    <path d="M266.66,473.39l.68-.7c1.73,.43,3.27,.17,3.63-1.58l2-9.87c.36-1.75-.77-3.53-2.5-3.96l-.51-.13c-1.73-.43-4.45,.03-4.81,1.78l-2.56,10.42c-.36,1.75,2.34,3.61,4.07,4.04Z" style="fill: #de593f;"/>
                                    <path d="M271.85,466.52s-4.22-.26-6.79-4.6c0,0,2.49,6.41,6.31,7.27l.48-2.67Z" style="fill: #bc4242;"/>
                                    <path d="M263.72,446.07c1.63-2.67,4-3.17,6.15-1.69,2.18-.96,4.73,.36,6.55,3.78,2.53,4.77,3.01,12.39,.64,16.29-1.03,1.7-2.62,2.09-4.11,2.14-1.39,.05-2.79-.21-4.12-.7-4.75-1.77-4.85-1.05-6.54-4.23-2.53-4.77-.95-11.71,1.42-15.6Z" style="fill: #de593f;"/>
                                    <path d="M266.73,447.74c-1.94,4.67-2.66,15.44-2.98,16.87,0,0-11.46,.27-9.67-10.79,2.23-13.76,11.45-7.39,11.45-7.39l1.19,1.31Z" style="fill: #24396b;"/>
                                    <path d="M263.35,449.56c5.37-2.08,9.8-3.72,17.64,3.44,.67-1.16-.74-5.15-2.39-6.46-3.44-2.75-5.18-4.24-9-5.19l-.93-.13c-5.63-.77-8.73,1.36-10.19,6.87-.13,.48-1.2,2.68-1.25,3.09l1.84-.57c-.41,3.27,1.06-1.58,4.29-1.05Z" style="fill: #24396b;"/>
                                    <path d="M273.9,463.38h0c1.09-.3,2.12-1.91,2.3-3.61l-3.95,1.07c-.18,1.7,.56,2.83,1.65,2.54Z" style="fill: #fff;"/>
                                    <path d="M260.57,459.11c-.16,1.54,.93,2.9,2.45,3.03,1.52,.13,2.88-1.01,3.04-2.56,.16-1.54-.93-2.9-2.45-3.03-1.52-.13-2.88,1.01-3.04,2.56Z" style="fill: #de593f;"/>
                                    <path d="M242.47,548.77c1.12-2.42,7.03-14.16,6.48-21.45-.36-4.77-2.91-13.27-5.05-19.75,7.34,13.1,7.67,17.87,15.96,18.94-12.42,21.25-2.59,29.29-2.97,36.91-20.94,.24-15.7-11.87-14.42-14.65Z" style="fill: #ced7a6;"/>
                                    <path d="M271.71,467.28l2.9,1.28s1.37,4.61-.97,6.64l-4.23-2.63s1.37-1.49,1.96-3.38l.34-1.91Z" style="fill: #fff;"/>
                                    <path d="M269.41,472.57l-2.61,4.32s-7.8-3.47-7.92-8.41l4.3-1.57s2.83,6.14,6.23,5.66Z" style="fill: #fff;"/>
                                    <path d="M251.89,719.33s-1.4,8.89-5.06,8.25c-3.65-.63-1.35-9.37-1.35-9.37l6.41,1.12Z" style="fill: #de593f;"/>
                                    <path d="M253.89,469.64c.94-.52,2.12-.04,2.42,.98,1.31,4.43,4.23,14.81,4.17,19.26-.08,5.73,3.02,51.39,3.02,51.39,0,0-3.7,72.15-1.63,82.86,0,0-23.33,3.98-34.56-3.87,0,0,.57-28.79,.68-34.52,.11-5.73,6.27-44.12,7.7-50.22s-3.07-47.92-3.07-47.92c0,0-1.41-7.52,12.3-13.61,4.61-2.05,7.38-3.47,8.96-4.34Z" style="fill: #fff;"/>
                                    <path d="M278.7,468.12c-.48-.14-.89,.36-.65,.8,1.38,2.59,4.56,9.11,5.51,16.01,1.23,8.9,2.03,31.95,2.03,31.95,0,0,5.59,31.45,6.25,41.35,.65,9.9-.02,59.77-.02,59.77,5.54-.13,13.81-2.82,16.76-7.73,0,0-3.82-32.44-5.32-39.47-1.5-7.03-4.51-33.01-4.51-33.01,0,0-3.8-23.24-3.39-29.25,.42-6.01-1.85-25-1.85-25l-8.27-13.58-6.53-1.84Z" style="fill: #fff;"/>
                                    <path d="M259.19,552.46l24.93-.76c2.46-.08,4.74-2.11,5.06-4.52l6.08-44.74c.33-2.41-1.42-4.32-3.87-4.24l-24.93,.76c-2.46,.08-4.74,2.11-5.06,4.52l-6.08,44.74c-.33,2.41,1.42,4.32,3.87,4.24Z" style="fill: #26326d;"/>
                                    <path d="M291.66,536.53h0c.08,1.5-1.03,2.74-2.47,2.75l-4.98,.02c-1.43,0-2.66-1.22-2.74-2.72h0c-.08-1.5,1.03-2.74,2.47-2.75l4.98-.02c1.43,0,2.66,1.22,2.74,2.72Z" style="fill: #de593f;"/>
                                    <path d="M235.45,492.68s-6.4,34.06,3.46,48.2,45.98-1.56,45.98-1.56l-1.06-4.97-30.83-2.46-2.3-38.94-15.25-.26Z" style="fill: #de593f;"/>
                                    <path d="M277.55,533.43l.09,11.78s-16.9,6.41-28.95,4.42c-12.05-1.99-17.51-13.31-17.6-25.68-.09-12.37,1.5-37.24,1.5-37.24l14.99-7.01,6.46,12.42,1.25,33.82s1.04,6.08,22.25,7.49Z" style="fill: #fff;"/>
                                    <path d="M344.81,504.75h0c.66,.24,1.41-.1,1.65-.76l18.03-48.86c.24-.66-.1-1.41-.76-1.65h0c-.66-.24-1.41,.1-1.65,.76l-18.03,48.86c-.24,.66,.1,1.41,.76,1.65Z" style="fill: #26326d;"/>
                                    <path d="M251.9,505.31s-1.12,16.44,1.49,20.49" style="fill: none; stroke: #b4c5d5; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.25px;"/>
                                    <line x1="296.94" y1="514.77" x2="296.3" y2="510.25" style="fill: none; stroke: #b4c5d5; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.25px;"/>
                                    </g>
                                    <g>
                                    <path d="M675.18,659.34l82.08-68.27c11.36-9.75,4.14-27.64-12.88-31.89l-246.19-61.51,176.99,161.67Z" style="fill: #d4e7f7;"/>
                                    <path d="M649.2,665.75l-246.17-67.58c-8.04-2.36-13.29-9.59-13.26-18.28l1.53-396.21c.06-14.73,14.7-26.62,28.56-23.18l246.19,61.24c8.45,2.1,14.06,9.5,14.03,18.49l-1.57,407.16c-.06,15.08-15.33,22.45-29.3,18.36Z" style="fill: #c1cde9;"/>
                                    <path d="M643.03,669.52l-246.17-67.58c-8.04-2.36-13.29-9.59-13.26-18.28l1.53-396.21c.06-14.73,14.7-26.62,28.56-23.18l246.19,61.24c8.45,2.1,14.06,9.5,14.03,18.49l-1.57,407.16c-.06,15.08-15.33,22.45-29.3,18.36Z" style="fill: #017296;"/>
                                    <polygon points="654.5 644.21 401.49 576.03 402.98 191.74 656.01 252.62 654.5 644.21" style="fill: #dfedf9;"/>
                                    <path d="M582.14,196.57l-14.21-4.53,.03-6.76c.09-18.74-14.95-38.9-33.41-44.79h0c-18.46-5.89-33.64,4.62-33.73,23.36l-.03,6.76-14.21-4.53c-13-4.15-23.68,3.25-23.75,16.45h0c-.06,13.2,10.52,27.39,23.52,31.54l95.54,30.5c13,4.15,23.68-3.25,23.75-16.45h0c.06-13.2-10.52-27.39-23.52-31.54Zm-46.48-21.48l-2.51-.8c-4.56-1.46-8.28-6.44-8.26-11.07,.02-4.63,3.77-7.23,8.34-5.78l2.51,.8c4.56,1.46,8.28,6.44,8.26,11.07-.02,4.63-3.77,7.23-8.34,5.78Z" style="fill: #7889c4;"/>
                                    <path d="M574.48,200.63l-14.21-3.87,.03-6.76c.09-18.74-14.95-38.19-33.41-43.22h0c-18.47-5.03-33.65,6.2-33.73,24.94l-.03,6.76-14.21-3.87c-13-3.54-23.69,4.36-23.75,17.56h0c-.06,13.2,10.53,26.89,23.53,30.43l95.57,26.01c13,3.54,23.69-4.36,23.75-17.56h0c.06-13.2-10.53-26.89-23.53-30.43Zm-46.49-19.3l-2.51-.68c-4.56-1.24-8.28-6.05-8.26-10.68s3.77-7.41,8.34-6.17l2.51,.68c4.56,1.24,8.28,6.05,8.26,10.68-.02,4.63-3.77,7.41-8.34,6.17Z" style="fill: #bdd0eb;"/>
                                    </g>
                                    <path d="M714.02,181.37c.14,4.29-3.22,7.89-7.51,8.03-4.29,.14-7.89-3.22-8.03-7.51-.14-4.29,3.22-7.89,7.51-8.03,4.29-.14,7.89,3.22,8.03,7.51Z" style="fill: none; fill-rule: evenodd; stroke: #243c7c; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.43px;"/>
                                    <path d="M145.65,324.82c.14,4.29-3.22,7.89-7.51,8.03-4.29,.14-7.89-3.22-8.03-7.51-.14-4.29,3.22-7.89,7.51-8.03,4.29-.14,7.89,3.22,8.03,7.51Z" style="fill: none; fill-rule: evenodd; stroke: #243c7c; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.43px;"/>
                                    <path d="M804.28,587.68c.14,4.29-3.22,7.89-7.51,8.03-4.29,.14-7.89-3.22-8.03-7.51-.14-4.29,3.22-7.89,7.51-8.03,4.29-.14,7.89,3.22,8.03,7.51Z" style="fill: none; fill-rule: evenodd; stroke: #243c7c; stroke-linecap: round; stroke-linejoin: round; stroke-width: 1.43px;"/>
                                    <path class="animate-medical-card" d="M626.45,522.81h0c-49.64-32.5-86.34-71.41-85.8-122.74l1.26-120.44,89.61-16.88,88.77,63.51-1.26,120.44c.83,17.23-34.58,61.15-92.58,76.11Z" style="fill: #017296;"/>
                                    <path class="animate-medical-card" d="M557.63,302.87l71.67-13.5,70.99,50.79-1.01,96.33c-3.62,20.14-27.86,48.72-71.57,66.21-33.47-31.3-71.52-62.45-71.09-103.5l1.01-96.33Z" style="fill: #fff;"/>
                                    <g class="animate-medical-card">
                                    <polygon points="638.19 430.98 609.08 423.53 609.55 341.85 638.66 349.31 638.19 430.98" style="fill: #017296;"/>
                                    <polygon points="584.81 391.42 584.98 360.92 662.94 380.9 662.77 411.39 584.81 391.42" style="fill: #017296;"/>
                                    </g>
                                    <g class="animate-medical-card-two">
                                    <path  d="M373.97,536.21l3.31-157.75c.2-9.45,9.69-14.89,21.09-12.1l117.94,28.94c11.4,2.8,20.56,12.82,20.37,22.27l-3.31,157.75c-.2,9.45-9.69,14.89-21.09,12.1l-117.94-28.94c-11.4-2.8-20.56-12.82-20.36-22.27Z" style="fill: #fff;"/>
                                    <path d="M450.55,545.92h0c-25.66-16.9-44.56-37.29-44.02-64.54l1.26-63.96,46.7-9.61,45.86,33.07-1.26,63.96c.34,9.14-18.3,32.72-48.54,41.09Z" style="fill: #32ccfe;"/>
                                    <g>
                                        <polygon points="457.12 497.07 442.01 493.32 442.67 449.96 457.78 453.7 457.12 497.07" style="fill: #fff;"/>
                                        <polygon points="429.55 476.45 429.79 460.26 470.25 470.3 470 486.49 429.55 476.45" style="fill: #fff;"/>
                                    </g>
                                    </g>
                                </g>
                            </svg>
                        </div>
                    </div>
                    
                </image-carousel-slide>
            </image-carousel>
            <div class="logo_arrow_right" @click="Imagenext"></div>
        </div>
    </div>

    <div class="headline_recruiting">
      <!-- <img src="../assets/FinalImages/AdobeStock_Pink_Door.jpeg" alt=""> -->
      <img src="../assets/FinalImages/pinnjcourt.png" alt="">
      <div class="sign_up"><a href="/CreateAccount" target="_blank">Start using LRex</a></div>
    </div>

</template>

<script>
import image1 from "../assets/FinalImages/Associations/camden-county-logo-White-1.png"
import image2 from "../assets/FinalImages/Associations/NJAJ.jpg"
import image3 from "../assets/FinalImages/Associations/Chamber_of_commerce.jpg"
import image4 from "../assets/FinalImages/Associations/GSPO.png"
import image6 from "../assets/FinalImages/Associations/logo-IAPS.jpg"
import ImageCarousel from './ImageCarousel/ImageCarousel.vue'
import ImageCarouselSlide from './ImageCarousel/ImageCarouselSlide.vue'
import axios from 'axios'

export default{
    data: function () {
      return {
          images: [
            image1,
            image2,
            image3,
            image4,
            image6
          ],
          svgArray: [
            "svg1",
            "svg2",
            "svg3",
            "svg4",
            "svg5"
          ],
          visibleSlideImg: 1,
          direction: '',
          sliderValue: 1,
          toggleSupportTeam: false,
          PricingInput: {
            companyName: "",
            name: "",
            email: "",
            phone: "",
            message: ""
          },
          toggleAlertBox: false,
          alertMessage: "",
          submittingInfo: false,
          inquirySent: false,
          headerMessage: ""
        }
    },
    components:{
      ImageCarousel,
      ImageCarouselSlide
    },
    methods:{
    SendPricingEmail(){
        if((this.PricingInput.companyName.length != 0) && (this.PricingInput.name.length != 0) && (this.PricingInput.email.length != 0) && (this.PricingInput.phone.length != 0) && (this.PricingInput.message.length != 0)){
        this.submittingInfo = true;
        this.headerMessage = "Submitting Information";
        axios.post('https://1ho101uzx4.execute-api.us-east-1.amazonaws.com/prod/sendpricinginquiry', this.PricingInput,{})
            .then((response)=>{
                //console.log(response)
                if(response.status == 200){
                    this.inquirySent = true;
                }else{
                    this.toggleAlertBox = true;
                    this.alertMessage = "Error submitting information.";

                    setTimeout(()=>{this.toggleAlertBox = false;}, 3000)
                }
            })
            .catch(error => {
                alert(error); 
                this.toggleAlertBox = true;
                this.alertMessage = "Error submitting information.";

                setTimeout(()=>{this.toggleAlertBox = false;}, 3000)
            }).finally(()=>{this.submittingInfo = false})
        }else{
            this.toggleAlertBox = true;
            this.alertMessage = "Please fill in all input fields.";

            setTimeout(()=>{this.toggleAlertBox = false;}, 3000)
        }
    },
    Imagenext(){
      if(this.visibleSlideImg >= this.imagesLength - 2){
        this.visibleSlideImg = 1;
      }else{
        this.visibleSlideImg++;
      }
      this.direction = "left";
    },
    Imageprev(){
        if(this.visibleSlideImg <= 1){
            this.visibleSlideImg = this.imagesLength - 2;
        }else{
            this.visibleSlideImg--;
        }
        this.direction = "right";
      },
    CardOneAnimation(){
        if(document.querySelector('.card-one').classList.contains('animate-card-one')){
            document.querySelector('.card-one').classList.remove('animate-card-one');
        }else{
            document.querySelector('.card-one').classList.add('animate-card-one');
        }
    },
    CardTwoAnimation(){
        if(document.querySelector('.card-two').classList.contains('animate-card-two')){
            document.querySelector('.card-two').classList.remove('animate-card-two');
        }else{
            document.querySelector('.card-two').classList.add('animate-card-two');
        }
    },
    CardThreeAnimation(){
        if(document.querySelector('.card-three').classList.contains('animate-card-three')){
            document.querySelector('.card-three').classList.remove('animate-card-three');
        }else{
            document.querySelector('.card-three').classList.add('animate-card-three');
        }
    },
    CardFourAnimation(){
        if(document.querySelector('.card-four').classList.contains('animate-card-four')){
            document.querySelector('.card-four').classList.remove('animate-card-four');

        }else{
            document.querySelector('.card-four').classList.add('animate-card-four');
        }

        this.toggleSupportTeam = !this.toggleSupportTeam;
    },
    CardFiveAnimation(){
        if(document.querySelector('.card-five').classList.contains('animate-card-five')){
            document.querySelector('.card-five').classList.remove('animate-card-five');
        }else{
            document.querySelector('.card-five').classList.add('animate-card-five');
        }
    }
    },
    computed:{
        imagesLength(){
            return this.images.length;
        }
    },
    mounted(){
        //Card Animation Observer

        const cardOne = document.querySelector('.card-one')
        const cardTwo = document.querySelector('.card-two')
        const cardThree = document.querySelector('.card-three')
        const cardFour = document.querySelector('.card-four')
        const cardFive = document.querySelector('.card-five')

        const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if(entry.isIntersecting){
            cardOne.classList.add('animate-shipping-card')
            cardTwo.classList.add('animate-shipping-card')
            cardThree.classList.add('animate-shipping-card')
            cardFour.classList.add('animate-shipping-card')
            cardFive.classList.add('animate-shipping-card')
            return;
            }
        })
        });
        observer.observe(document.querySelector('.card-container'))
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "../styles/button-styles.css";

.main-button-blue-white{
    text-decoration: none;
}

/* || Slider Syles */

.imageSliderContainer h1{
  margin-top: 5%;
  margin-bottom: 0;
  font-size: 4vw;
  font-family: 'Work Sans', sans-serif;
  color: black;
}

.imageSlider{
  margin-top: 2.5%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.progress-outer-container{
    display: flex;
	justify-content: center;
    width: 100%;
}

.progress-container {
	display: flex;
	justify-content: space-between;
	position: relative;
	width: 90%;
	margin-top: 70%
}

.progress-container::before {
	content: "";
	background-color: #33f18a;
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%);
	height: 6px;
	width: 100%;
	z-index: -1;
	transition: .9s ease
}

.progress {
	background-color: #33f18a;
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%);
	height: 6px;
	width: 0%;
	z-index: -1;
	transition: .9s ease
}

.circle {
	background-color: #fff;
	color: #999;
	border-radius: 50%;
	height: 3vw;
	width: 3vw;
	border: 4px solid #b2bec3;
	display: flex;
	align-items: center;
	justify-content: center;
	transition: .9s ease;
	cursor: pointer
}

.circle.active {
	border-color: #33f18a;
	background-color: #33f18a;
	transition-delay: .3s;
	color: #000
}

.circle.active:hover {
	border-color: #30db7d;
	background-color: #30db7d
}

/* SVG Slider Animation */

.svg-container{
    display: flex;
    flex-direction: row;
    justify-content: space-evenly;
}

.svg1{
    height: 20vw;
    width: 20vw;
}

.svg2{
    height: 20vw;
    width: 20vw;
}

.svg3{
    height: 20vw;
    width: 20vw;
}

.svg-main-medical, .svg-main-lawyer, .svg-main-insurance, .svg-main-realestate, .svg-main-commerce{
  height: 18vw;
  margin-top: .5vw;
  margin-bottom: .5vw;
}

@media only screen and (max-width: 400px){
  .svg-main-medical, .svg-main-lawyer, .svg-main-insurance, .svg-main-realestate, .svg-main-commerce{
    height: 19vw;
    margin-top: .5vw;
    margin-bottom: .5vw;
    }
}

/* Commerce Animation */

.commerce-dollar{
    animation: move-dollar 4s infinite;
    animation-delay: .5s;
}

@keyframes move-dollar{
    0%{
        transform:rotate(0deg);
        margin-left: 0;
    }
    50%{
        transform:rotate(5deg);
        margin-left: 5px;
    }
    100%{
        transfor:rotate(0deg);
        margin-left: 0;
    }
}

/* RealEstate Animation */

.lady-arm{
    animation: move-lady-arm 1s infinite;
}

@keyframes move-lady-arm{
    0%{
        transform:rotate(0deg);
        margin-left: 0;
    }
    50%{
        transform:rotate(-.5deg);
        margin-left: 1px;
    }
    100%{
        transfor:rotate(0deg);
        margin-left: 0;
    }
}

/* Insurance Animation */

.umbrella-element{
    animation: move-umbrella 4s infinite;
}

@keyframes move-umbrella{
    0%{
        transform:rotate(0deg);
        margin-left: 0;
    }
    50%{
        transform:rotate(-2deg);
        margin-left: 5px;
    }
    100%{
        transfor:rotate(0deg);
        margin-left: 0;
    }
}

/* Lawyer Animation */

.rotate-lawyer{
  animation: rotation 10s infinite;
  transform-origin: center center;
}

.rotate-scale{
  animation: move-scale 10s infinite;
}

.rotate-scale-two{
  animation: move-scale-two 10s infinite;
}

@keyframes move-scale-two{
  0%{transform: translateY(0%);}
  25%{transform: translateY(2.5%);}
  50%{transform: translateY(0%);}
  75%{transform: translateY(-4.5%);}
  100%{transform: translateY(0%);}
}

@keyframes move-scale{
  0%{transform: translateY(0%);}
  25%{transform: translateY(-4%);}
  50%{transform: translateY(0%);}
  75%{transform: translateY(4%);}
  100%{transform: translateY(0%);}
}

@keyframes rotation {
  0%{transform:skew(0deg);}
  25%{transform: skewY(10deg);}
  50%{transform: skew(0deg);}
  75%{transform: skewY(-10deg);}
  100%{transform: skew(0deg);}
}

/* Medical Animation */

.animate-medical-card{
  animation: animate-medical-card 3s infinite;
  animation-delay: .25s;
}

.animate-medical-card-two{
  animation: animate-medical-card-two 3s infinite;
}

@keyframes animate-medical-card-two {
  0%{
    transform: translate(0px, 0px);
  }
  50%{
    transform: translate(-10px, 10px);
  }
  100%{
    transform: translate(0px, 0px);
  }
}

@keyframes animate-medical-card {
  0%{
    transform: translate(0px, 0px);
  }
  50%{
    transform: translate(-10px, 10px);
  }
  100%{
    transform: translate(0px, 0px);
  }
}

/***********************/

.logo_arrow_right{
  width: 20px;
  height: 20px;
  border-right: 10px solid #33f18a;
  border-top: 10px solid #33f18a;
  border-radius: 5px;
  -webkit-transform: rotate(-135deg);
  transform: rotate(45deg);
  cursor: pointer;
}

.logo_arrow_left{
  width: 20px;
  height: 20px;
  border-right: 10px solid #33f18a;
  border-top: 10px solid #33f18a;
  border-radius: 5px;
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
  cursor: pointer;
}

/* Shipping Options */

@keyframes animate-shipping-cards{
  0%{margin-top: 15px;}
  50%{margin-top: 5px;}
  100%{margin-top: 15px;}
}

.animate-shipping-card{
  animation: animate-shipping-cards 1s ease;
}

.text-container{
  width: 100%;
  margin-top: 2.5%;
  font-size: 1.4vw;
  display: flex;
  justify-content: center;
  align-items: center;

  position: absolute;
}

.text-container-back, .text-container-front{
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;

    position: absolute;
    width: 100%;
    height: 100%;
}

.text-container-front{
    z-index: 2;
    transform: rotateY(0deg);
    -webkit-transform: rotateY(0deg);
}

/* rotateY(-180deg) allows card animation to work on safari*/

.text-container-back{
    transform: rotateY(-180deg);
    -webkit-transform: rotateY(-180deg);
    visibility: visible;
    z-index: 1;
    opacity: .99;
}

.text-container-image{
  display: flex;
  flex-direction: row;
  align-items: center;
}

.text-container-image-tech{
  display: flex;
  flex-direction: column;
  align-items: center;
  position: absolute;
  z-index: 6;
  width: 100%;
}

.text-container-tech-header{
    width: 85%;
    margin-bottom: 0;
    margin-top: 0;
}

.text-container-tech-header p{
    margin-bottom: 0;
    margin-top: 0;
}


.tech-image-text{
    display: flex;
    align-items: center;
    flex-direction: row;
    width: 100%;
    margin-top: 0.5em;
    margin-bottom: 0.5em;
}

.text-container-shipping-options{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 1em;
}

.text-container-shipping-options p{
    margin: 0;
}

.text-container-shipping-options img{
  height: 3vw;
  width: auto;
  margin-right: 15px;
}

.text-container-svg svg{
  width: auto;
  height: 1.5em;
}

/**********  SVG Styles ***********/

.snowflake-alt{
    fill: #000;
    stroke: transparent;
}

.puzzle{
    stroke-width: 15px;
    stroke-miterlimit: 10;
}

.st0{
    fill: none;
    stroke: #000000;
    stroke-width: 8;
    stroke-miterlimit: 10;
}

.cls-1-alt{
    fill: none;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 8px;
}

.cls-1 {
    fill: none;
    stroke: #000;
    stroke-miterlimit: 10;
    stroke-width: 8px;
}

.cls-2-alt{
    stroke: #33f18a;
    fill: none;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 11px;
}

.cls-2 {
    fill: none;
    stroke: #000;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 12px;
}

.technology-svg{
    height: 2.1em !important;
    width: auto;
}

.technology-svg-signature{
    height: 1.8em !important;
    width: auto;
}

.svg-wrapper {
  width: 100%;
  height: 8em;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: visible;  
}

.svg-wrapper svg {
  width: 100%;
  height: 100%;
  overflow: visible;
}

.st0-tech{
	fill:url(#SVGID_1_);
	animation: animate-bubble 4s infinite;
}

.st1-tech{
	fill:url(#SVGID_00000155841459330274204580000013039651787148724128_);
	animation: animate-bubble 4s infinite;
	animation-delay: .25s;
}

.st2-tech{
	fill:url(#SVGID_00000054229247425402527590000016703565254739954095_);
	animation: animate-bubble 4s infinite;
	animation-delay: .5s;
}

.st3-tech{
	fill:url(#SVGID_00000103230218770803328030000000520330459659151278_);
	animation: animate-bubble-two 4s infinite;
	animation-delay: .75s;
}

.st4-tech{
	fill:url(#SVGID_00000047760665946480754720000011518955034995631547_);
	animation: animate-bubble-four 4s infinite;
	animation-delay: 1s;
}

.st5-tech{
	fill:url(#SVGID_00000008868900880858101920000008275841903144435897_);
	animation: animate-bubble 4s infinite;
	animation-delay: 1.25s;
}

@keyframes animate-bubble{
  0%{transform: translateY(0px);}
  50%{transform: translateY(-5px);}
  100%{transform: translateY(0px);}
}

@keyframes animate-bubble-two{
  0%{transform: translateY(0px);}
  50%{transform: translateY(5px);}
  100%{transform: translateY(0px);}
}

@keyframes animate-bubble-three{
  0%{transform: translateX(0px);}
  50%{transform: translateX(5px);}
  100%{transform: translateX(0px);}
}

@keyframes animate-bubble-four{
  0%   {opacity: 1;}
  50% {opacity: .6;}
  100% {opacity: 1;}
}

.svg-main{
  height: auto;
  width: 100%;
  position: absolute;
}

.svg-container{
	width: 100%;
	position: relative;
	z-index: 5;
}

/**************************/

.text-container-svg{
  width: 30%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.text-container-text{
  width: 80%;
  margin-left: 15px;
}

.text-container-text p{
  margin-top: 0;
  margin-bottom: 0;
}

.text-container-image img{
  height: 3vw;
  width: auto;
  margin-right: 15px;
}

.text-container-image-tech img{
  height: 3vw;
  width: auto;
  margin-right: 15px;
}

.text-container-zipship{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-top: 0;
  margin-bottom: 0;
}

.text-container-zipship p{
  margin-top: 10%;
  margin-bottom: 0;
}

.text-container-zipship img{
  height: 1.5em;
  width: auto;
  margin-right: 15px;
  margin-top: 15px;
}

.text-container-inner{
  width: fit-content;
  text-align: left;
  margin-bottom: 5%;
  width: 75%;
}

.text-container-inner-tech{
  width: fit-content;
  text-align: left;
  margin-bottom: 5%;
  width: 95%;
}


.support-team-list-container li{
  animation-name: animate-support-team;
  animation-duration: 350ms;
  animation-delay: calc(var(--animation-order) * .35s);
  animation-fill-mode: both;
  animation-timing-function: ease-in-out;
}

@keyframes animate-support-team {
    0% {
        opacity: 0;
        transform: scale(0.6) translateY(-8px);
    }
    
    100% {
        opacity: 1;
    }
}



.shipping-options-more-info{
    margin-top: 5px;
    margin-bottom: 5px;
    font-size: 1em;
}

.text-container-inner ul{
  list-style: none; /* Remove default bullets */
  margin-top: 7% !important;
}

.text-container-inner li{
    margin-top: 3%;
}

.text-container-inner ul li::before{
  content: "\2022";
  color: #33f18a;
  font-weight: bold;
  display: inline-block; /* Allows space between bullet and text */
  width: 1em; /* Adds space */
  margin-left: -1em; /* Adds space */
}

.button-container-card{
  width: 100%;
  margin-top: auto;
  margin-bottom: 5%;

  position: absolute;
  z-index: 10;
  bottom: 0;
}

.main-button-blue-white{
  padding: 10px;
  font-size: 1.2vw;
}

.header-container{
  margin-top: 5%;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.header-container h1{
    font-size: 4vw;
}

/* Slider Pricing Styles */
.slidecontainer {
  width: 100%;
}

.slider {
  -webkit-appearance: none;
  width: 100%;
  height: 15px;
  border-radius: 5px;
  background: #d3d3d3;
  outline: none;
  opacity: 0.7;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

.slider:hover {
  opacity: 1;
}

.slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #fe804d;
  cursor: pointer;
}

.slider::-moz-range-thumb {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #fe804d;
  cursor: pointer;
}

.pricing-container{
  margin-top: 10px;
  overflow: hidden;
}

.pricing-inner{
  margin: 0;
  animation: animate-price 1s ease;
}

@keyframes animate-price{
  from{margin-left: -15%; opacity: 0;}
  to{margin-left: 0%; opacity: 1;}
}

.pricing-inner h2, .pricing-inner p{
  margin: 0;
}

.price-text{
  font-size: 1.5em;
  color: #33f18a;
}

.shipment-value{
    background-color: #33f18a;
    color: #fff;
    border-radius: 5px;
    padding: 5px;
}

.pricing-contact-form{
    margin-top: 0;
}

.pricing-contact-form textarea{
    padding: .5em;
    font-size: .5em;
    border: 1px solid rgba(0, 0, 0, 0.336);
    border-radius: 5px;
    outline: none;
    width: 100%;
    margin-top: .5em;
}

.pricing-contact-form input{
    padding: .5em;
    font-size: .5em;
    border: 1px solid rgba(0, 0, 0, 0.336);
    border-radius: 5px;
    outline: none;
    width: 100%;
}

.pricing-contact-form button{
    width: 50%;
    padding: .5em;
}


.dot-container{
    padding: 0;
    margin-top: 10px;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
}

.dot1{
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #fff;
    margin: 2px;
    animation: dot-bounce .75s infinite;
}

.dot2{
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #fff;
    margin: 2px;
    animation: dot-bounce .75s infinite;
    animation-delay: .25s;
}

.dot3{
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background-color: #fff;
    margin: 2px;
    animation: dot-bounce .75s infinite;
    animation-delay: .5s;
}

@keyframes dot-bounce {
    0%{transform: translateY(0px);}
    50%{transform: translateY(5px);}
    100%{transform: translateY(0px);}
}

.alert-box-container{
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.alert-box{
    background-color: #32ccfe;
    color: #fff;
    box-shadow: rgba(0, 0, 0, 0.85) 0px 15px 25px;
    position: absolute;
    top: 0;
    z-index: 5;
    padding: 2.5%;
    border-radius: 25px;
    width: fit-content;


    animation: animate-alert-box 1s ease;
}

@keyframes animate-alert-box{
    0%{
        opacity: .5;
        margin-left: -50px;
    }
    100%{
        opacity: 1;
        margin-left: 0px;
    }
}

.alert-box p{
    margin-top: 0;
    margin-bottom: 0;
}

/* Check Mark Animation */
    .check {
        height: 25px;
        width: 12.5px;
        border-width: 7px;
        transform: rotate(45deg);
        border-bottom: 7px solid #fff;
        border-right: 7px solid #fff;
        margin-bottom: 7px;
    }

    @keyframes animate-check-container {
        0%{
            transform: rotate(0deg) scale(10%);
            background-color: #fff;
        }
        100%{
            transform: rotate(360deg) scale(100%);
        }
    }

    @keyframes animate-inquiry-sent{
        from{
            margin-left: -20px;
            opacity: 50%;
        }
        to{
            margin-left: 0;
            opacity: 100%;
        }
    }

    .inquiry-sent{
        animation: animate-inquiry-sent .5s ease;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #f8f8f8;
        border-radius: 15px;
        padding: 10px;
        margin-top: 10px;
    }

    .inquiry-sent h2{
        margin-top: 0;
    }

    .check-container{
        width: 50px;
        height: 50px;
        border: 5px solid #33f18a;
        background-color: #33f18a;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        animation: animate-check-container 1s ease;
    }


/* Card Styles */

.card-container{
  margin-bottom: 5%;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
}

.card-container-inner{
  width: 90%;
  height: 100%;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  perspective: 3000px;
}

.card-one{
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px;
  padding: 5px;
  border-radius: 25px;
  height: 100%;
  width: 30%;
  min-width: 300px;
  min-height: 35vw;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 15px;
  animation-delay: .5s;

  position: relative;
  transition: transform .5s;
  transform-style: preserve-3d;

  -webkit-transition: transform .5s;  
  -webkit-transform-style: preserve-3d;
}

.animate-card-one, .animate-card-two, .animate-card-three, .animate-card-four, .animate-card-five{
    transform: rotateY(180deg);
    -webkit-transform: rotateY(180deg);
}

.card-two{
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px;
  padding: 5px;
  border-radius: 25px;
  height: 100%;
  width: 30%;
  min-width: 300px;
  min-height: 35vw;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 15px;
  animation-delay: .75s;

  position: relative;
  transition: transform .5s;
  transform-style: preserve-3d;
  -webkit-transition: transform .5s;  
  -webkit-transform-style: preserve-3d;

  background-image: url(../assets/FinalImages/OurSolutions/LREXShapeX.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.header-container-lrex{
  color: #fff;
  width: 100%;
  display: flex;
  justify-content: flex-start;
}

.header-container-lrex-inner, .header-container-lrex-inner-back{
  width: 50%;
}

.header-container-lrex-inner h2{
  font-size: 1.7vw;
  margin-top: 25%;
  margin-right: 5%;
}

.header-container-lrex-inner-back h2{
  font-size: 1.7vw;
  margin-top: 25%;
  margin-right: 1%;
}

.text-container-lrex{
  color: #fff;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  margin-top: 50%;
}

.text-container-lrex-back{
  color: #fff;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  margin-top: 45%;
}

.text-container-lrex-inner{
  width: 45%;
  text-align: left;
  font-size: .85vw;
  margin-left: 3%;
  margin-top: 10%;
}

.text-container-lrex-inner p{
    color: #fff;
    font-weight: bold;
}

.text-container-lrex-inner-back{
  width: 40%;
  margin-top: 20%;
  text-align: left;
  font-size: .85vw;
  margin-left: 2%;
}

.text-container-lrex-inner-two{
  width: 40%;
  text-align: left;
  font-size: .85vw;
  margin-left: 5%;
}

.card-three{
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px;
  padding: 5px;
  border-radius: 25px;
  height: 100%;
  width: 30%;
  min-width: 300px;
  min-height: 35vw;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 15px;
  animation-delay: 1s;

  position: relative;
  transition: transform .5s;
  transform-style: preserve-3d;
  -webkit-transition: transform .5s;  
  -webkit-transform-style: preserve-3d;
}

.card-four{
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px;
  padding: 5px;
  border-radius: 25px;
  height: 100%;
  width: 30%;
  min-width: 300px;
  min-height: 35vw;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 15px;
  animation-delay: 1s;

  position: relative;
  transition: transform .5s;
  transform-style: preserve-3d;
  -webkit-transition: transform .5s;  
  -webkit-transform-style: preserve-3d;
}

.card-five{
  background-color: #fff;
  box-shadow: rgba(0, 0, 0, 0.2) 0px 5px 15px;
  padding: 5px;
  border-radius: 25px;
  height: 100%;
  width: 30%;
  min-width: 300px;
  min-height: 35vw;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  margin-top: 15px;
  animation-delay: 1s;

  position: relative;
  transition: transform .5s;
  transform-style: preserve-3d;
  -webkit-transition: transform .5s;  
  -webkit-transform-style: preserve-3d;
}

.shape-one{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  color: white;
  height: 100%;
  width: 90%;
  font-size: 4vw;
  clip-path: polygon(15% 5%, 85% 5%, 100% 50%, 85% 95%, 15% 95%, 0% 50%);
}

.shape-one h2,.shape-two h2,.shape-three h2{
  font-size: 1.8rem;
}

.shape-two{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  color: white;
  height: 100%;
  width: 90%;
  border-radius: 50% / 100%;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.shape-three{
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: black;
  color: white;
  height: 100%;
  width: 90%;
  border-radius: 500px;
}

.shape-container{
  margin-top: 5%;
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
}

/**************************************/
/* || Shipment Tracking Syles */

    .ship_with_us_layout{
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
        position: relative;
        top: 8vw;
        right: 15vw;
    }

    .ship_with_us_layout h1{
        display: flex;
        font-size: 3.2vw;
        margin-bottom: 0;
        text-align: left;
    }

    .ship_with_us_layout p{
        display: flex;
        color: white;
        z-index: 5;
        font-size: 1.8vw;
        margin-top: 20px;
    }

    .ship_with_us_layout button{
        display: flex;
        padding: 1vw;
        background-color: #33f18a;
        border: none;
        border-radius: 999px;
        cursor: pointer;
        transition: all 0.3s ease 0s;
        font-size: 2vw;
        width: 20vw;
        justify-content: center;
    }

    .ship_with_us{
        position: relative;
        display: flex;
        justify-content: center;
        margin-top: 20vh;
        padding-top: 5vh;
    }

    .ship_with_us img{
        position: absolute;
        z-index: 1;
        width: 90vw;
        height: auto;
    }

    .ship_with_us h1{
        position:relative;
        z-index:5;
        color:white;
    }

    .ship_with_us button{
        position:relative;
        z-index:5;
        color: black;
        text-align: center;
    }

/**************************/
/* || Industry Solutions Syles */
    .shipping-options{
        font-family: 'Work Sans', sans-serif;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        margin-top: 10%;
    }

    .shipping-options h1{
        color: black;
        font-size: 4vw;
    }

/* Shipping Options Styles */
    .next-day-container, .shipping-options-inner, .same-day-container, .zip-ship-container, .priority-today-container{
        padding-top: 3vw;
        border-top: black 2px solid;
        width: 80vw;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }

    .next-day-container p, .shipping-options-inner p, .same-day-container p, .zip-ship-container p, .priority-today-container p{
        font-size: 2vw;
        width: 60vw;
        text-align: left;
    }

    .next-day-container div{
        background-color: black;
        color: white;
        padding-top: 5vw;
        padding-bottom: 5vw;
        width: 50vw;
        border-radius: 55%;
        font-size: 4vw;
    }

    .shipping-options-inner div{
        background-color: black;
        color: white;
        padding-top: 5vw;
        padding-bottom: 5vw;
        width: 50vw;
        border-radius: 50% / 100%;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
        font-size: 4vw;
    }

    .same-day-container div, .zip-ship-container div{
        background-color: black;
        color: white;
        padding-top: 5vw;
        padding-bottom: 5vw;
        width: 50vw;
        border-radius: 999px;
        font-size: 4vw;
    }

    .priority-today-container div{
        background-color: black;
        color: white;
        padding-top: 5vw;
        padding-bottom: 5vw;
        padding-left: 5vw;
        padding-right: 5vw;
        width: 50vw;
        font-size: 4vw;
        clip-path: polygon(15% 5%, 85% 5%, 100% 50%, 85% 95%, 15% 95%, 0% 50%);
    }

/**************************/
/* || Recruiting Syles */
.headline_recruiting{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 5%;
  position: relative;
  margin-bottom: 15vw;
}

.headline_recruiting img{
  width: 60vw;
  border-radius: 999px 999px 0 0;
  z-index: 1;
  position: relative;
}

.sign_up{
  width: 15vw;
  height: 15vw;
  background-color: #33f18a;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 999px;
  position: absolute;
  top: 24vw;
  z-index: 5;
}

.sign_up a{
  text-decoration: none;
  font-family: 'Work Sans', sans-serif;
  font-size: 2vw;
  color: black;
  width: 190px;
}


@media only screen and (max-width: 1150px){
    .shipping-options-more-info{
        font-size: .9em;
    }

    .pricing-contact-form input{
        padding: .25em;
        font-size: .5em;
    }

    .pricing-contact-form textarea{
        padding: .25em;
        font-size: .5em;
    }

    .pricing-contact-form button{
        padding: .5em;
        font-size: .5em;
    }
}


@media only screen and (max-width: 500px){
    .card-one, .card-two, .card-three, .card-four, .card-five{
        min-height: 94vw !important;
    }

    .text-container-lrex-inner-two{
        margin-top: 5%;
    }

    .text-container-inner ul{
        font-size: 3.75vw !important;
    }
}


@media only screen and (max-width: 1000px){
    .circle {
        height: 7vw;
        width: 7vw;
    }

    .header-container h1{
        font-size: 8vw;
    }

    .header-container{
        margin-top: 10%;
    }

    .card-container{
        margin-bottom: 10%;
    }

    .text-container{
        font-size: 4vw;
    } 

    .text-container-inner{
        width: 85%;
    }

    .text-container-inner-tech{
        width: 95%;
    }

    .main-button-blue-white{
        font-size: 3vw;
    }

    .card-one, .card-two{
        width: 75%;
        min-height: 90vw;
    }

    .shipping-options-more-info{
        font-size: 4vw;
    }

    .text-container-inner ul{
        font-size: 3.25vw;
    }

    .card-three, .card-four, .card-five{
        width: 75%;
        min-height: 85vw;
    }

    .header-container-lrex-inner-back h2, .header-container-lrex-inner h2{
        font-size: 4vw;
    }

    .text-container-lrex-inner-back, .text-container-lrex-inner, .text-container-lrex-inner-two{
        font-size: 2vw;
    }

    .shape-one h2,.shape-two h2,.shape-three h2{
        font-size: 4.5vw;
    }

/**************************************/
/* || Slider Syles */

.imageSliderContainer h1{
  margin-bottom: -1vh;
  font-size: 7vw;
  font-family: 'Work Sans', sans-serif;
  color: black;
}

.logo_arrow_right{
  width: 20px;
  height: 20px;
  border-right: 5px solid #33f18a;
  border-top: 5px solid #33f18a;
  border-radius: 5px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
  cursor: pointer;
  margin-left: -5vw;
}

.logo_arrow_left{
  width: 20px;
  height: 20px;
  border-right: 5px solid #33f18a;
  border-top: 5px solid #33f18a;
  border-radius: 5px;
  -webkit-transform: rotate(-135deg);
  transform: rotate(-135deg);
  cursor: pointer;
  margin-right: -5vw;
}
/**************************/
/* || Header Syles */
  .nav_links li{
        padding: 0px 10px;
        margin-right: auto;
    }

/**************************/
/* || Shipment Tracking Syles */
  .ship_with_us{
    margin-top: 10vh;
    height: 38vh;
    overflow: hidden;
    padding-top: 10vw;
  }

  .ship_with_us h1{
    font-size: 5vw;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.534);
  }

  .ship_with_us p{
    font-size: 3vw;
    text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.534);
  }

  .ship_with_us img{
    object-fit: cover;
    object-position: 40%;
    height: 40vh;
  }

  .ship_with_us_layout{
        right: 1vw;
        margin-bottom: 15vw;
        margin-right: 3vw;
    }

    .ship_with_us_layout button{
        font-size: 4vw;
        width: 40vw;
    }

.svg-wrapper {
  height: 6em; 
}

/**************************/
/* || Industry Solutions Syles */
.shipping-options{
    margin-top: 15%;
}

.shipping-options h1{
    font-size: 8vw;
}

.next-day-container div, .shipping-options-inner div, .same-day-container div, .zip-ship-container div, .priority-today-container div{
    font-size: 7vw;
}

.next-day-container p, .shipping-options-inner p, .same-day-container p, .zip-ship-container p, .priority-today-container p{
    font-size: 4vw;
    width: 80vw;
}
/**************************/
/* || Recruiting Syles */
.headline_recruiting{
    margin-bottom: 8vw;
}

.sign_up{
  top: 22vw;
  width: 18vw;
  height: 18vw;
}

.sign_up a{
  font-size: 4vw;
  width: 10vw;
}
  
}

@media only screen and (max-width: 950px){
/**************************/
/* || Shipment Tracking Syles */
  .form_shiptrack{
        right: 15vw;
    }
}
</style>
